function makeSection(id, title, blocks) {
  return { id: id, title: title, blocks: blocks || [] }
}

function p(text) {
  return { type: 'paragraph', text: text }
}

function table(columns, rows) {
  return { type: 'table', columns: columns, rows: rows, variant: 'overview' }
}

function bullets(items) {
  return { type: 'bullets', items: items }
}

function tip(title, text) {
  return { type: 'tip', title: title, text: text }
}

function faqItem(question, answer) {
  return { type: 'faq-item', question: question, answer: answer }
}

function stepsBlock() {
  return { type: 'steps' }
}

function prosConsBlock() {
  return { type: 'pros-cons' }
}

function links(title, items) {
  return { type: 'links', title: title, items: items || [] }
}

function gallery(imageKeys, caption, cols, fit, ratio) {
  var items = (imageKeys || []).map(function (key) {
    return { imageKey: key }
  })
  return {
    type: 'gallery',
    items: items,
    caption: caption || '',
    cols: cols || items.length || 2,
    fit: fit || 'contain',
    ratio: ratio || 'portrait'
  }
}

function scenarioItem(title, text) {
  return { type: 'scenario-item', title: title, text: text }
}

function buildIntentSection(L) {
  var blocks = [p(L.scenarioIntro || '')]
  ;(L.scenarios || []).forEach(function (item) {
    blocks.push(scenarioItem(item.title, item.text))
  })
  return makeSection('search-intents', L.sec.intentsTitle || L.sec.faqTitle, blocks)
}

function insertBeforeLast(rows, extras) {
  extras = extras || []
  rows = rows || []
  if (!extras.length) return rows.slice()
  if (!rows.length) return extras.slice()
  return rows.slice(0, -1).concat(extras).concat([rows[rows.length - 1]])
}

function prependRows(rows, extras) {
  return (extras || []).concat(rows || [])
}

function buildBgBody(L) {
  var tldrRows = insertBeforeLast(L.sec.tldrRows || [], L.sec.tldrExtraRows || [])
  var troubleRows = (L.sec.troubleRows || []).concat(L.sec.troubleExtraRows || [])
  var whatBlocks = [p(L.sec.whatP1), p(L.sec.whatP2)]
  if (L.sec.galleryCaption) {
    whatBlocks.push(gallery(['background-remover-before', 'background-remover-after'], L.sec.galleryCaption, 2, 'contain', 'portrait'))
  }
  whatBlocks.push(tip(L.sec.whatTipTitle, L.sec.whatTipText))
  var howBlocks = [p(L.sec.howP), stepsBlock()]
  if (L.sec.howTipTitle) howBlocks.push(tip(L.sec.howTipTitle, L.sec.howTipText))
  var troubleBlocks = [table(L.sec.troubleCols, troubleRows)]
  if (L.sec.troubleTipTitle) troubleBlocks.push(tip(L.sec.troubleTipTitle, L.sec.troubleTipText))
  return {
    overview: L.overview,
    practice: L.practice,
    compareIntro: L.compareIntro,
    workflow: L.workflow,
    scenarioIntro: L.scenarioIntro,
    sections: [
      makeSection('tldr', L.sec.tldrTitle, [
        table(L.sec.tldrCols, tldrRows),
        p(L.sec.tldrP)
      ]),
      makeSection('what-it-does', L.sec.whatTitle, whatBlocks),
      makeSection('how-to-use', L.sec.howTitle, howBlocks),
      makeSection('edge-check', L.sec.edgeTitle, [
        table(L.sec.edgeCols, L.sec.edgeRows),
        p(L.sec.edgeP)
      ]),
      makeSection('background-types', L.sec.bgTitle, [
        table(L.sec.bgCols, L.sec.bgRows),
        p(L.sec.bgP)
      ]),
      makeSection('troubleshooting', L.sec.troubleTitle, troubleBlocks),
      makeSection('pros-cons', L.sec.prosConsTitle, [prosConsBlock()]),
      makeSection('best-practices', L.sec.bestTitle, [
        bullets(L.sec.bestItems)
      ]),
      makeSection('miral-workflow', L.sec.miralTitle, [
        p(L.sec.miralP),
        links(L.sec.miralLinksTitle, L.sec.miralLinks)
      ]),
      buildIntentSection(L),
      makeSection('faq', L.sec.faqTitle, L.sec.faqItems.map(function (item) {
        return faqItem(item[0], item[1])
      }))
    ],
    linksTitle: L.linksTitle,
    linksIntro: L.linksIntro,
    links: L.links,
    steps: L.steps,
    pros: L.pros,
    cons: L.cons,
    tips: L.tips,
    scenarios: L.scenarios,
    toolFaq: L.toolFaq
  }
}

function buildEcomBody(L) {
  var tldrRows = prependRows(L.sec.tldrRows || [], L.sec.tldrExtraRows || [])
  var platRows = (L.sec.platRows || []).concat(L.sec.platExtraRows || [])
  var workflowBlocks = [p(L.sec.workflowP1)]
  if (L.sec.galleryCaption) {
    workflowBlocks.push(gallery(['ecommerce-background-remover-before', 'ecommerce-background-remover-after'], L.sec.galleryCaption, 2, 'contain', 'portrait'))
  }
  if (L.sec.workflowP2) workflowBlocks.push(p(L.sec.workflowP2))
  workflowBlocks.push(stepsBlock())
  var platBlocks = [table(L.sec.platCols, platRows)]
  if (L.sec.platTipTitle) {
    platBlocks.push(tip(L.sec.platTipTitle, L.sec.platTipText || L.sec.platP))
  } else if (L.sec.platP) {
    platBlocks.push(p(L.sec.platP))
  }
  var caseBlocks = [table(L.sec.casesCols, L.sec.casesRows)]
  if (L.sec.casesP) caseBlocks.push(p(L.sec.casesP))
  var acceptBlocks = [bullets(L.sec.acceptItems)]
  if (L.sec.acceptTipTitle) {
    acceptBlocks.push(tip(L.sec.acceptTipTitle, L.sec.acceptTipText))
  }
  return {
    overview: L.overview,
    practice: L.practice,
    compareIntro: L.compareIntro,
    workflow: L.workflow,
    scenarioIntro: L.scenarioIntro,
    sections: [
      makeSection('tldr', L.sec.tldrTitle, [
        table(L.sec.tldrCols, tldrRows),
        p(L.sec.tldrP)
      ]),
      makeSection('workflow', L.sec.workflowTitle, workflowBlocks),
      makeSection('transparent-or-white', L.sec.transTitle, [
        p(L.sec.transP),
        tip(L.sec.transTipTitle, L.sec.transTipText)
      ]),
      makeSection('platforms', L.sec.platTitle, platBlocks),
      makeSection('quality-check', L.sec.qualityTitle, [
        bullets(L.sec.qualityItems)
      ]),
      makeSection('product-cases', L.sec.casesTitle, caseBlocks),
      makeSection('acceptance-checklist', L.sec.acceptTitle, acceptBlocks),
      makeSection('pros-cons', L.sec.prosConsTitle, [prosConsBlock()]),
      makeSection('miral-workflow', L.sec.miralTitle, [
        p(L.sec.miralP),
        links(L.sec.miralLinksTitle, L.sec.miralLinks)
      ]),
      buildIntentSection(L),
      makeSection('faq', L.sec.faqTitle, L.sec.faqItems.map(function (item) {
        return faqItem(item[0], item[1])
      }))
    ],
    linksTitle: L.linksTitle,
    linksIntro: L.linksIntro,
    links: L.links,
    steps: L.steps,
    pros: L.pros,
    cons: L.cons,
    tips: L.tips,
    scenarios: L.scenarios,
    toolFaq: L.toolFaq
  }
}

var STRUCT_EXTRAS = require('./backgroundRemoverExtras.js')

// Localize tool labels + English product names left from EN source packs.
// Longer replacements first.
var LOCALE_BRAND = {
  ja: {
    links: {
      '/tools/background-remover': 'Miral AI 背景除去',
      '/tools/image-enhancer': 'AI画像強化',
      '/tools/object-remover': 'AIオブジェクト除去',
      '/tools/watermark-remover': 'AI透かし除去'
    },
    replace: [
      ['Miral AI Background Remover', 'Miral AI 背景除去'],
      ['AI Background Remover', 'AI 背景除去'],
      ['AI Image Enhancer', 'AI画像強化'],
      ['AI Object Remover', 'AIオブジェクト除去'],
      ['AI Watermark Remover', 'AI透かし除去'],
      ['Background Remover', '背景除去'],
      ['Watermark Remover', '透かし除去'],
      ['Object Remover', 'オブジェクト除去']
    ]
  },
  ko: {
    links: {
      '/tools/background-remover': 'Miral AI 배경 제거',
      '/tools/image-enhancer': 'AI 이미지 향상',
      '/tools/object-remover': 'AI 오브젝트 제거',
      '/tools/watermark-remover': 'AI 워터마크 제거'
    },
    replace: [
      ['Miral AI Background Remover', 'Miral AI 배경 제거'],
      ['AI Background Remover', 'AI 배경 제거'],
      ['AI Image Enhancer', 'AI 이미지 향상'],
      ['AI Object Remover', 'AI 오브젝트 제거'],
      ['AI Watermark Remover', 'AI 워터마크 제거'],
      ['Background Remover', '배경 제거'],
      ['Watermark Remover', '워터마크 제거'],
      ['Object Remover', '오브젝트 제거']
    ]
  },
  fr: {
    links: {
      '/tools/background-remover': 'Suppression d’arrière-plan Miral AI',
      '/tools/image-enhancer': 'Amélioration d’image IA',
      '/tools/object-remover': 'Suppression d’objets IA',
      '/tools/watermark-remover': 'Suppression de filigrane IA'
    },
    replace: [
      ['Miral AI Background Remover', 'Suppression d’arrière-plan Miral AI'],
      ['AI Background Remover', 'Suppression d’arrière-plan IA'],
      ['AI Image Enhancer', 'Amélioration d’image IA'],
      ['AI Object Remover', 'Suppression d’objets IA'],
      ['AI Watermark Remover', 'Suppression de filigrane IA'],
      ['Background Remover', 'Suppression d’arrière-plan'],
      ['Watermark Remover', 'Suppression de filigrane'],
      ['Object Remover', 'Suppression d’objets']
    ]
  },
  es: {
    links: {
      '/tools/background-remover': 'Eliminador de fondo Miral AI',
      '/tools/image-enhancer': 'Mejorador de imágenes IA',
      '/tools/object-remover': 'Eliminador de objetos IA',
      '/tools/watermark-remover': 'Eliminar marca de agua con IA'
    },
    replace: [
      ['Miral AI Background Remover', 'Eliminador de fondo Miral AI'],
      ['AI Background Remover', 'Eliminador de fondo IA'],
      ['AI Image Enhancer', 'Mejorador de imágenes IA'],
      ['AI Object Remover', 'Eliminador de objetos IA'],
      ['AI Watermark Remover', 'Eliminar marca de agua con IA'],
      ['Background Remover', 'Eliminador de fondo'],
      ['Watermark Remover', 'Eliminador de marcas de agua'],
      ['Object Remover', 'Eliminador de objetos']
    ]
  },
  it: {
    links: {
      '/tools/background-remover': 'Rimozione sfondo Miral AI',
      '/tools/image-enhancer': 'Miglioramento immagini IA',
      '/tools/object-remover': 'Rimozione oggetti IA',
      '/tools/watermark-remover': 'Rimozione watermark IA'
    },
    replace: [
      ['Miral AI Background Remover', 'Rimozione sfondo Miral AI'],
      ['AI Background Remover', 'Rimozione sfondo IA'],
      ['AI Image Enhancer', 'Miglioramento immagini IA'],
      ['AI Object Remover', 'Rimozione oggetti IA'],
      ['AI Watermark Remover', 'Rimozione watermark IA'],
      ['Background Remover', 'Rimozione sfondo'],
      ['Watermark Remover', 'Rimozione watermark'],
      ['Object Remover', 'Rimozione oggetti']
    ]
  },
  de: {
    links: {
      '/tools/background-remover': 'Miral AI Hintergrundentferner',
      '/tools/image-enhancer': 'KI-Bildverbesserung',
      '/tools/object-remover': 'KI-Objektentferner',
      '/tools/watermark-remover': 'KI-Wasserzeichen entfernen'
    },
    replace: [
      ['Miral AI Background Remover', 'Miral AI Hintergrundentferner'],
      ['AI Background Remover', 'KI-Hintergrundentferner'],
      ['AI Image Enhancer', 'KI-Bildverbesserung'],
      ['AI Object Remover', 'KI-Objektentferner'],
      ['AI Watermark Remover', 'KI-Wasserzeichen entfernen'],
      ['Background Remover', 'Hintergrundentferner'],
      ['Watermark Remover', 'Wasserzeichenentferner'],
      ['Object Remover', 'Objektentferner']
    ]
  },
  pt: {
    links: {
      '/tools/background-remover': 'Removedor de fundo Miral AI',
      '/tools/image-enhancer': 'Aprimorador de imagens IA',
      '/tools/object-remover': 'Remover objetos com IA',
      '/tools/watermark-remover': 'Remover marca d’água com IA'
    },
    replace: [
      ['Miral AI Background Remover', 'Removedor de fundo Miral AI'],
      ['AI Background Remover', 'Removedor de fundo IA'],
      ['AI Image Enhancer', 'Aprimorador de imagens IA'],
      ['AI Object Remover', 'Remover objetos com IA'],
      ['AI Watermark Remover', 'Remover marca d’água com IA'],
      ['Background Remover', 'Removedor de fundo'],
      ['Watermark Remover', 'Removedor de marca d’água'],
      ['Object Remover', 'Removedor de objetos']
    ]
  },
  pl: {
    links: {
      '/tools/background-remover': 'Usuwanie tła Miral AI',
      '/tools/image-enhancer': 'Wyostrzanie obrazów AI',
      '/tools/object-remover': 'Usuwanie obiektów AI',
      '/tools/watermark-remover': 'Usuwanie znaków wodnych AI'
    },
    replace: [
      ['Miral AI Background Remover', 'Usuwanie tła Miral AI'],
      ['AI Background Remover', 'Usuwanie tła AI'],
      ['AI Image Enhancer', 'Wyostrzanie obrazów AI'],
      ['AI Object Remover', 'Usuwanie obiektów AI'],
      ['AI Watermark Remover', 'Usuwanie znaków wodnych AI'],
      ['Background Remover', 'Usuwanie tła'],
      ['Watermark Remover', 'Usuwanie znaków wodnych'],
      ['Object Remover', 'Usuwanie obiektów']
    ]
  },
  ar: {
    links: {
      '/tools/background-remover': 'أداة إزالة الخلفية من Miral AI',
      '/tools/image-enhancer': 'تحسين الصور بالذكاء الاصطناعي',
      '/tools/object-remover': 'إزالة الكائنات بالذكاء الاصطناعي',
      '/tools/watermark-remover': 'إزالة العلامة المائية بالذكاء الاصطناعي'
    },
    replace: [
      ['Miral AI Background Remover', 'أداة إزالة الخلفية من Miral AI'],
      ['AI Background Remover', 'أداة إزالة الخلفية بالذكاء الاصطناعي'],
      ['AI Image Enhancer', 'تحسين الصور بالذكاء الاصطناعي'],
      ['AI Object Remover', 'إزالة الكائنات بالذكاء الاصطناعي'],
      ['AI Watermark Remover', 'إزالة العلامة المائية بالذكاء الاصطناعي'],
      ['Background Remover', 'أداة إزالة الخلفية'],
      ['Watermark Remover', 'أداة إزالة العلامة المائية'],
      ['Object Remover', 'أداة إزالة الكائنات']
    ]
  }
}

function replaceBrandText(text, pairs) {
  var out = String(text || '')
  var i
  for (i = 0; i < pairs.length; i++) {
    out = out.split(pairs[i][0]).join(pairs[i][1])
  }
  return out
}

function localizeLinkList(items, linkMap) {
  return (items || []).map(function (item) {
    if (!item || !item.path) return item
    var nextLabel = linkMap[item.path]
    if (!nextLabel) return item
    return Object.assign({}, item, { label: nextLabel })
  })
}

function deepLocalizeBrand(value, brand) {
  if (!brand) return value
  if (typeof value === 'string') return replaceBrandText(value, brand.replace || [])
  if (Array.isArray(value)) {
    return value.map(function (item) {
      return deepLocalizeBrand(item, brand)
    })
  }
  if (!value || typeof value !== 'object') return value
  var out = {}
  Object.keys(value).forEach(function (key) {
    if (key === 'path') {
      out[key] = value[key]
      return
    }
    out[key] = deepLocalizeBrand(value[key], brand)
  })
  return out
}

function localizePack(pack, loc) {
  var brand = LOCALE_BRAND[loc]
  if (!brand || !pack) return pack
  var out = deepLocalizeBrand(pack, brand)
  if (brand.tldrTitle && out.sec) {
    out.sec = Object.assign({}, out.sec, { tldrTitle: brand.tldrTitle })
  }
  if (brand.links) {
    if (out.sec && out.sec.miralLinks) {
      out.sec = Object.assign({}, out.sec, {
        miralLinks: localizeLinkList(out.sec.miralLinks, brand.links)
      })
    }
    if (out.links) {
      out.links = localizeLinkList(out.links, brand.links)
    }
  }
  return out
}

function mergePack(base, extra) {
  extra = extra || {}
  var sec = Object.assign({}, base.sec, extra.sec || {})
  var out = Object.assign({}, base, extra, { sec: sec })
  if (extra.extraScenarios && extra.extraScenarios.length) {
    out.scenarios = (base.scenarios || []).concat(extra.extraScenarios)
  }
  return out
}

function withKeywords(articles, keywords) {
  var out = Object.assign({}, articles)
  Object.keys(keywords || {}).forEach(function (slug) {
    if (!out[slug]) return
    out[slug] = Object.assign({}, out[slug], { keywords: keywords[slug] })
  })
  return out
}

function localizeArticles(articles, loc) {
  var brand = LOCALE_BRAND[loc]
  if (!brand || !articles) return articles
  var out = {}
  Object.keys(articles).forEach(function (slug) {
    out[slug] = deepLocalizeBrand(articles[slug], brand)
  })
  return out
}

var HUB_CROSS_LINKS = {
  ja: [
    { label: '人物背景除去と証明写真', path: '/hub/articles/ai-portrait-background-remover' },
    { label: 'AI 背景差し替えガイド', path: '/hub/articles/ai-background-changer-online' }
  ],
  ko: [
    { label: '인물 배경 제거와 증명사진', path: '/hub/articles/ai-portrait-background-remover' },
    { label: 'AI 배경 바꾸기 가이드', path: '/hub/articles/ai-background-changer-online' }
  ],
  fr: [
    { label: 'Portrait et photo d’identité', path: '/hub/articles/ai-portrait-background-remover' },
    { label: 'Guide changement d’arrière-plan IA', path: '/hub/articles/ai-background-changer-online' }
  ],
  es: [
    { label: 'Retrato y foto tipo documento', path: '/hub/articles/ai-portrait-background-remover' },
    { label: 'Guía para cambiar fondo con IA', path: '/hub/articles/ai-background-changer-online' }
  ],
  it: [
    { label: 'Ritratto e foto documento', path: '/hub/articles/ai-portrait-background-remover' },
    { label: 'Guida cambio sfondo IA', path: '/hub/articles/ai-background-changer-online' }
  ],
  de: [
    { label: 'Porträt- und Ausweisfotos', path: '/hub/articles/ai-portrait-background-remover' },
    { label: 'KI-Hintergrundwechsel-Guide', path: '/hub/articles/ai-background-changer-online' }
  ],
  pt: [
    { label: 'Retrato e foto de documento', path: '/hub/articles/ai-portrait-background-remover' },
    { label: 'Guia de troca de fundo com IA', path: '/hub/articles/ai-background-changer-online' }
  ],
  pl: [
    { label: 'Portret i zdjęcie do dokumentów', path: '/hub/articles/ai-portrait-background-remover' },
    { label: 'Przewodnik wymiany tła AI', path: '/hub/articles/ai-background-changer-online' }
  ],
  ar: [
    { label: 'صور البورتريه والوثائق', path: '/hub/articles/ai-portrait-background-remover' },
    { label: 'دليل تغيير الخلفية بالذكاء الاصطناعي', path: '/hub/articles/ai-background-changer-online' }
  ]
}

function appendHubCrossLinks(body, loc) {
  var extras = HUB_CROSS_LINKS[loc] || []
  if (!body || !extras.length) return body
  function mergeList(list) {
    var paths = {}
    ;(list || []).forEach(function (item) {
      if (item && item.path) paths[item.path] = true
    })
    var next = (list || []).slice()
    extras.forEach(function (item) {
      if (!paths[item.path]) next.push(item)
    })
    return next
  }
  if (body.links) body.links = mergeList(body.links)
  ;(body.sections || []).forEach(function (section) {
    if (!section || section.id !== 'miral-workflow') return
    ;(section.blocks || []).forEach(function (block) {
      if (block && block.type === 'links') {
        block.items = mergeList(block.items)
      }
    })
  })
  return body
}

function buildLocale(bg, ecom, articles, loc) {
  var extra = STRUCT_EXTRAS[loc] || {}
  var bodies = {
    'ai-background-remover-online': buildBgBody(localizePack(mergePack(bg, extra.bg), loc)),
    'ecommerce-product-background-removal': buildEcomBody(localizePack(mergePack(ecom, extra.ecom), loc))
  }
  appendHubCrossLinks(bodies['ai-background-remover-online'], loc)
  appendHubCrossLinks(bodies['ecommerce-product-background-removal'], loc)
  return {
    bodies: bodies,
    articles: withKeywords(localizeArticles(articles, loc), extra.keywords)
  }
}

var jaBg = {
  overview: [
    "Miral AI Background Remover はサインイン後に無料で使えます。画像全体を解析し、前景の被写体を周囲から分離して、手描きマスクなしで背景を自動除去します。",
    "15 MB までの JPG、PNG、または WebP をアップロードし、髪・透明素材・小さな穴・低コントラストのエッジを確認したうえで、透明 PNG としてダウンロードします。",
    "透明 PNG はそのまま Miral AI のワークフローで強化、オブジェクト除去、新しい商品シーン作成に使えます。透明背景と白背景は別物です。マーケットプレイスが白背景を求める場合は、あとから白いレイヤーを追加してください。"
  ],
  practice: [
    "最も信頼できる素材は、被写体が欠けず、輪郭がシャープで、前景と背景のコントラストがはっきりした写真です。再圧縮されたスクリーンショットやブレは、細いディテールの分離を難しくします。",
    "結果は必ず暗いキャンバスと明るいキャンバスの両方で確認します。白ハロ、暗いフリンジ、取りこぼした隙間、消えた髪の毛など、デフォルトプレビューでは見えにくい問題が浮かび上がります。"
  ],
  compareIntro: "背景全体を自動で消したいときは AI Background Remover を使います。特定の不要なマークや物体だけを消したいときは Watermark Remover または Object Remover を使います。",
  workflow: "15 MB までの JPG、PNG、または WebP を 1 枚アップロードし、AI に前景を自動検出させ、細かいエッジを確認してから透明 PNG をダウンロードします。",
  scenarioIntro: "元画像に最も近いシナリオを選び、その被写体で特に重要な自動検出エッジを確認してください。",
  sec: {
    tldrTitle: "短い答え",
    tldrCols: [
      "知っておくこと",
      "詳細"
    ],
    tldrRows: [
      [
        "料金",
        "サインイン後に無料で利用可能"
      ],
      [
        "アップロード",
        "JPG、PNG、または WebP 画像 1 枚（最大 15 MB）"
      ],
      [
        "処理",
        "被写体を自動検出。輪郭やマスクの手描きは不要"
      ],
      [
        "ダウンロード",
        "透明 PNG"
      ],
      [
        "確認すべき点",
        "髪、ガラス、毛皮、細い隙間、低コントラストのエッジ"
      ]
    ],
    tldrP: "素直なポートレートや商品写真なら、作業はだいたいアップロード、待機、確認、ダウンロードです。確認が重要です。小さなプレビューでは問題なさそうでも、暗いデザインに載せると薄い縁が見えることがあります。",
    whatTitle: "リムーバーが実際に行うこと",
    whatP1: "Miral AI Background Remover は画像全体を読み取り、どのピクセルが前景かを判断します。ペンツールで被写体をなぞるよりはるかに速く、処理前に選択を正確に取る必要もありません。",
    whatP2: "結果は透明付きの PNG であり、白く塗りつぶした JPG ではありません。白の商品カード、ブランドカラー、まったく新しいシーンのどれにも、被写体を再度切り抜かずに載せられます。",
    whatTipTitle: "役立つ区別",
    whatTipText: "透明と白は互換ではありません。透明はキャンバスを開いたままにし、白背景は白いピクセルで永久に埋めます。",
    howTitle: "シンプルな 4 ステップのワークフロー",
    howP: "可能ならオリジナルファイルから始めます。メッセージアプリ経由のスクリーンショットはエッジが柔らかくなりやすく、ふんわりした髪や透明素材の分離が難しくなります。",
    edgeTitle: "ダウンロード前に見るべきところ",
    edgeCols: [
      "画像",
      "特に見る点",
      "理由"
    ],
    edgeRows: [
      [
        "ポートレート",
        "ゆるい髪、メガネ、イヤリング",
        "細いディテールは削られやすい"
      ],
      [
        "商品",
        "持ち手、穴、コード、靴ひも",
        "閉じた隙間に背景が残ることがある"
      ],
      [
        "ガラスや透明包装",
        "反射と半透明のエッジ",
        "元の背景が物体越しに見える"
      ],
      [
        "ロゴや署名",
        "細い線とカウンター（すき間）",
        "小さなすき間がふさがることがある"
      ],
      [
        "ペット",
        "毛皮とひげ",
        "サムネイルでは欠けた毛が見えにくい"
      ]
    ],
    edgeP: "ダウンロードした PNG を明るいキャンバスと暗いキャンバスの両方に置くのがおすすめです。薄いハロも暗いフリンジも一気に見え、チェッカーボードのプレビューだけより確実です。",
    bgTitle: "透明、白、それとも差し替え背景？",
    bgCols: [
      "結果",
      "含まれるもの",
      "向いている用途"
    ],
    bgRows: [
      [
        "透明背景",
        "固定の背景色なし。PNG で保存",
        "ロゴ、プロフィール画像、デザイン素材、再利用可能な商品切り抜き"
      ],
      [
        "白背景",
        "切り抜きの下に白いレイヤー",
        "商品リスティング、証明写真、白が必要なレイアウト"
      ],
      [
        "ブランドカラー背景",
        "被写体の下に単色またはグラデーション",
        "キャンペーングラフィック、プロフィールカード、ブランドビジュアル"
      ],
      [
        "新しいシーン",
        "別の環境に切り抜きを配置",
        "商品ライフスタイル画像とクリエイティブ合成"
      ]
    ],
    bgP: "まず透明 PNG を残し、白やカラー版はそのあと作ります。JPG は透明ピクセルを保存できないので、再利用可能なマスターには不向きです。",
    troubleTitle: "切り抜きがおかしいとき",
    troubleCols: [
      "問題",
      "想定される原因",
      "試すこと"
    ],
    troubleRows: [
      [
        "白または暗い縁",
        "旧背景の色がエッジに残っている",
        "よりシャープでコントラストの強い素材で再試行"
      ],
      [
        "髪やひげが消える",
        "素材が小さい、ぼやけている、または強く圧縮されている",
        "オリジナル写真を使い、実寸で確認"
      ],
      [
        "持ち手の中に背景が残る",
        "閉じた隙間が被写体の一部と読まれた",
        "隙間がより見える角度の写真を試す"
      ],
      [
        "ガラスが不完全",
        "透明部分に旧シーンの色が含まれる",
        "背景をすっきりさせ、結果を手動で確認"
      ],
      [
        "白地に白のエッジが消える",
        "前景と背景が似すぎている",
        "コントラストのある写真を選ぶ"
      ]
    ],
    prosConsTitle: "役立つ点—そして判断が必要な点",
    bestTitle: "結果を良くする習慣",
    bestItems: [
      "チャットアプリから保存したサムネイルより、オリジナル写真を使う。",
      "被写体全体が見えてピントが合っている画像を選ぶ。",
      "被写体が背景に溶け込む場合は、コントラストがはっきりした別の写真を試す。",
      "使う前に、明るいキャンバスと暗いキャンバスの両方で PNG を確認する。",
      "白い商品は暗いキャンバスで確認する。残留がはるかに見えやすい。",
      "重要な画像は 1 枚ずつ進め、エッジをきちんと確認する。"
    ],
    miralTitle: "Miral AI で作業を続ける",
    miralP: "背景がなくなった透明 PNG は便利なマスターファイルです。シャープにし、余分な物体を消し、権限のある透かしを消し、商品を新しい商用シーンに変えられます。",
    miralLinksTitle: "次のステップ",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "AI Object Remover",
        path: "/tools/object-remover"
      },
      {
        label: "AI Watermark Remover",
        path: "/tools/watermark-remover"
      },
      {
        label: "EC 商品背景ガイド",
        path: "/hub/articles/ecommerce-product-background-removal"
      },
      {
        label: "Seedream 5",
        path: "/image-models/seedream-ai-image-generator"
      }
    ],
    faqTitle: "実務でよく出る質問",
    faqItems: [
      [
        "オンラインで画像背景を透明にするには？",
        "JPG、PNG、または WebP をアップロードし、自動背景除去を待ち、透明 PNG をダウンロードします。"
      ],
      [
        "Miral AI Background Remover は無料ですか？",
        "はい。サインインして画像をアップロードし、背景除去機能を無料で使えます。追加のデスクトップソフトは不要です。"
      ],
      [
        "サインインは必要ですか？",
        "はい。アップロード前にサインインが必要ですが、背景除去機能自体は無料です。"
      ],
      [
        "被写体の輪郭を描く必要がありますか？",
        "いいえ。ツールが画像全体の前景を自動検出します。"
      ],
      [
        "ダウンロードが PNG なのはなぜ？",
        "PNG は透明ピクセルを保てます。JPG はできません。"
      ],
      [
        "背景除去で画像サイズは変わりますか？",
        "公開前に、ダウンロードしたピクセル寸法を最終レイアウトと照合してください。特にマーケットプレイスやテンプレートに固定サイズがある場合。"
      ],
      [
        "切り抜き周りの白ハロはどう直す？",
        "暗いキャンバスで PNG を確認し、よりシャープでコントラストの強い素材で再試行します。"
      ],
      [
        "髪やペットの毛皮に対応できますか？",
        "できますが、細い毛は明るい背景と暗い背景の両方で実寸確認が必要です。"
      ],
      [
        "AI 背景除去と背景消しゴムの違いは？",
        "AI 背景除去は被写体を自動で見つけます。従来の背景消しゴムは、通常手で領域を消します。"
      ],
      [
        "白い被写体が白背景で消えるのはなぜ？",
        "エッジのコントラストがほとんどありません。より暗い、またははっきりした背景の写真のほうが境界が明確です。"
      ],
      [
        "ガラス商品の一部が欠けるのはなぜ？",
        "ガラスは旧背景を反射・透過するため境界が曖昧です。コントラストのある背景のシャープな写真のほうがモデルに有利です。"
      ],
      [
        "何をアップロードできますか？",
        "各 15 MB までの JPG、PNG、WebP。ページは一度に 1 枚処理します。"
      ]
    ]
  },
  linksTitle: "Miral AI でワークフローを続ける",
  linksIntro: "背景除去のあと、透明 PNG を他の Miral AI ツールで使うか、次のステップ向けのガイドに進みます。",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "AI Object Remover",
      path: "/tools/object-remover"
    },
    {
      label: "AI Watermark Remover",
      path: "/tools/watermark-remover"
    },
    {
      label: "EC 商品背景ガイド",
      path: "/hub/articles/ecommerce-product-background-removal"
    },
    {
      label: "Seedream 5",
      path: "/image-models/seedream-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "オリジナル画像をアップロード",
      text: "15 MB 以下の JPG、PNG、または WebP を 1 つ選びます。"
    },
    {
      title: "AI に被写体を見つけさせる",
      text: "Miral が背景全体を自動除去します。輪郭やマスクの手描きは不要です。"
    },
    {
      title: "難しいエッジを確認",
      text: "髪、メガネ、透明素材、商品の穴など細かい部分を拡大します。"
    },
    {
      title: "透明 PNG をダウンロード",
      text: "再利用可能な切り抜きとして保存し、最終キャンバスに配置します。"
    }
  ],
  pros: [
    "手動アウトライン不要の自動被写体検出",
    "JPG、PNG、WebP 入力に対応",
    "再利用可能な透明 PNG をダウンロード",
    "ポートレート、商品、ロゴ、署名、ペットに有用"
  ],
  cons: [
    "髪と透明物体は目視確認が必要",
    "被写体と背景の低コントラストはエッジ品質を下げうる",
    "現在のページは一度に 1 枚処理",
    "15 MB 超のファイルは先に縮小が必要"
  ],
  tips: [
    {
      title: "背景色を 2 つで確認",
      text: "透明 PNG を暗い背景と明るい背景の両方に置き、ハロと欠けたエッジを見つけます。"
    },
    {
      title: "最もクリアな素材を使う",
      text: "何度も圧縮された小さなスクリーンショットより、大きくシャープなオリジナルのほうが通常うまくいきます。"
    },
    {
      title: "細かいディテールを守る",
      text: "髪、ひげ、ジュエリーチェーン、靴ひも、メガネ、商品持ち手の内側の隙間を拡大確認します。"
    },
    {
      title: "白または暗いハロを直す",
      text: "ハロは多くの場合、元のエッジの色汚染です。よりシャープで前景と背景のコントラストが強い素材で再試行します。"
    },
    {
      title: "透明素材を確認",
      text: "ガラスや透明包装は旧背景が透けるため、白と暗いキャンバスの両方で比較します。"
    }
  ],
  scenarios: [
    {
      title: "ポートレート背景除去",
      text: "プロフィール画像やポスターに使う前に、ゆるい髪、イヤリング、メガネを確認します。"
    },
    {
      title: "商品背景除去",
      text: "持ち手、穴、コード、反射エッジ、透明包装を点検します。"
    },
    {
      title: "ロゴや署名の背景除去",
      text: "細い線と内部の切り抜きが保たれるよう、高解像度の素材を使います。"
    },
    {
      title: "ペット写真の背景除去",
      text: "コントラストの強いシンプルな背景を選び、毛皮とひげを実寸で確認します。"
    }
  ],
  toolFaq: [
    {
      q: "オンラインで画像背景を除去するには？",
      a: "JPG、PNG、または WebP をアップロードし、AI に背景を自動検出・除去させ、透明 PNG をダウンロードします。"
    },
    {
      q: "人物や商品を手動で選択する必要がありますか？",
      a: "いいえ。Background Remover が画像全体を解析し、前景を自動検出します。"
    },
    {
      q: "結果が PNG でダウンロードされるのはなぜ？",
      a: "PNG は透明をサポートします。JPG は透明背景を保てません。"
    },
    {
      q: "背景除去後の白ハロはどう直す？",
      a: "まず暗いキャンバスで結果を確認し、被写体と背景のコントラストがよりはっきりしたシャープな素材で再試行します。"
    },
    {
      q: "AI は髪やペットの毛皮周りも除去できますか？",
      a: "はい。ただし細い髪、ひげ、毛皮は難しいエッジなので、必ず実寸で確認してください。"
    },
    {
      q: "透明、白、差し替え背景の違いは？",
      a: "透明 PNG には固定背景がありません。白背景画像は白いピクセルを含み、差し替え背景は切り抜きを新しいシーンや色に置きます。"
    },
    {
      q: "ガラス物体の一部が欠けるのはなぜ？",
      a: "透明物体には元背景の色が含まれます。よりクリアでコントラストの高い素材で再試し、透明部分を手動確認します。"
    },
    {
      q: "Background Remover の利用にサインインは必要ですか？",
      a: "はい。画像のアップロードと処理の前にサインインしてください。"
    },
    {
      q: "Miral AI Background Remover は無料ですか？",
      a: "はい。サインイン後、背景除去機能は無料で使え、追加ソフトのインストールは不要です。"
    },
    {
      q: "対応フォーマットとファイルサイズは？",
      a: "各 15 MB までの JPG、PNG、WebP を受け付けます。"
    }
  ]
}

var jaEcom = {
  overview: [
    "EC 用途では、Miral AI Background Remover はサインイン後に無料です。きれいな透明 PNG マスターを 1 枚作り、同じ切り抜きから白背景・ブランドカラー・バナー・ライフスタイル版を作ります。",
    "JPG、PNG、または WebP（最大 15 MB）をアップロードすると、Miral AI Background Remover が商品を自動検出します。手動マスクは不要です。公開前に持ち手、チェーン、靴ひも、透明包装、ガラス、毛皮、反射金属を確認してください。",
    "Amazon、Shopify、eBay、Etsy、Google Shopping などは画像ルールが異なり、変わることもあります。背景除去は素材を整えますが、マーケットプレイス準拠を自動保証はしません。対象チャネルとカテゴリの現行要件を確認してください。"
  ],
  practice: [
    "私の推奨フローは、商品原写真 → 自動背景除去 → エッジ確認 → 透明 PNG マスター → そのあとチャネル別レイアウトです。店頭ごとに切り抜きを繰り返さずに済みます。",
    "純白画像なら透明 PNG を白キャンバスに置きます。Shopify バナーやソーシャル広告なら、同じ切り抜きをブランドカラーに載せるか、Seedream や FLUX でライフスタイルシーンに続けます。"
  ],
  compareIntro: "透明商品マスターを作るには Background Remover を使い、マーケットプレイス掲載用に白キャンバスを足すか、ライフスタイル画像は Seedream と FLUX で続けます。",
  workflow: "15 MB までのクリアな商品画像を 1 枚アップロードし、AI に背景全体を自動除去させ、商品エッジを確認して透明 PNG マスターをダウンロードします。",
  scenarioIntro: "商品に最も近い EC シナリオを選び、チャネル別レイアウトを作る前に自動検出された商品エッジを確認してください。",
  sec: {
    tldrTitle: "推奨ワークフロー",
    tldrCols: [
      "段階",
      "残すもの",
      "確認"
    ],
    tldrRows: [
      [
        "背景を除去",
        "透明 PNG マスター",
        "エッジ、穴、細かい部品、透明素材"
      ],
      [
        "白版を作る",
        "別のフラット化した書き出し",
        "余白と現行のマーケットプレイスルール"
      ],
      [
        "ブランド版を作る",
        "カード、バナー、広告用ファイル",
        "商品色、形状、ロゴ、包装テキスト"
      ],
      [
        "マスターを保管",
        "確認済み透明 PNG",
        "チャネル固有背景で上書きしない"
      ]
    ],
    tldrP: "Miral AI Background Remover はサインイン後無料です。背景は一度だけ除去し、その透明マスターを残して、白・ブランド・ライフスタイル版はすべてそこから作ります。店頭ごとに同じ商品を切り抜くよりきれいです。",
    workflowTitle: "原写真から再利用可能な商品切り抜きへ",
    workflowP1: "商品全体が見えてピントが合った写真を選びます。Miral AI Background Remover にアップロードし、ツールに商品を自動検出させ、PNG をダウンロードする前に結果を確認します。",
    workflowP2: "最後の確認は飛ばしがちです。持ち手、ポート、靴ひも、チェーン、透明包装、旧背景が透けて見えるべき隙間を見てください。新しいキャンバスで自然に見えるかどうかはそこで決まります。",
    transTitle: "なぜ先に透明版を残すか",
    transP: "透明 PNG は柔軟なアセットです。今日は純白のマーケットプレイスキャンバス、明日は Shopify ブランドカード、来月は季節バナーにも置けます。白版だけ保存すると、新しい背景のたびにまたクリーンアップが必要になります。",
    transTipTitle: "レイヤーを分けておく",
    transTipText: "透明マスターを保管し、チャネル版は別ファイルで書き出します。修正がはるかに楽になります。",
    platTitle: "1 つのマスター、複数の店頭",
    platCols: [
      "チャネル",
      "典型的な用途",
      "実務メモ"
    ],
    platRows: [
      [
        "Amazon",
        "メインおよび補助商品画像",
        "必要なときだけ白を足し、現行カテゴリポリシーを確認"
      ],
      [
        "Shopify",
        "商品カード、コレクションページ、バナー",
        "透明はテーマカラーとレスポンシブレイアウトと相性が良い"
      ],
      [
        "eBay",
        "リスティングカバーとギャラリー",
        "商品シルエット周りの残留を確認"
      ],
      [
        "Etsy",
        "ハンドメイド商品のカバーと詳細",
        "素材と手作りディテールを誠実に保つ"
      ],
      [
        "Google Shopping",
        "商品広告アセット",
        "ランディングページの商品と一致させ、現行広告ルールを確認"
      ]
    ],
    platP: "マーケットプレイスルールは変わり、同じマーケット内でもカテゴリで異なります。背景除去はファイルを整えるだけで、特定リスティング向けの最終画像を認証するものではありません。",
    qualityTitle: "間違えやすい商品",
    qualityItems: [
      "ガラス、クリスタル、透明包装は透明領域が失われやすい。",
      "ジュエリーチェーン、靴ひも、メッシュはばらばらに切れやすい。",
      "白地に白、暗地に暗い商品はエッジコントラストが弱い。",
      "フリース、毛皮、柔らかいテキスタイルは明暗両方の背景で確認が必要。",
      "反射金属は元の周囲の色を残すことがある。"
    ],
    casesTitle: "特に注意が必要な商品",
    casesCols: [
      "商品",
      "よくある失敗",
      "確認"
    ],
    casesRows: [
      [
        "衣類と靴",
        "ほつれた生地、靴ひも、メッシュが消える",
        "輪郭と交差する靴ひもをすべて追う"
      ],
      [
        "ジュエリー",
        "チェーンが切れたり小さな開口が埋まる",
        "リンク、爪、フック、ネガティブスペースを拡大"
      ],
      [
        "ガラスと透明包装",
        "透明領域が塗りつぶされるか不完全になる",
        "白と暗い背景の両方で確認"
      ],
      [
        "ビューティー包装",
        "ポンプの隙間や透明ボトルのディテールが失われる",
        "ラベル、キャップのエッジ、本物の商品色を守る"
      ],
      [
        "電子機器",
        "ポート、ケーブル、反射エッジが変わる",
        "付属部品とコネクタをすべて確認"
      ],
      [
        "家具",
        "脚のあいだの空間が残る",
        "外側のエッジと同様に内側の隙間も点検"
      ]
    ],
    acceptTitle: "公開前チェック",
    acceptItems: [
      "薄いハロ、暗いフリンジ、ギザギザ、旧背景のパッチがない。",
      "持ち手、穴、チェーン、靴ひも、メッシュなど内部空間が開いているべきところが開いている。",
      "ガラス、透明プラスチック、毛皮、反射金属が本物の素材に見える。",
      "色、ロゴ、包装テキスト、ポート、アクセサリが元商品と一致する。",
      "透明マスターが白・ライフスタイル書き出しと別に保存されている。",
      "最終のクロップ、余白、背景、内容がマーケットプレイスの現行ルールに沿っている。"
    ],
    prosConsTitle: "このワークフローが解決すること",
    miralTitle: "残りは Miral AI で作る",
    miralP: "切り抜きが確認を通ったら、画像強化や新しい商用シーンに進めます。進むにつれ商品の同一性を確認し続けてください。ボトル形状や靴の色、パッケージラベルが変われば、きれいな背景も役に立ちません。",
    miralLinksTitle: "次のステップ",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "一般向け AI 背景除去ガイド",
        path: "/hub/articles/ai-background-remover-online"
      },
      {
        label: "Seedream 5 商品画像",
        path: "/image-models/seedream-ai-image-generator"
      },
      {
        label: "FLUX.2 商品撮影",
        path: "/image-models/flux-2-ai-image-generator"
      },
      {
        label: "GPT Image テキストポスター",
        path: "/image-models/gpt-image-ai-image-generator"
      }
    ],
    faqTitle: "よくある EC の質問",
    faqItems: [
      [
        "Miral AI の商品背景除去は無料ですか？",
        "はい。サインインして背景リムーバーを無料で使い、透明 PNG をダウンロードできます。"
      ],
      [
        "Amazon 用の白背景画像はどう作る？",
        "元背景を除去し、透明 PNG を残し、純白キャンバスにコピーを置き、そのカテゴリの現行要件を確認します。"
      ],
      [
        "Shopify 商品画像は白背景必須ですか？",
        "必ずしもそうではありません。テーマ付き商品カードやバナーには透明が便利なことが多いですが、最終判断はストアデザイン次第です。"
      ],
      [
        "透明と白の商品背景の違いは？",
        "透明 PNG には固定背景がありません。白背景画像はすでに白いピクセルを含み、下のキャンバスを見せられません。"
      ],
      [
        "カタログ全体を一度に処理できますか？",
        "現在のページは一度に 1 枚です。"
      ],
      [
        "ガラス商品が不完全に見えるのはなぜ？",
        "ガラスと透明包装には旧背景の色が含まれます。コントラストがはっきりしたシャープな素材を試し、透明領域を手動確認してください。"
      ],
      [
        "商品周りの白い縁はどう直す？",
        "暗いキャンバスで PNG を見て縁を確認し、よりシャープでコントラストの強い素材で再試行します。"
      ],
      [
        "透明商品画像はどう保存すべき？",
        "固定背景なしの透明 PNG マスターを 1 つ残し、そこから白・ブランド・ライフスタイル版を別途書き出します。"
      ],
      [
        "1 枚をすべてのマーケットプレイスで使えますか？",
        "透明マスターは再利用し、最終のクロップ、余白、背景はチャネルとカテゴリごとに別書き出します。"
      ],
      [
        "切り抜きをライフスタイル画像にできますか？",
        "はい。透明 PNG を Seedream または FLUX で続け、商品の形状・色・ロゴ・包装が正確か確認します。"
      ]
    ]
  },
  linksTitle: "Miral AI で商品画像ワークフローを構築",
  linksIntro: "透明商品マスターを 1 つ残し、強化、商用シーン生成、テキスト主導のプロモデザインを Miral AI で続けます。",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "一般向け AI 背景除去ガイド",
      path: "/hub/articles/ai-background-remover-online"
    },
    {
      label: "Seedream 5 商品画像",
      path: "/image-models/seedream-ai-image-generator"
    },
    {
      label: "FLUX.2 商品撮影",
      path: "/image-models/flux-2-ai-image-generator"
    },
    {
      label: "GPT Image テキストポスター",
      path: "/image-models/gpt-image-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "クリアな商品写真を選ぶ",
      text: "商品全体が見えてピントが合った、15 MB までの JPG、PNG、または WebP を使います。"
    },
    {
      title: "元の背景を除去",
      text: "Miral AI が商品を検出し、手動マスクなしで背景全体をクリアします。"
    },
    {
      title: "商品ディテールを確認",
      text: "内部の隙間、細かい部品、透明部分、毛皮、ガラス、反射エッジを点検します。"
    },
    {
      title: "透明マスターを保存",
      text: "マーケットプレイス固有の背景やレイアウトを足す前に PNG をダウンロードします。"
    },
    {
      title: "チャネル版を作成",
      text: "白またはブランドのキャンバスを追加し、行き先マーケットプレイスの現行要件を確認します。"
    }
  ],
  pros: [
    "1 つの透明マスターで複数の販売チャネルに対応",
    "自動商品検出で手動アウトラインの時間を節約",
    "店頭背景と余白の標準化がしやすい",
    "切り抜きを Seedream や FLUX のシーンに続けられる"
  ],
  cons: [
    "公開前にマーケットプレイス要件の確認が必要",
    "ガラス、毛皮、細いチェーン、反射素材は手動確認が必要",
    "背景除去は最終のマーケットプレイスサイズとレイアウトを行わない",
    "現在のツールは一度に 1 枚処理"
  ],
  tips: [
    {
      title: "除去とレイアウトを分ける",
      text: "透明 PNG マスターを残し、切り抜きを繰り返さずに白背景・ブランド派生を作ります。"
    },
    {
      title: "難しい素材を点検",
      text: "ガラス、透明包装、ジュエリーチェーン、毛皮、反射金属を最初に確認します。"
    },
    {
      title: "現行のマーケットプレイスルールを確認",
      text: "画像サイズ、背景、フレーミング、内容ポリシーは変わり、カテゴリで異なることがあります。"
    },
    {
      title: "商品受け入れチェックリストを使う",
      text: "公開前に輪郭、内部隙間、色、ロゴ、包装テキスト、ポート、アクセサリ、透明領域を確認します。"
    },
    {
      title: "透明マスターを 1 つ残す",
      text: "確認済み透明 PNG を別に保管し、白・ブランド・ライフスタイル版はすべてそのファイルから派生させます。"
    }
  ],
  scenarios: [
    {
      title: "Amazon 白背景商品画像",
      text: "確認済み透明 PNG を純白キャンバスに置き、現行カテゴリ要件を確認します。"
    },
    {
      title: "Shopify 商品カードとバナー",
      text: "レスポンシブカード、ブランドカラー、ホームページ構成で透明商品を再利用します。"
    },
    {
      title: "eBay と Etsy のリスティング画像",
      text: "商品を完全かつ誠実に保ち、アップロード前にエッジの背景残留を確認します。"
    },
    {
      title: "越境 EC クリエイティブ",
      text: "本物の商品形状・色・ブランディングを保ちつつ、1 つの透明 PNG マスターから複数チャネルサイズを作ります。"
    },
    {
      title: "Google Shopping 商品広告",
      text: "ランディングページと一致する商品を保ち、現行広告ルールに沿って透明マスターからアセットを作ります。"
    }
  ],
  toolFaq: [
    {
      q: "Miral AI の EC 商品背景除去は無料ですか？",
      a: "はい。サインインして背景除去機能を無料で使い、透明 PNG をダウンロードできます。"
    },
    {
      q: "Amazon 用の白背景商品画像はどう作る？",
      a: "元背景を除去し、透明 PNG をダウンロードし、純白キャンバスに置き、商品カテゴリの現行要件を確認します。"
    },
    {
      q: "Shopify 商品画像は白背景必須ですか？",
      a: "必ずしもそうではありません。透明 PNG はブランドカラーのカードやバナーに便利です。ストアテーマとレイアウトに合わせて最終背景を選びます。"
    },
    {
      q: "透明と白背景の違いは？",
      a: "透明画像には固定背景がなく、任意のキャンバスに置けます。白背景画像は白いピクセルを含みます。"
    },
    {
      q: "商品カタログ全体の背景を一度に除去できますか？",
      a: "現在の Background Remover ページは一度に 1 枚なので、この記事はバッチワークフローを主張しません。"
    },
    {
      q: "背景除去後にガラス商品が不完全なのはなぜ？",
      a: "透明と反射は分離が難しいです。よりシャープでコントラストの強い画像で再試し、結果を手動確認します。"
    },
    {
      q: "商品切り抜きの白ハロはどう直す？",
      a: "透明 PNG を暗いキャンバスに置いてハロを特定し、より高解像度でエッジコントラストの強い素材で再試行します。"
    },
    {
      q: "商品切り抜きを公開前に何を確認すべき？",
      a: "実寸で輪郭、穴、チェーン、靴ひも、透明、色、ロゴ、包装テキスト、ポート、付属アクセサリを確認します。"
    },
    {
      q: "同じ商品画像をすべてのマーケットプレイスで使えますか？",
      a: "透明 PNG マスターは再利用し、最終サイズ、フレーミング、余白、背景は各マーケットプレイスと現行カテゴリポリシー向けに作ります。"
    },
    {
      q: "切り抜きをライフスタイル商品画像にできますか？",
      a: "はい。透明 PNG を Seedream または FLUX で続け、商品構造・色・ブランディングが正確か確認します。"
    }
  ]
}

var jaArticles = {
  "ai-background-remover-online": {
    title: "無料 AI 背景リムーバーでオンライン切り抜きと透明 PNG 作成",
    excerpt: "無料で画像背景を除去：JPG、PNG、または WebP をアップロードし、AI に被写体を検出させ、透明 PNG をダウンロード。",
    metaTitle: "無料 AI 背景リムーバー オンライン | Miral",
    metaDescription: "サインイン後、Miral AI Background Remover を無料で使い、写真背景を自動除去して透明 PNG 切り抜きを書き出します。",
    target: {
      label: "背景除去を開く",
      path: "/tools/background-remover"
    }
  },
  "ecommerce-product-background-removal": {
    title: "EC 画像向け無料 AI 商品背景リムーバー",
    excerpt: "無料で商品背景を除去し、Amazon、Shopify、eBay、Etsy 向けの透明 PNG または白背景画像を作成。",
    metaTitle: "無料 EC 商品背景リムーバー | Miral",
    metaDescription: "サインイン後、Miral AI を無料で使い、商品背景を除去し、透明 PNG を書き出し、EC 白背景画像を準備します。",
    target: {
      label: "商品背景除去を開く",
      path: "/tools/background-remover"
    }
  }
}

var koBg = {
  overview: [
    "Miral AI Background Remover는 로그인 후 무료로 사용할 수 있습니다. 이미지 전체를 분석해 전경 피사체를 주변에서 분리하고, 손으로 그린 마스크 없이 배경을 자동으로 제거합니다.",
    "최대 15 MB의 JPG, PNG 또는 WebP 이미지를 업로드하고 머리카락, 투명 재질, 작은 구멍, 저대비 가장자리를 확인한 뒤 투명 PNG로 다운로드하세요.",
    "투명 PNG는 Miral AI 워크플로에서 향상, 오브젝트 정리, 새 제품 장면 제작에 그대로 쓸 수 있습니다. 투명 배경은 흰색 배경과 다릅니다. 마켓플레이스가 흰색을 요구하면 이후에 흰색 레이어를 추가하세요."
  ],
  practice: [
    "가장 신뢰할 수 있는 원본은 피사체가 완전하고, 가장자리가 선명하며, 전경과 배경 대비가 분명한 사진입니다. 재압축된 스크린샷과 모션 블러는 세부 분리를 어렵게 합니다.",
    "모든 결과는 어두운 캔버스와 밝은 캔버스 모두에서 검토합니다. 흰 후광, 어두운 테두리, 놓친 틈, 잘린 가닥처럼 기본 미리보기에서 안 보이는 문제가 드러납니다."
  ],
  compareIntro: "배경 전체를 자동으로 없애야 할 때는 AI Background Remover를 사용하세요. 특정 마크나 오브젝트만 지울 때는 Watermark Remover 또는 Object Remover를 사용하세요.",
  workflow: "최대 15 MB의 JPG, PNG 또는 WebP 이미지 하나를 업로드하고, AI가 전경을 자동 감지하게 한 뒤, 세밀한 가장자리를 검토하고 투명 PNG를 다운로드하세요.",
  scenarioIntro: "원본 이미지에 가장 가까운 시나리오를 선택한 다음, 해당 피사체에서 가장 중요한 자동 감지 가장자리를 검토하세요.",
  sec: {
    tldrTitle: "핵심 요약",
    tldrCols: [
      "알아둘 점",
      "세부 내용"
    ],
    tldrRows: [
      [
        "요금",
        "로그인 후 무료 사용"
      ],
      [
        "업로드",
        "JPG, PNG 또는 WebP 이미지 1장(최대 15 MB)"
      ],
      [
        "처리",
        "피사체 자동 감지; 윤곽선이나 마스크를 그릴 필요 없음"
      ],
      [
        "다운로드",
        "투명 PNG"
      ],
      [
        "확인할 점",
        "머리카락, 유리, 털, 가는 틈, 저대비 가장자리"
      ]
    ],
    tldrP: "단순한 인물이나 제품 사진이라면 보통 업로드, 대기, 검사, 다운로드면 충분합니다. 검사가 중요합니다. 작은 미리보기에서는 괜찮아 보여도 어두운 디자인에 올리면 옅은 테두리가 보일 수 있습니다.",
    whatTitle: "리무버가 실제로 하는 일",
    whatP1: "Miral AI Background Remover는 전체 이미지를 읽고 어떤 픽셀이 전경인지 판단합니다. 펜 도구로 피사체를 따라 그리는 것보다 훨씬 빠르며, 처리 전에 선택 영역을 맞출 필요도 없습니다.",
    whatP2: "결과는 투명도가 있는 PNG이며, 흰색으로 칠한 JPG가 아닙니다. 흰색 제품 카드, 브랜드 색, 완전히 새로운 장면에 피사체를 다시 잘라내지 않고 올릴 수 있습니다.",
    whatTipTitle: "유용한 구분",
    whatTipText: "투명과 흰색은 서로 바꿀 수 없습니다. 투명은 캔버스를 열어 두고, 흰색 배경은 흰색 픽셀로 영구히 채웁니다.",
    howTitle: "간단한 4단계 워크플로",
    howP: "가능하면 원본 파일로 시작하세요. 메신저를 거친 스크린샷은 가장자리가 부드러워져 잔머리와 투명 재질 분리가 더 어렵습니다.",
    edgeTitle: "다운로드 전에 볼 곳",
    edgeCols: [
      "이미지",
      "자세히 볼 점",
      "이유"
    ],
    edgeRows: [
      [
        "인물",
        "잔머리, 안경, 귀걸이",
        "가는 디테일이 쉽게 잘림"
      ],
      [
        "제품",
        "손잡이, 구멍, 코드, 신발끈",
        "닫힌 틈 안에 배경이 남을 수 있음"
      ],
      [
        "유리·투명 포장",
        "반사와 반투명 가장자리",
        "원래 배경이 물체를 통해 보임"
      ],
      [
        "로고·서명",
        "가는 선과 카운터(빈 공간)",
        "작은 틈이 메워질 수 있음"
      ],
      [
        "반려동물",
        "털과 수염",
        "썸네일에서는 빠진 가닥이 가려짐"
      ]
    ],
    edgeP: "다운로드한 PNG를 밝은 캔버스와 어두운 캔버스에 각각 올려 보세요. 옅은 후광과 어두운 테두리가 드러나며, 체커보드 미리보기만 보는 것보다 확실합니다.",
    bgTitle: "투명, 흰색, 아니면 교체 배경?",
    bgCols: [
      "결과",
      "포함 내용",
      "적합한 용도"
    ],
    bgRows: [
      [
        "투명 배경",
        "고정 배경색 없음; PNG로 저장",
        "로고, 프로필 이미지, 디자인 자산, 재사용 가능한 제품 컷아웃"
      ],
      [
        "흰색 배경",
        "컷아웃 아래 흰색 레이어",
        "제품 리스팅, 증명사진, 흰색이 필요한 레이아웃"
      ],
      [
        "브랜드 색 배경",
        "피사체 아래 단색 또는 그라데이션",
        "캠페인 그래픽, 프로필 카드, 브랜드 비주얼"
      ],
      [
        "새 장면",
        "다른 환경에 컷아웃 배치",
        "제품 라이프스타일 이미지와 크리에이티브 합성"
      ]
    ],
    bgP: "투명 PNG를 먼저 두고 흰색·컬러 버전은 나중에 만듭니다. JPG는 투명 픽셀을 저장할 수 없어 재사용 마스터로는 부적합합니다.",
    troubleTitle: "컷아웃이 이상해 보일 때",
    troubleCols: [
      "문제",
      "가능한 원인",
      "시도할 점"
    ],
    troubleRows: [
      [
        "흰/어두운 테두리",
        "옛 배경 색이 가장자리에 남음",
        "더 선명하고 대비가 강한 원본으로 재시도"
      ],
      [
        "머리카락·수염 소실",
        "원본이 작거나 흐리거나 심하게 압축됨",
        "원본 사진을 쓰고 실물 크기로 검사"
      ],
      [
        "손잡이 안 배경 잔존",
        "닫힌 틈이 피사체로 읽힘",
        "틈이 더 잘 보이는 각도로 재촬영·재시도"
      ],
      [
        "유리가 불완전",
        "투명 영역에 옛 장면 색이 포함됨",
        "배경을 더 깔끔히 하고 결과를 수동 검토"
      ],
      [
        "흰색 위 흰색 가장자리 소실",
        "전경과 배경이 너무 비슷함",
        "대비가 더 큰 사진을 선택"
      ]
    ],
    prosConsTitle: "도움이 되는 점—그리고 판단이 필요한 점",
    bestTitle: "결과를 개선하는 습관",
    bestItems: [
      "채팅 앱에서 저장한 썸네일보다 원본 사진을 사용하세요.",
      "피사체 전체가 보이고 초점이 맞은 이미지를 선택하세요.",
      "피사체가 배경에 녹아들면 대비가 더 분명한 다른 사진을 쓰세요.",
      "사용 전에 밝은 캔버스와 어두운 캔버스에서 PNG를 검토하세요.",
      "흰 제품은 어두운 캔버스에서 확인하세요. 잔여가 훨씬 잘 보입니다.",
      "중요한 이미지는 한 장씩 처리해 가장자리를 제대로 검토하세요."
    ],
    miralTitle: "Miral AI에서 계속 작업하기",
    miralP: "배경이 사라진 투명 PNG는 유용한 마스터 파일입니다. 선명도를 올리고, 불필요한 오브젝트를 지우고, 권한이 있는 워터마크를 지우거나, 제품을 새 상업 장면으로 바꿀 수 있습니다.",
    miralLinksTitle: "다음 단계",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "AI Object Remover",
        path: "/tools/object-remover"
      },
      {
        label: "AI Watermark Remover",
        path: "/tools/watermark-remover"
      },
      {
        label: "이커머스 제품 배경 가이드",
        path: "/hub/articles/ecommerce-product-background-removal"
      },
      {
        label: "Seedream 5",
        path: "/image-models/seedream-ai-image-generator"
      }
    ],
    faqTitle: "실무에서 자주 나오는 질문",
    faqItems: [
      [
        "온라인에서 이미지 배경을 투명하게 하려면?",
        "JPG, PNG 또는 WebP를 업로드하고 자동 배경 제거를 기다린 뒤 투명 PNG를 다운로드하세요."
      ],
      [
        "Miral AI Background Remover는 무료인가요?",
        "네. 로그인한 뒤 이미지를 업로드하고 배경 제거 기능을 무료로 사용할 수 있습니다. 추가 데스크톱 소프트웨어는 필요 없습니다."
      ],
      [
        "로그인이 필요한가요?",
        "네. 업로드 전에 로그인해야 하지만, 배경 제거 기능 자체는 무료입니다."
      ],
      [
        "피사체 윤곽을 그려야 하나요?",
        "아니요. 도구가 전체 이미지에서 전경을 자동 감지합니다."
      ],
      [
        "다운로드가 PNG인 이유는?",
        "PNG는 투명 픽셀을 유지할 수 있습니다. JPG는 할 수 없습니다."
      ],
      [
        "배경 제거가 이미지 크기를 바꾸나요?",
        "게시 전에 다운로드한 픽셀 치수를 최종 레이아웃과 맞추세요. 특히 마켓플레이스나 템플릿에 고정 크기가 있을 때."
      ],
      [
        "컷아웃 주변 흰 후광은 어떻게 고치나요?",
        "어두운 캔버스에서 PNG를 본 뒤, 더 선명하고 대비가 강한 원본으로 재시도하세요."
      ],
      [
        "머리카락과 반려동물 털도 처리되나요?",
        "가능하지만, 가는 가닥은 밝은 배경과 어두운 배경 모두에서 실물 크기 확인이 필요합니다."
      ],
      [
        "AI 배경 제거와 배경 지우개의 차이는?",
        "AI 배경 제거는 피사체를 자동으로 찾습니다. 전통적인 배경 지우개는 보통 손으로 영역을 지웁니다."
      ],
      [
        "흰 피사체가 흰 배경에서 사라지는 이유는?",
        "가장자리 대비가 거의 없습니다. 더 어둡거나 뚜렷한 배경의 원본이 경계가 더 분명합니다."
      ],
      [
        "유리 제품 일부가 빠지는 이유는?",
        "유리는 옛 배경을 반사·투과해 경계가 모호합니다. 대비 있는 배경의 선명한 사진이 모델에 더 유리합니다."
      ],
      [
        "무엇을 업로드할 수 있나요?",
        "각 최대 15 MB의 JPG, PNG, WebP. 페이지는 한 번에 한 장 처리합니다."
      ]
    ]
  },
  linksTitle: "Miral AI에서 워크플로 이어가기",
  linksIntro: "배경 제거 후 투명 PNG를 다른 Miral AI 도구에서 쓰거나, 다음 단계 전용 가이드로 이어가세요.",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "AI Object Remover",
      path: "/tools/object-remover"
    },
    {
      label: "AI Watermark Remover",
      path: "/tools/watermark-remover"
    },
    {
      label: "이커머스 제품 배경 가이드",
      path: "/hub/articles/ecommerce-product-background-removal"
    },
    {
      label: "Seedream 5",
      path: "/image-models/seedream-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "원본 이미지 업로드",
      text: "15 MB 이하 JPG, PNG 또는 WebP 파일 하나를 선택하세요."
    },
    {
      title: "AI가 피사체를 찾게 하기",
      text: "Miral이 전체 배경을 자동 제거합니다. 윤곽선이나 마스크를 그릴 필요 없습니다."
    },
    {
      title: "어려운 가장자리 검사",
      text: "머리카락, 안경, 투명 재질, 제품 구멍 등 세부를 확대하세요."
    },
    {
      title: "투명 PNG 다운로드",
      text: "재사용 컷아웃으로 저장한 뒤 최종 캔버스에 배치하세요."
    }
  ],
  pros: [
    "수동 윤곽 없이 자동 피사체 감지",
    "JPG, PNG, WebP 입력 지원",
    "재사용 가능한 투명 PNG 다운로드",
    "인물, 제품, 로고, 서명, 반려동물에 유용"
  ],
  cons: [
    "머리카락과 투명 오브젝트는 시각 검토가 필요",
    "피사체·배경 저대비는 가장자리 품질을 낮출 수 있음",
    "현재 페이지는 한 번에 한 장 처리",
    "15 MB 초과 파일은 먼저 줄여야 함"
  ],
  tips: [
    {
      title: "배경색 두 가지로 확인",
      text: "투명 PNG를 어두운 배경과 밝은 배경에 모두 올려 후광과 빠진 가장자리를 찾으세요."
    },
    {
      title: "가장 선명한 원본 사용",
      text: "여러 번 압축된 작은 스크린샷보다 크고 선명한 원본이 보통 더 잘 됩니다."
    },
    {
      title: "세밀한 디테일 보호",
      text: "머리카락, 수염, 주얼리 체인, 신발끈, 안경, 제품 손잡이 안 틈을 확대 확인하세요."
    },
    {
      title: "흰/어두운 후광 수정",
      text: "후광은 종종 원래 가장자리의 색 오염입니다. 더 선명하고 전경·배경 대비가 강한 원본으로 재시도하세요."
    },
    {
      title: "투명 재질 검토",
      text: "유리와 투명 포장은 옛 배경이 비치므로 흰색과 어두운 캔버스 모두에서 비교하세요."
    }
  ],
  scenarios: [
    {
      title: "인물 배경 제거",
      text: "프로필 이미지나 포스터에 쓰기 전에 잔머리, 귀걸이, 안경을 확인하세요."
    },
    {
      title: "제품 배경 제거",
      text: "손잡이, 구멍, 코드, 반사 가장자리, 투명 포장을 검사하세요."
    },
    {
      title: "로고·서명 배경 제거",
      text: "가는 선과 내부 컷아웃이 유지되도록 고해상도 원본을 사용하세요."
    },
    {
      title: "반려동물 사진 배경 제거",
      text: "대비가 강한 단순한 배경을 고르고 털과 수염을 실물 크기로 검사하세요."
    }
  ],
  toolFaq: [
    {
      q: "온라인에서 이미지 배경을 제거하려면?",
      a: "JPG, PNG 또는 WebP를 업로드하고 AI가 배경을 자동 감지·제거하게 한 뒤 투명 PNG를 다운로드하세요."
    },
    {
      q: "사람이나 제품을 수동으로 선택해야 하나요?",
      a: "아니요. Background Remover가 전체 이미지를 분석해 전경을 자동 감지합니다."
    },
    {
      q: "결과가 PNG로 다운로드되는 이유는?",
      a: "PNG는 투명도를 지원합니다. JPG는 투명 배경을 보존할 수 없습니다."
    },
    {
      q: "배경 제거 후 흰 후광은 어떻게 고치나요?",
      a: "먼저 어두운 캔버스에서 결과를 확인한 뒤, 피사체·배경 대비가 더 분명한 선명한 원본으로 재시도하세요."
    },
    {
      q: "AI가 머리카락이나 반려동물 털 주변도 제거하나요?",
      a: "네. 다만 가는 머리카락, 수염, 털은 어려운 가장자리이므로 항상 실물 크기로 검토하세요."
    },
    {
      q: "투명, 흰색, 교체 배경의 차이는?",
      a: "투명 PNG에는 고정 배경이 없습니다. 흰 배경 이미지는 흰 픽셀을 포함하고, 교체 배경은 컷아웃을 새 장면이나 색에 둡니다."
    },
    {
      q: "유리 오브젝트 일부가 빠지는 이유는?",
      a: "투명 오브젝트에는 원래 배경 색이 포함됩니다. 더 선명하고 고대비 원본으로 재시도하고 투명 영역을 수동 검토하세요."
    },
    {
      q: "Background Remover 사용에 로그인이 필요한가요?",
      a: "네. 이미지를 업로드하고 처리하기 전에 로그인하세요."
    },
    {
      q: "Miral AI Background Remover는 무료인가요?",
      a: "네. 로그인 후 배경 제거 기능은 무료이며 추가 소프트웨어 설치가 필요 없습니다."
    },
    {
      q: "지원 형식과 파일 크기는?",
      a: "각 최대 15 MB의 JPG, PNG, WebP를 받습니다."
    }
  ]
}

var koEcom = {
  overview: [
    "이커머스 작업에서 Miral AI Background Remover는 로그인 후 무료입니다. 깨끗한 투명 PNG 마스터 하나를 만든 뒤, 같은 컷아웃으로 흰 배경·브랜드 색·배너·라이프스타일 버전을 만드세요.",
    "최대 15 MB JPG, PNG 또는 WebP를 업로드하면 Miral AI Background Remover가 제품을 자동 감지합니다. 수동 마스크 단계는 없습니다. 게시 전에 손잡이, 체인, 끈, 투명 포장, 유리, 털, 반사 금속을 검사하세요.",
    "Amazon, Shopify, eBay, Etsy, Google Shopping 등 채널마다 이미지 규칙이 다르고 바뀔 수 있습니다. 배경 제거는 자산을 준비하지만 마켓플레이스 준수를 자동 보장하지는 않습니다. 정확한 채널과 카테고리의 현재 요구사항을 확인하세요."
  ],
  practice: [
    "선호하는 워크플로는 제품 원본 사진 → 자동 배경 제거 → 가장자리 검토 → 투명 PNG 마스터 → 그다음 채널별 레이아웃입니다. 스토어마다 컷아웃을 반복하지 않아도 됩니다.",
    "순백 이미지는 투명 PNG를 흰 캔버스에 놓으세요. Shopify 배너나 소셜 광고는 같은 컷아웃을 브랜드 색에 재사용하거나 Seedream·FLUX로 라이프스타일 장면을 이어가세요."
  ],
  compareIntro: "투명 제품 마스터를 만들려면 Background Remover를 쓰고, 마켓플레이스 리스팅용으로 흰 캔버스를 추가하거나 Seedream·FLUX로 라이프스타일 이미지를 이어가세요.",
  workflow: "최대 15 MB의 선명한 제품 이미지 하나를 업로드하고, AI가 전체 배경을 자동 제거하게 한 뒤, 제품 가장자리를 검토하고 투명 PNG 마스터를 다운로드하세요.",
  scenarioIntro: "제품에 가장 가까운 이커머스 시나리오를 선택한 다음, 채널별 레이아웃을 만들기 전에 자동 감지된 제품 가장자리를 검사하세요.",
  sec: {
    tldrTitle: "권장 워크플로",
    tldrCols: [
      "단계",
      "유지할 것",
      "확인"
    ],
    tldrRows: [
      [
        "배경 제거",
        "투명 PNG 마스터",
        "가장자리, 구멍, 세부품, 투명 재질"
      ],
      [
        "흰 버전 제작",
        "별도 평탄화 내보내기",
        "여백과 현재 마켓플레이스 규칙"
      ],
      [
        "브랜드 버전 제작",
        "카드·배너·광고용 파일",
        "제품 색, 형태, 로고, 포장 텍스트"
      ],
      [
        "마스터 보관",
        "검토된 투명 PNG",
        "채널별 배경으로 덮어쓰지 말 것"
      ]
    ],
    tldrP: "Miral AI Background Remover는 로그인 후 무료입니다. 배경은 한 번만 제거하고 그 투명 마스터를 유지한 뒤, 흰·브랜드·라이프스타일 버전은 모두 그것으로 만드세요. 스토어마다 같은 제품을 다시 자르는 것보다 깔끔합니다.",
    workflowTitle: "원본 사진에서 재사용 제품 컷아웃까지",
    workflowP1: "제품 전체가 보이고 초점이 맞은 사진을 고르세요. Miral AI Background Remover에 업로드하고 도구가 제품을 자동 찾게 한 뒤, PNG 다운로드 전에 결과를 검사하세요.",
    workflowP2: "마지막 확인은 건너뛰기 쉽습니다. 손잡이, 포트, 끈, 체인, 투명 포장, 옛 배경이 보여야 하는 틈을 확인하세요. 새 캔버스에서 자연스러워 보이는지가 여기서 결정됩니다.",
    transTitle: "왜 투명 버전을 먼저 남기나",
    transP: "투명 PNG는 유연한 자산입니다. 오늘은 순백 마켓플레이스 캔버스, 내일은 Shopify 브랜드 카드, 다음 달에는 시즌 배너에 올릴 수 있습니다. 흰 버전만 저장하면 새 배경마다 다시 정리해야 합니다.",
    transTipTitle: "레이어를 분리해 두기",
    transTipText: "투명 마스터를 보관하고 채널 버전은 별도 파일로보내세요. 수정이 훨씬 덜 고통스럽습니다.",
    platTitle: "하나의 마스터, 여러 스토어프론트",
    platCols: [
      "채널",
      "일반 용도",
      "실무 메모"
    ],
    platRows: [
      [
        "Amazon",
        "메인·보조 제품 이미지",
        "필요할 때만 흰색을 추가하고 현재 카테고리 정책을 확인"
      ],
      [
        "Shopify",
        "제품 카드, 컬렉션 페이지, 배너",
        "투명은 테마 색과 반응형 레이아웃에 잘 맞음"
      ],
      [
        "eBay",
        "리스팅 커버와 갤러리",
        "제품 실루엣 주변 잔여를 확인"
      ],
      [
        "Etsy",
        "핸드메이드 제품 커버와 디테일",
        "소재와 핸드메이드 디테일을 진실되게 유지"
      ],
      [
        "Google Shopping",
        "제품 광고 자산",
        "랜딩 페이지 상품과 일치시키고 현재 광고 규칙을 확인"
      ]
    ],
    platP: "마켓플레이스 규칙은 바뀌고, 같은 마켓 안에서도 카테고리마다 다를 수 있습니다. 배경 제거는 파일을 준비할 뿐 특정 리스팅용 최종 이미지를 인증하지 않습니다.",
    qualityTitle: "가장 틀리기 쉬운 제품",
    qualityItems: [
      "유리, 크리스털, 투명 포장은 투명 영역이 사라질 수 있습니다.",
      "주얼리 체인, 신발끈, 메쉬는 끊어진 조각으로 깨질 수 있습니다.",
      "흰 배경의 흰 제품, 어두운 배경의 어두운 제품은 가장자리 대비가 약합니다.",
      "플리스, 털, 부드러운 직물은 밝은·어두운 배경 모두에서 확인이 필요합니다.",
      "반사 금속은 원래 주변 색을 남길 수 있습니다."
    ],
    casesTitle: "더 자세히 볼 제품",
    casesCols: [
      "제품",
      "흔한 실패",
      "검토"
    ],
    casesRows: [
      [
        "의류·신발",
        "풀린 원단, 끈, 메쉬가 사라짐",
        "윤곽과 교차하는 모든 끈을 따라가세요"
      ],
      [
        "주얼리",
        "체인이 끊기거나 작은 개구가 메워짐",
        "링크, 프롱, 훅, 네거티브 스페이스를 확대"
      ],
      [
        "유리·투명 포장",
        "투명 영역이 채워지거나 불완전해짐",
        "흰·어두운 배경에서 확인"
      ],
      [
        "뷰티 포장",
        "펌프 틈과 투명 병이 디테일을 잃음",
        "라벨, 캡 가장자리, 실제 제품 색을 보호"
      ],
      [
        "전자제품",
        "포트, 케이블, 반사 가장자리가 바뀜",
        "포함된 부품과 커넥터를 모두 확인"
      ],
      [
        "가구",
        "다리 사이 공간이 채워진 채 남음",
        "바깥 가장자리만큼 내부 틈도 검사"
      ]
    ],
    acceptTitle: "게시 전 체크",
    acceptItems: [
      "옅은 후광, 어두운 테두리, 들쭉날쭉한 가장자리, 옛 배경 조각이 없음.",
      "손잡이, 구멍, 체인, 끈, 메쉬 등 내부 공간이 열려야 할 곳에서 열림.",
      "유리, 투명 플라스틱, 털, 반사 금속이 실제 소재처럼 보임.",
      "색, 로고, 포장 텍스트, 포트, 액세서리가 원본 제품과 일치.",
      "투명 마스터가 흰·라이프스타일보내기와 분리 저장됨.",
      "최종 크롭, 여백, 배경, 내용이 마켓플레이스 현재 규칙을 따름."
    ],
    prosConsTitle: "이 워크플로가 해결하는 것",
    miralTitle: "나머지는 Miral AI에서 구축",
    miralP: "컷아웃이 검토를 통과하면 이미지 향상이나 새 상업 장면으로 이어갈 수 있습니다. 진행하면서 제품 정체성을 계속 확인하세요. 병 형태, 신발 색, 패키지 라벨이 바뀌면 깔끔한 배경도 소용없습니다.",
    miralLinksTitle: "다음 단계",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "일반 AI 배경 제거 가이드",
        path: "/hub/articles/ai-background-remover-online"
      },
      {
        label: "Seedream 5 제품 이미지",
        path: "/image-models/seedream-ai-image-generator"
      },
      {
        label: "FLUX.2 제품 촬영",
        path: "/image-models/flux-2-ai-image-generator"
      },
      {
        label: "GPT Image 텍스트 포스터",
        path: "/image-models/gpt-image-ai-image-generator"
      }
    ],
    faqTitle: "자주 묻는 이커머스 질문",
    faqItems: [
      [
        "Miral AI에서 제품 배경 제거는 무료인가요?",
        "네. 로그인 후 배경 리무버를 무료로 쓰고 투명 PNG를 다운로드할 수 있습니다."
      ],
      [
        "Amazon용 흰 배경 이미지는 어떻게 만드나요?",
        "원본 배경을 제거하고 투명 PNG를 유지한 뒤, 순백 캔버스에 사본을 놓고 해당 카테고리의 현재 요구사항을 확인하세요."
      ],
      [
        "Shopify 제품 이미지는 흰 배경이 필수인가요?",
        "반드시 그렇지는 않습니다. 테마 제품 카드와 배너에는 투명이 종종 유용하지만, 최종 선택은 스토어 디자인에 달립니다."
      ],
      [
        "투명과 흰 제품 배경의 차이는?",
        "투명 PNG에는 고정 배경이 없습니다. 흰 배경 이미지는 이미 흰 픽셀을 포함해 아래 캔버스를 드러낼 수 없습니다."
      ],
      [
        "전체 카탈로그를 한 번에 처리할 수 있나요?",
        "현재 페이지는 한 번에 한 장입니다."
      ],
      [
        "유리 제품이 불완전해 보이는 이유는?",
        "유리와 투명 포장에는 옛 배경 색이 포함됩니다. 대비가 더 분명한 선명한 원본을 쓰고 투명 영역을 수동 검토하세요."
      ],
      [
        "제품 주변 흰 테두리는 어떻게 고치나요?",
        "어두운 캔버스에서 PNG를 보고 테두리를 확인한 뒤, 더 선명하고 대비가 강한 원본으로 재시도하세요."
      ],
      [
        "투명 제품 이미지는 어떻게 저장해야 하나요?",
        "고정 배경 없는 투명 PNG 마스터 하나를 두고, 그것으로 흰·브랜드·라이프스타일 버전을 따로 내보내세요."
      ],
      [
        "한 이미지를 모든 마켓플레이스에 재사용할 수 있나요?",
        "투명 마스터는 재사용하되, 최종 크롭·여백·배경은 채널과 카테고리별로 따로 내보내세요."
      ],
      [
        "컷아웃을 라이프스타일 이미지로 만들 수 있나요?",
        "네. 투명 PNG를 Seedream 또는 FLUX에서 이어가고 제품 형태·색·로고·포장이 정확한지 확인하세요."
      ]
    ]
  },
  linksTitle: "Miral AI에서 제품 이미지 워크플로 구축",
  linksIntro: "투명 제품 마스터 하나를 유지한 뒤, Miral AI에서 향상, 상업 장면 생성, 텍스트 중심 프로모 디자인을 이어가세요.",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "일반 AI 배경 제거 가이드",
      path: "/hub/articles/ai-background-remover-online"
    },
    {
      label: "Seedream 5 제품 이미지",
      path: "/image-models/seedream-ai-image-generator"
    },
    {
      label: "FLUX.2 제품 촬영",
      path: "/image-models/flux-2-ai-image-generator"
    },
    {
      label: "GPT Image 텍스트 포스터",
      path: "/image-models/gpt-image-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "선명한 제품 사진 선택",
      text: "제품 전체가 보이고 초점이 맞은, 최대 15 MB JPG·PNG·WebP를 사용하세요."
    },
    {
      title: "원본 배경 제거",
      text: "Miral AI가 제품을 감지하고 수동 마스크 없이 전체 배경을 지웁니다."
    },
    {
      title: "제품 디테일 확인",
      text: "내부 틈, 세부품, 투명 구간, 털, 유리, 반사 가장자리를 검사하세요."
    },
    {
      title: "투명 마스터 저장",
      text: "마켓플레이스별 배경이나 레이아웃을 추가하기 전에 PNG를 다운로드하세요."
    },
    {
      title: "채널 버전 만들기",
      text: "흰 또는 브랜드 캔버스를 추가한 뒤, 대상 마켓플레이스의 현재 요구사항을 확인하세요."
    }
  ],
  pros: [
    "하나의 투명 마스터로 여러 판매 채널 지원",
    "자동 제품 감지로 수동 윤곽 시간 절약",
    "스토어프론트 배경과 여백 표준화가 쉬움",
    "컷아웃을 Seedream·FLUX 장면으로 이어갈 수 있음"
  ],
  cons: [
    "게시 전 마켓플레이스 요구사항 확인 필요",
    "유리·털·가는 체인·반사 소재는 수동 검토 필요",
    "배경 제거는 최종 마켓플레이스 크기·레이아웃을 수행하지 않음",
    "현재 도구는 한 번에 한 장 처리"
  ],
  tips: [
    {
      title: "제거와 레이아웃 분리",
      text: "투명 PNG 마스터를 유지하고 컷아웃을 반복하지 않고 흰 배경·브랜드 파생본을 만드세요."
    },
    {
      title: "어려운 재질 검사",
      text: "유리, 투명 포장, 주얼리 체인, 털, 반사 금속을 먼저 확인하세요."
    },
    {
      title: "현재 마켓플레이스 규칙 확인",
      text: "이미지 크기, 배경, 프레이밍, 콘텐츠 정책은 바뀌고 카테고리마다 다를 수 있습니다."
    },
    {
      title: "제품 수락 체크리스트 사용",
      text: "게시 전 윤곽, 내부 틈, 색, 로고, 포장 텍스트, 포트, 액세서리, 투명 영역을 확인하세요."
    },
    {
      title: "투명 마스터 하나 유지",
      text: "검토된 투명 PNG를 따로 저장하고 흰·브랜드·라이프스타일 버전은 모두 그 파일에서 파생하세요."
    }
  ],
  scenarios: [
    {
      title: "Amazon 흰 배경 제품 이미지",
      text: "검토된 투명 PNG를 순백 캔버스에 놓고 현재 카테고리 요구사항을 확인하세요."
    },
    {
      title: "Shopify 제품 카드와 배너",
      text: "반응형 카드, 브랜드 색, 홈페이지 구성에 투명 제품을 재사용하세요."
    },
    {
      title: "eBay·Etsy 리스팅 이미지",
      text: "상품을 완전하고 진실되게 유지하고, 업로드 전 가장자리 배경 잔여를 검사하세요."
    },
    {
      title: "크로스보더 이커머스 크리에이티브",
      text: "실제 제품 형태·색·브랜딩을 보존하면서 하나의 투명 PNG 마스터로 여러 채널 크기를 만드세요."
    },
    {
      title: "Google Shopping 제품 광고",
      text: "랜딩 페이지와 일치하는 상품을 유지하고 현재 광고 규칙에 맞게 투명 마스터에서 자산을 만드세요."
    }
  ],
  toolFaq: [
    {
      q: "Miral AI에서 이커머스 제품 배경 제거는 무료인가요?",
      a: "네. 로그인 후 배경 제거 기능을 무료로 쓰고 투명 PNG를 다운로드할 수 있습니다."
    },
    {
      q: "Amazon용 흰 배경 제품 이미지는 어떻게 만드나요?",
      a: "원본 배경을 제거하고 투명 PNG를 다운로드한 뒤 순백 캔버스에 놓고 제품 카테고리의 현재 요구사항을 확인하세요."
    },
    {
      q: "Shopify 제품 이미지는 흰 배경이 필수인가요?",
      a: "항상은 아닙니다. 투명 PNG는 브랜드 색 카드와 배너에 유용합니다. 스토어 테마와 레이아웃에 맞춰 최종 배경을 선택하세요."
    },
    {
      q: "투명과 흰 배경의 차이는?",
      a: "투명 이미지는 고정 배경이 없어 어떤 캔버스에도 올릴 수 있습니다. 흰 배경 이미지는 흰 픽셀을 포함합니다."
    },
    {
      q: "전체 제품 카탈로그 배경을 한 번에 제거할 수 있나요?",
      a: "현재 Background Remover 페이지는 한 번에 한 장 처리하므로, 이 글은 배치 워크플로를 주장하지 않습니다."
    },
    {
      q: "배경 제거 후 유리 제품이 불완전한 이유는?",
      a: "투명도와 반사는 분리하기 어렵습니다. 더 선명하고 대비가 강한 이미지로 재시도한 뒤 결과를 수동 검토하세요."
    },
    {
      q: "제품 컷아웃의 흰 후광은 어떻게 고치나요?",
      a: "투명 PNG를 어두운 캔버스에 올려 후광을 찾은 뒤, 더 높은 해상도와 강한 가장자리 대비의 원본으로 재시도하세요."
    },
    {
      q: "제품 컷아웃 게시 전에 무엇을 확인해야 하나요?",
      a: "실물 크기로 윤곽, 구멍, 체인, 끈, 투명도, 색, 로고, 포장 텍스트, 포트, 포함 액세서리를 확인하세요."
    },
    {
      q: "같은 제품 이미지를 모든 마켓플레이스에 쓸 수 있나요?",
      a: "투명 PNG 마스터는 재사용하되, 최종 크기·프레이밍·여백·배경은 각 마켓플레이스와 현재 카테고리 정책에 맞게 만드세요."
    },
    {
      q: "컷아웃을 라이프스타일 제품 이미지로 만들 수 있나요?",
      a: "네. 투명 PNG를 Seedream 또는 FLUX에서 이어가고 제품 구조·색·브랜딩이 정확한지 확인하세요."
    }
  ]
}

var koArticles = {
  "ai-background-remover-online": {
    title: "무료 AI 배경 리무버로 온라인 누끼와 투명 PNG 만들기",
    excerpt: "무료로 이미지 배경 제거: JPG, PNG 또는 WebP를 업로드하고 AI가 피사체를 감지하게 한 뒤 투명 PNG를 다운로드하세요.",
    metaTitle: "무료 AI 배경 리무버 온라인 | Miral",
    metaDescription: "로그인 후 Miral AI Background Remover를 무료로 사용해 사진 배경을 자동 제거하고 투명 PNG 컷아웃을보내세요.",
    target: {
      label: "배경 제거 열기",
      path: "/tools/background-remover"
    }
  },
  "ecommerce-product-background-removal": {
    title: "이커머스 이미지용 무료 AI 제품 배경 리무버",
    excerpt: "무료로 제품 배경을 제거하고 Amazon, Shopify, eBay, Etsy용 투명 PNG 또는 흰 배경 이미지를 만드세요.",
    metaTitle: "무료 이커머스 제품 배경 리무버 | Miral",
    metaDescription: "로그인 후 Miral AI를 무료로 사용해 제품 배경을 제거하고 투명 PNG를보내며 이커머스 흰 배경 이미지를 준비하세요.",
    target: {
      label: "제품 배경 제거 열기",
      path: "/tools/background-remover"
    }
  }
}

var frBg = {
  overview: [
    "Miral AI Background Remover est gratuit après connexion. Il analyse l'image entière, sépare le sujet au premier plan de son environnement et supprime l'arrière-plan automatiquement, sans masque dessiné à la main.",
    "Importez une image JPG, PNG ou WebP jusqu'à 15 Mo, vérifiez les cheveux, les matériaux transparents, les petits trous et les bords à faible contraste, puis téléchargez le résultat en PNG transparent.",
    "Le PNG transparent peut rester dans le workflow Miral AI pour l'amélioration, le nettoyage d'objets ou une nouvelle scène produit. Un arrière-plan transparent n'est pas la même chose qu'un fond blanc : ajoutez une couche blanche ensuite si une marketplace l'exige."
  ],
  practice: [
    "La source la plus fiable montre un sujet complet, des contours nets et un contraste net entre le premier plan et l'arrière-plan. Les captures d'écran recompressées et le flou de mouvement compliquent la séparation des détails fins.",
    "Je vérifie chaque résultat sur un fond sombre et un fond clair. Cela révèle les halos blancs, les franges sombres, les interstices manqués et les mèches supprimées, invisibles dans l'aperçu par défaut."
  ],
  compareIntro: "Utilisez AI Background Remover lorsque l'arrière-plan entier doit disparaître automatiquement. Utilisez Watermark Remover ou Object Remover pour effacer uniquement une marque ou un objet indésirable.",
  workflow: "Importez une image JPG, PNG ou WebP jusqu'à 15 Mo, laissez l'IA détecter le premier plan automatiquement, vérifiez les bords fins et téléchargez le PNG transparent.",
  scenarioIntro: "Choisissez le scénario le plus proche de votre image source, puis examinez les bords détectés automatiquement qui comptent le plus pour ce sujet.",
  sec: {
    tldrTitle: "L'essentiel",
    tldrCols: [
      "À savoir",
      "Détails"
    ],
    tldrRows: [
      [
        "Tarif",
        "Gratuit après connexion"
      ],
      [
        "Import",
        "Une image JPG, PNG ou WebP (max. 15 Mo)"
      ],
      [
        "Traitement",
        "Détection automatique du sujet ; aucun contour ni masque à dessiner"
      ],
      [
        "Téléchargement",
        "Un PNG transparent"
      ],
      [
        "À vérifier",
        "Cheveux, verre, fourrure, interstices fins et bords à faible contraste"
      ]
    ],
    tldrP: "Pour un portrait ou une photo produit simple, le travail se résume en général à importer, attendre, vérifier et télécharger. La vérification compte : un détourage peut sembler correct en petit aperçu et laisser une frange pâle sur un design sombre.",
    whatTitle: "Ce que fait réellement l'outil",
    whatP1: "Miral AI Background Remover lit l'image entière et détermine quels pixels appartiennent au premier plan. C'est bien plus rapide que de tracer le sujet à la plume, et il n'y a pas d'étape de sélection à réussir avant le traitement.",
    whatP2: "Le résultat est un PNG avec transparence, pas un JPG peint en blanc. Vous pouvez placer ce fichier sur une fiche produit blanche, une couleur de marque ou une scène entièrement nouvelle sans redécouper le sujet.",
    whatTipTitle: "Une distinction utile",
    whatTipText: "Transparent et blanc ne sont pas interchangeables. La transparence laisse le canevas ouvert ; un fond blanc le remplit définitivement de pixels blancs.",
    howTitle: "Un workflow simple en quatre étapes",
    howP: "Commencez par le fichier original si vous l'avez. Les captures d'écran passées par des messageries ont souvent des bords plus doux, ce qui complique la séparation des cheveux fins et des matériaux transparents.",
    edgeTitle: "Où regarder avant de télécharger",
    edgeCols: [
      "Image",
      "À examiner de près",
      "Pourquoi"
    ],
    edgeRows: [
      [
        "Portrait",
        "Cheveux libres, lunettes, boucles d'oreilles",
        "Les détails fins sont faciles à rogner"
      ],
      [
        "Produit",
        "Poignées, trous, câbles, lacets",
        "L'arrière-plan peut rester dans les interstices fermés"
      ],
      [
        "Verre ou emballage transparent",
        "Reflets et bords translucides",
        "L'arrière-plan d'origine est visible à travers l'objet"
      ],
      [
        "Logo ou signature",
        "Traits fins et contreformes",
        "Les petits interstices peuvent se refermer"
      ],
      [
        "Animal",
        "Fourrure et moustaches",
        "Une vignette peut masquer des mèches manquantes"
      ]
    ],
    edgeP: "Je place le PNG téléchargé sur un canevas clair et un canevas sombre. Ce contrôle rapide révèle halos pâles et franges sombres, plus fiable que le damier seul.",
    bgTitle: "Transparent, blanc ou arrière-plan remplacé ?",
    bgCols: [
      "Résultat",
      "Contenu",
      "Meilleur usage"
    ],
    bgRows: [
      [
        "Arrière-plan transparent",
        "Aucune couleur de fond fixe ; enregistré en PNG",
        "Logos, photos de profil, assets design et détourages produit réutilisables"
      ],
      [
        "Fond blanc",
        "Une couche blanche sous le détourage",
        "Fiches produit, photos d'identité et mises en page exigeant le blanc"
      ],
      [
        "Fond couleur de marque",
        "Couleur unie ou dégradé sous le sujet",
        "Visuels de campagne, cartes de profil et identité visuelle"
      ],
      [
        "Nouvelle scène",
        "Détourage placé dans un autre environnement",
        "Images lifestyle produit et compositions créatives"
      ]
    ],
    bgP: "Je conserve d'abord le PNG transparent et crée les versions blanches ou colorées ensuite. Le JPG ne peut pas stocker de pixels transparents, donc il est peu adapté comme fichier maître réutilisable.",
    troubleTitle: "Si le détourage semble incorrect",
    troubleCols: [
      "Problème",
      "Cause probable",
      "À essayer"
    ],
    troubleRows: [
      [
        "Frange blanche ou sombre",
        "Couleur de l'ancien fond restée sur le bord",
        "Réessayer avec une source plus nette et un contraste plus fort"
      ],
      [
        "Cheveux ou moustaches disparus",
        "Source petite, floue ou fortement compressée",
        "Utiliser la photo originale et vérifier en taille réelle"
      ],
      [
        "Arrière-plan restant dans une poignée",
        "Un interstice fermé a été lu comme partie du sujet",
        "Essayer un angle plus clair avec un interstice plus visible"
      ],
      [
        "Verre incomplet",
        "La transparence contient des couleurs de l'ancienne scène",
        "Utiliser un fond plus propre et vérifier le résultat manuellement"
      ],
      [
        "Bords blanc sur blanc effacés",
        "Premier plan et arrière-plan trop similaires",
        "Choisir une photo avec plus de contraste"
      ]
    ],
    prosConsTitle: "Ce qu'il apporte — et où le jugement reste nécessaire",
    bestTitle: "Quelques habitudes qui améliorent le résultat",
    bestItems: [
      "Utilisez la photo originale plutôt qu'une vignette enregistrée depuis une messagerie.",
      "Choisissez une image où le sujet entier est visible et net.",
      "Si le sujet se fond dans l'arrière-plan, essayez une autre photo avec un contraste plus net.",
      "Vérifiez le PNG sur un fond clair et un fond sombre avant utilisation.",
      "Contrôlez les produits blancs sur un fond sombre ; les résidus y sont bien plus visibles.",
      "Traitez les images importantes une par une pour examiner chaque bord correctement."
    ],
    miralTitle: "Poursuivre dans Miral AI",
    miralP: "Une fois l'arrière-plan supprimé, le PNG transparent est un fichier maître utile. Vous pouvez le nettoyer, retirer un objet indésirable, effacer un filigrane autorisé ou transformer le produit en nouvelle scène commerciale.",
    miralLinksTitle: "Étapes suivantes",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "AI Object Remover",
        path: "/tools/object-remover"
      },
      {
        label: "AI Watermark Remover",
        path: "/tools/watermark-remover"
      },
      {
        label: "Guide e-commerce pour les fonds produit",
        path: "/hub/articles/ecommerce-product-background-removal"
      },
      {
        label: "Seedream 5",
        path: "/image-models/seedream-ai-image-generator"
      }
    ],
    faqTitle: "Questions fréquentes en pratique",
    faqItems: [
      [
        "Comment rendre un arrière-plan transparent en ligne ?",
        "Importez une image JPG, PNG ou WebP, attendez la suppression automatique de l'arrière-plan et téléchargez le PNG transparent."
      ],
      [
        "Miral AI Background Remover est-il gratuit ?",
        "Oui. Connectez-vous, importez une image et utilisez la suppression d'arrière-plan gratuitement. Aucun logiciel de bureau supplémentaire n'est requis."
      ],
      [
        "Faut-il se connecter ?",
        "Oui. Connectez-vous avant l'import, mais la fonction de suppression d'arrière-plan est gratuite."
      ],
      [
        "Dois-je tracer le contour du sujet ?",
        "Non. L'outil détecte automatiquement le premier plan sur toute l'image."
      ],
      [
        "Pourquoi le téléchargement est-il en PNG ?",
        "Le PNG peut conserver des pixels transparents. Le JPG ne le peut pas."
      ],
      [
        "La suppression d'arrière-plan change-t-elle les dimensions ?",
        "Vérifiez les dimensions en pixels du fichier téléchargé par rapport à votre mise en page finale avant publication, surtout si une marketplace ou un modèle impose une taille fixe."
      ],
      [
        "Comment corriger un halo blanc autour du détourage ?",
        "Affichez le PNG sur un fond sombre, puis réessayez avec une source plus nette et un contraste plus fort autour du sujet."
      ],
      [
        "Gère-t-il les cheveux et la fourrure d'animaux ?",
        "Oui, mais les mèches fines méritent une vérification en taille réelle sur fond clair et fond sombre."
      ],
      [
        "Quelle différence entre suppression IA et gomme d'arrière-plan ?",
        "La suppression IA trouve le sujet automatiquement. Une gomme classique demande généralement d'effacer des zones à la main."
      ],
      [
        "Pourquoi un sujet blanc disparaît sur fond blanc ?",
        "Le bord a très peu de contraste. Une photo avec un arrière-plan plus sombre ou plus distinct donne une limite plus claire au modèle."
      ],
      [
        "Pourquoi une partie de mon produit en verre manque-t-elle ?",
        "Le verre réfléchit et transmet l'ancien fond, donc la limite est ambiguë. Une photo nette sur fond contrasté donne un meilleur point de départ au modèle."
      ],
      [
        "Que puis-je importer ?",
        "Images JPG, PNG et WebP jusqu'à 15 Mo chacune. La page traite une image à la fois."
      ]
    ]
  },
  linksTitle: "Poursuivre le workflow dans Miral AI",
  linksIntro: "Après la suppression d'arrière-plan, utilisez le PNG transparent dans d'autres outils Miral AI ou consultez un guide dédié pour l'étape suivante.",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "AI Object Remover",
      path: "/tools/object-remover"
    },
    {
      label: "AI Watermark Remover",
      path: "/tools/watermark-remover"
    },
    {
      label: "Guide e-commerce pour les fonds produit",
      path: "/hub/articles/ecommerce-product-background-removal"
    },
    {
      label: "Seedream 5",
      path: "/image-models/seedream-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "Importer l'image originale",
      text: "Choisissez un fichier JPG, PNG ou WebP de 15 Mo maximum."
    },
    {
      title: "Laisser l'IA trouver le sujet",
      text: "Miral supprime l'arrière-plan entier automatiquement ; aucun contour ni masque à dessiner."
    },
    {
      title: "Examiner les bords difficiles",
      text: "Zoomez sur les cheveux, lunettes, matériaux transparents, trous de produit et autres détails fins."
    },
    {
      title: "Télécharger le PNG transparent",
      text: "Enregistrez le résultat comme détourage réutilisable, puis placez-le sur le canevas final."
    }
  ],
  pros: [
    "Détection automatique du sujet sans contour manuel",
    "Prend en charge JPG, PNG et WebP",
    "Télécharge un PNG transparent réutilisable",
    "Utile pour portraits, produits, logos, signatures et animaux"
  ],
  cons: [
    "Cheveux et objets transparents nécessitent une vérification visuelle",
    "Un faible contraste sujet/fond peut dégrader les bords",
    "La page actuelle traite une image à la fois",
    "Les fichiers de plus de 15 Mo doivent d'abord être réduits"
  ],
  tips: [
    {
      title: "Vérifier deux couleurs de fond",
      text: "Placez le PNG transparent sur un fond sombre et un fond clair pour révéler halos et bords manquants."
    },
    {
      title: "Utiliser la source la plus nette",
      text: "Un original plus grand et plus net fonctionne généralement mieux qu'une petite capture recompressée plusieurs fois."
    },
    {
      title: "Protéger les détails fins",
      text: "Zoomez sur cheveux, moustaches, chaînes de bijoux, lacets, lunettes et interstices dans les poignées de produit."
    },
    {
      title: "Corriger halos blancs ou sombres",
      text: "Un halo vient souvent d'une contamination de couleur au bord d'origine. Réessayez avec une source plus nette et un contraste premier plan/arrière-plan plus fort."
    },
    {
      title: "Vérifier les matériaux transparents",
      text: "Le verre et l'emballage transparent laissent voir l'ancien fond ; comparez le résultat sur fond blanc et fond sombre."
    }
  ],
  scenarios: [
    {
      title: "Suppression d'arrière-plan pour portrait",
      text: "Vérifiez cheveux libres, boucles d'oreilles et lunettes avant d'utiliser le détourage en photo de profil ou affiche."
    },
    {
      title: "Suppression d'arrière-plan pour produit",
      text: "Inspectez poignées, trous, câbles, bords réfléchissants et emballages transparents."
    },
    {
      title: "Suppression d'arrière-plan pour logo ou signature",
      text: "Utilisez une source haute résolution pour conserver traits fins et découpes internes."
    },
    {
      title: "Suppression d'arrière-plan pour photo d'animal",
      text: "Choisissez un fond simple à fort contraste et examinez fourrure et moustaches en taille réelle."
    }
  ],
  toolFaq: [
    {
      q: "Comment supprimer un arrière-plan d'image en ligne ?",
      a: "Importez une image JPG, PNG ou WebP, laissez l'IA détecter et supprimer l'arrière-plan automatiquement, puis téléchargez le PNG transparent."
    },
    {
      q: "Dois-je sélectionner manuellement la personne ou le produit ?",
      a: "Non. Background Remover analyse l'image complète et détecte le premier plan automatiquement."
    },
    {
      q: "Pourquoi le résultat est-il téléchargé en PNG ?",
      a: "Le PNG prend en charge la transparence. Le JPG ne peut pas conserver un arrière-plan transparent."
    },
    {
      q: "Comment corriger un halo blanc après suppression ?",
      a: "Vérifiez d'abord le résultat sur un fond sombre, puis réessayez avec une source plus nette et un contraste sujet/fond plus net."
    },
    {
      q: "L'IA peut-elle supprimer l'arrière-plan autour des cheveux ou de la fourrure ?",
      a: "Oui, mais cheveux fins, moustaches et fourrure sont des bords difficiles à toujours vérifier en taille réelle."
    },
    {
      q: "Quelle différence entre fond transparent, blanc et remplacé ?",
      a: "Un PNG transparent n'a pas de fond fixe. Une image à fond blanc contient des pixels blancs ; un fond remplacé place le détourage dans une nouvelle scène ou couleur."
    },
    {
      q: "Pourquoi des parties d'un objet en verre manquent-elles ?",
      a: "Les objets transparents contiennent des couleurs de l'arrière-plan d'origine. Réessayez avec une source plus nette et à plus fort contraste, puis vérifiez la transparence manuellement."
    },
    {
      q: "Faut-il se connecter pour utiliser Background Remover ?",
      a: "Oui. Connectez-vous avant d'importer et de traiter l'image."
    },
    {
      q: "Miral AI Background Remover est-il gratuit ?",
      a: "Oui. La suppression d'arrière-plan est gratuite après connexion, sans logiciel supplémentaire à installer."
    },
    {
      q: "Quels formats et tailles de fichier sont pris en charge ?",
      a: "L'outil accepte des images JPG, PNG et WebP jusqu'à 15 Mo chacune."
    }
  ]
}

var frEcom = {
  overview: [
    "Pour le e-commerce, Miral AI Background Remover est gratuit après connexion. Créez un fichier maître PNG transparent propre, puis produisez versions fond blanc, couleur de marque, bannière et lifestyle à partir du même détourage.",
    "Miral AI Background Remover détecte automatiquement le produit après import d'une image JPG, PNG ou WebP jusqu'à 15 Mo. Aucune étape de masque manuel. Avant publication, inspectez poignées, chaînes, lacets, emballages transparents, verre, fourrure et métal réfléchissant.",
    "Amazon, Shopify, eBay, Etsy, Google Shopping et d'autres canaux ont des règles d'image différentes et évolutives. La suppression d'arrière-plan prépare l'asset, mais ne garantit pas automatiquement la conformité marketplace ; vérifiez les exigences actuelles pour le canal et la catégorie exacts."
  ],
  practice: [
    "Mon workflow préféré : photo produit source, suppression automatique, vérification des bords, fichier maître PNG transparent, puis mise en page par canal. Cela évite de refaire le détourage pour chaque boutique.",
    "Pour une image blanche pure, placez le PNG transparent sur un canevas blanc. Pour bannières Shopify ou publicités sociales, réutilisez le même détourage sur une couleur de marque ou continuez dans Seedream ou FLUX pour une scène lifestyle."
  ],
  compareIntro: "Utilisez Background Remover pour créer le fichier maître produit transparent, puis ajoutez un canevas blanc pour les fiches marketplace ou continuez dans Seedream et FLUX pour des images lifestyle.",
  workflow: "Importez une photo produit nette jusqu'à 15 Mo, laissez l'IA supprimer l'arrière-plan entier automatiquement, vérifiez les bords produit et téléchargez le fichier maître PNG transparent.",
  scenarioIntro: "Choisissez le scénario e-commerce le plus proche de votre produit, puis inspectez le bord produit détecté automatiquement avant de créer chaque mise en page par canal.",
  sec: {
    tldrTitle: "Le workflow recommandé",
    tldrCols: [
      "Étape",
      "À conserver",
      "À vérifier"
    ],
    tldrRows: [
      [
        "Supprimer l'arrière-plan",
        "Un fichier maître PNG transparent",
        "Bords, trous, pièces fines et matériaux transparents"
      ],
      [
        "Créer une version blanche",
        "Un export aplati séparé",
        "Marges et règles marketplace actuelles"
      ],
      [
        "Créer des versions de marque",
        "Fichiers pour cartes, bannières et publicités",
        "Couleur, forme, logo et texte d'emballage du produit"
      ],
      [
        "Archiver le maître",
        "Le PNG transparent vérifié",
        "Ne pas l'écraser avec un fond spécifique au canal"
      ]
    ],
    tldrP: "Miral AI Background Remover est gratuit après connexion. Je supprimerais l'arrière-plan une fois, conserverais ce maître transparent et construirais chaque version blanche, de marque ou lifestyle à partir de celui-ci. C'est plus propre que de redécouper le même produit pour chaque boutique.",
    workflowTitle: "De la photo source au détourage produit réutilisable",
    workflowP1: "Choisissez une photo où l'article entier est visible et net. Importez-la dans Miral AI Background Remover, laissez l'outil trouver le produit automatiquement, puis inspectez le résultat avant de télécharger le PNG.",
    workflowP2: "La dernière étape est facile à sauter. Vérifiez poignées, ports, lacets, chaînes, emballages transparents et tout interstice où l'ancien fond devrait transparaître. Ces détails déterminent si l'image reste crédible sur un nouveau canevas.",
    transTitle: "Pourquoi je garde d'abord la version transparente",
    transP: "Un PNG transparent est l'asset flexible. Il peut aller sur un canevas marketplace blanc pur aujourd'hui, une carte de marque Shopify demain et une bannière saisonnière le mois prochain. Si vous ne gardez que la version blanche, chaque nouveau fond repart d'un nettoyage.",
    transTipTitle: "Garder les calques séparés",
    transTipText: "Archivez le maître transparent et exportez les versions par canal en fichiers séparés. Les révisions deviennent bien moins pénibles.",
    platTitle: "Un maître, plusieurs vitrines",
    platCols: [
      "Canal",
      "Usage typique",
      "Note pratique"
    ],
    platRows: [
      [
        "Amazon",
        "Images produit principales et secondaires",
        "Ajoutez le blanc uniquement si requis, puis vérifiez la politique de catégorie actuelle"
      ],
      [
        "Shopify",
        "Cartes produit, pages collection et bannières",
        "La transparence s'accorde bien aux couleurs de thème et mises en page responsives"
      ],
      [
        "eBay",
        "Couverture de fiche et images galerie",
        "Cherchez des résidus autour de la silhouette produit"
      ],
      [
        "Etsy",
        "Couvertures et détails produits faits main",
        "Conservez matériaux et détails artisanaux fidèlement"
      ],
      [
        "Google Shopping",
        "Assets publicitaires produit",
        "Alignez l'article avec la page de destination et vérifiez les règles publicitaires actuelles"
      ]
    ],
    platP: "Les règles marketplace changent, et les catégories peuvent différer au sein d'une même marketplace. La suppression d'arrière-plan prépare le fichier ; elle ne certifie pas l'image finale pour une fiche particulière.",
    qualityTitle: "Les produits les plus faciles à rater",
    qualityItems: [
      "Verre, cristal et emballages transparents peuvent perdre leurs zones transparentes.",
      "Chaînes de bijoux, lacets et mailles peuvent se fragmenter en morceaux déconnectés.",
      "Produits blancs sur blanc et sombres sur sombre ont un contraste de bord faible.",
      "Polaire, fourrure et textiles doux demandent une vérification sur fond clair et sombre.",
      "Le métal réfléchissant peut conserver des couleurs de l'environnement d'origine."
    ],
    casesTitle: "Les produits à examiner de plus près",
    casesCols: [
      "Produit",
      "Échec fréquent",
      "Vérification"
    ],
    casesRows: [
      [
        "Vêtements et chaussures",
        "Tissu effiloché, lacets ou maille disparaissent",
        "Suivez le contour et chaque lacet qui se croise"
      ],
      [
        "Bijoux",
        "Chaînes cassées ou petites ouvertures comblées",
        "Zoomez sur maillons, griffes, crochets et espaces négatifs"
      ],
      [
        "Verre et emballage transparent",
        "Zones transparentes deviennent pleines ou incomplètes",
        "Vérifiez sur fond blanc et sombre"
      ],
      [
        "Emballages beauté",
        "Interstices de pompe et flacons transparents perdent des détails",
        "Protégez étiquettes, bords de bouchon et couleur réelle du produit"
      ],
      [
        "Électronique",
        "Ports, câbles et bords réfléchissants changent",
        "Confirmez chaque pièce incluse et connecteur"
      ],
      [
        "Mobilier",
        "Espace entre les pieds reste comblé",
        "Inspectez les interstices internes aussi soigneusement que le bord extérieur"
      ]
    ],
    acceptTitle: "Ma vérification avant publication",
    acceptItems: [
      "Pas de halo pâle, frange sombre, bord dentelé ni morceau de l'ancien fond.",
      "Poignées, trous, chaînes, lacets, mailles et autres espaces internes ouverts là où ils doivent l'être.",
      "Verre, plastique transparent, fourrure et métal réfléchissant ressemblent encore au matériau réel.",
      "Couleur, logo, texte d'emballage, ports et accessoires correspondent au produit source.",
      "Le maître transparent est enregistré séparément des exports blancs et lifestyle.",
      "Recadrage, marges, fond et contenu finaux respectent les règles marketplace actuelles."
    ],
    prosConsTitle: "Ce que ce workflow résout",
    miralTitle: "Construire la suite dans Miral AI",
    miralP: "Une fois le détourage validé, il peut passer à l'amélioration d'image ou une nouvelle scène commerciale. Continuez à vérifier l'identité produit : un fond soigné ne sert à rien si la forme du flacon, la couleur de la chaussure ou l'étiquette change.",
    miralLinksTitle: "Étapes suivantes",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "Guide général de suppression d'arrière-plan IA",
        path: "/hub/articles/ai-background-remover-online"
      },
      {
        label: "Seedream 5 images produit",
        path: "/image-models/seedream-ai-image-generator"
      },
      {
        label: "FLUX.2 photo produit",
        path: "/image-models/flux-2-ai-image-generator"
      },
      {
        label: "GPT Image affiches texte",
        path: "/image-models/gpt-image-ai-image-generator"
      }
    ],
    faqTitle: "Questions e-commerce fréquentes",
    faqItems: [
      [
        "La suppression d'arrière-plan produit est-elle gratuite dans Miral AI ?",
        "Oui. Connectez-vous pour utiliser le background remover gratuitement et télécharger le PNG transparent."
      ],
      [
        "Comment créer une image Amazon à fond blanc ?",
        "Supprimez l'arrière-plan d'origine, conservez le PNG transparent, placez une copie sur un canevas blanc pur, puis vérifiez les exigences actuelles de la catégorie exacte."
      ],
      [
        "Les images produit Shopify doivent-elles avoir un fond blanc ?",
        "Pas nécessairement. Les fichiers transparents sont souvent utiles pour cartes et bannières thématiques, mais le choix final dépend du design de la boutique."
      ],
      [
        "Quelle différence entre fond produit transparent et blanc ?",
        "Un PNG transparent n'a pas de fond fixe. Une image à fond blanc contient déjà des pixels blancs et ne peut pas révéler un autre canevas en dessous."
      ],
      [
        "Puis-je traiter tout un catalogue d'un coup ?",
        "La page actuelle traite une image à la fois."
      ],
      [
        "Pourquoi un produit en verre semble-t-il incomplet ?",
        "Le verre et l'emballage transparent contiennent des couleurs de l'ancien fond. Essayez une source plus nette avec un contraste plus clair et vérifiez les zones transparentes manuellement."
      ],
      [
        "Comment corriger une frange blanche autour du produit ?",
        "Affichez le PNG sur un fond sombre pour confirmer la frange, puis réessayez avec une source plus nette et un contraste plus fort autour du produit."
      ],
      [
        "Comment enregistrer l'image produit transparente ?",
        "Conservez un fichier maître PNG transparent sans fond fixe, puis exportez séparément versions blanches, de marque et lifestyle."
      ],
      [
        "Puis-je réutiliser une image sur toutes les marketplaces ?",
        "Réutilisez le maître transparent, mais exportez recadrage, marges et fond séparément pour chaque canal et catégorie."
      ],
      [
        "Puis-je transformer le détourage en image lifestyle ?",
        "Oui. Continuez avec le PNG transparent dans Seedream ou FLUX, puis vérifiez que forme, couleur, logo et emballage du produit restent exacts."
      ]
    ]
  },
  linksTitle: "Construire le workflow d'images produit dans Miral AI",
  linksIntro: "Conservez un fichier maître produit transparent, puis continuez dans Miral AI avec amélioration, génération de scènes commerciales ou design promotionnel orienté texte.",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "Guide général de suppression d'arrière-plan IA",
      path: "/hub/articles/ai-background-remover-online"
    },
    {
      label: "Seedream 5 images produit",
      path: "/image-models/seedream-ai-image-generator"
    },
    {
      label: "FLUX.2 photo produit",
      path: "/image-models/flux-2-ai-image-generator"
    },
    {
      label: "GPT Image affiches texte",
      path: "/image-models/gpt-image-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "Choisir une photo produit nette",
      text: "Utilisez un JPG, PNG ou WebP jusqu'à 15 Mo avec l'article entier visible et net."
    },
    {
      title: "Supprimer l'arrière-plan d'origine",
      text: "Miral AI détecte le produit et efface l'arrière-plan entier automatiquement, sans masque manuel."
    },
    {
      title: "Vérifier les détails produit",
      text: "Inspectez interstices internes, pièces fines, sections transparentes, fourrure, verre et bords réfléchissants."
    },
    {
      title: "Enregistrer le maître transparent",
      text: "Téléchargez le PNG avant d'ajouter un fond ou une mise en page spécifique à la marketplace."
    },
    {
      title: "Créer la version par canal",
      text: "Ajoutez un canevas blanc ou de marque, puis vérifiez les exigences actuelles de la marketplace cible."
    }
  ],
  pros: [
    "Un maître transparent peut servir plusieurs canaux de vente",
    "La détection automatique du produit évite le contour manuel",
    "Facilite la standardisation des fonds et marges en boutique",
    "Le détourage peut continuer vers des scènes Seedream ou FLUX"
  ],
  cons: [
    "Les exigences marketplace doivent encore être vérifiées avant publication",
    "Verre, fourrure, chaînes fines et matériaux réfléchissants demandent une revue manuelle",
    "La suppression d'arrière-plan ne fait pas le dimensionnement et la mise en page marketplace finaux",
    "L'outil actuel traite une image à la fois"
  ],
  tips: [
    {
      title: "Séparer suppression et mise en page",
      text: "Conservez le maître PNG transparent, puis créez dérivés fond blanc et de marque sans refaire le détourage."
    },
    {
      title: "Inspecter les matériaux difficiles",
      text: "Verre, emballage transparent, chaînes de bijoux, fourrure et métal réfléchissant sont les premiers endroits à vérifier."
    },
    {
      title: "Vérifier les règles marketplace actuelles",
      text: "Taille d'image, fond, cadrage et politiques de contenu peuvent changer et varier par catégorie."
    },
    {
      title: "Utiliser une checklist d'acceptation produit",
      text: "Confirmez contour, interstices internes, couleur, logo, texte d'emballage, ports, accessoires et zones transparentes avant publication."
    },
    {
      title: "Garder un seul maître transparent",
      text: "Stockez le PNG transparent vérifié séparément, puis dérivez chaque version blanche, de marque et lifestyle de ce fichier."
    }
  ],
  scenarios: [
    {
      title: "Images produit Amazon fond blanc",
      text: "Placez le PNG transparent vérifié sur un canevas blanc pur, puis vérifiez les exigences de catégorie actuelles."
    },
    {
      title: "Cartes produit et bannières Shopify",
      text: "Réutilisez le produit transparent sur cartes responsives, couleurs de marque et compositions de page d'accueil."
    },
    {
      title: "Images de fiche eBay et Etsy",
      text: "Gardez l'article complet et fidèle, et inspectez le bord pour résidus d'arrière-plan avant import."
    },
    {
      title: "Créatif e-commerce cross-border",
      text: "Créez plusieurs tailles par canal à partir d'un maître PNG transparent en préservant forme, couleur et branding réels du produit."
    },
    {
      title: "Publicités produit Google Shopping",
      text: "Alignez l'article avec la page de destination et créez des assets depuis le maître transparent selon les règles publicitaires actuelles."
    }
  ],
  toolFaq: [
    {
      q: "La suppression d'arrière-plan produit e-commerce est-elle gratuite dans Miral AI ?",
      a: "Oui. Connectez-vous pour utiliser la suppression d'arrière-plan gratuitement et télécharger le PNG transparent."
    },
    {
      q: "Comment créer une image produit Amazon à fond blanc ?",
      a: "Supprimez l'arrière-plan source, téléchargez le PNG transparent, placez-le sur un canevas blanc pur et vérifiez les exigences actuelles de la catégorie produit."
    },
    {
      q: "Une image produit Shopify doit-elle obligatoirement avoir un fond blanc ?",
      a: "Pas toujours. Un PNG transparent est utile pour cartes et bannières couleur de marque ; choisissez le fond final selon le thème et la mise en page de la boutique."
    },
    {
      q: "Quelle différence entre fond transparent et blanc ?",
      a: "Une image transparente n'a pas de fond fixe et peut aller sur n'importe quel canevas. Une image à fond blanc contient des pixels blancs."
    },
    {
      q: "Puis-je supprimer l'arrière-plan d'un catalogue entier d'un coup ?",
      a: "La page Background Remover actuelle traite une image à la fois, donc cet article ne prétend pas à un workflow par lot."
    },
    {
      q: "Pourquoi un produit en verre semble incomplet après suppression ?",
      a: "Transparence et reflets sont difficiles à séparer. Réessayez avec une image plus nette et un contraste plus fort, puis vérifiez le résultat manuellement."
    },
    {
      q: "Comment corriger un halo blanc autour d'un détourage produit ?",
      a: "Placez le PNG transparent sur un fond sombre pour localiser le halo, puis réessayez avec une source plus haute résolution et un contraste de bord plus fort."
    },
    {
      q: "Que vérifier avant de publier un détourage produit ?",
      a: "Vérifiez en taille réelle contour, trous, chaînes, lacets, transparence, couleur, logo, texte d'emballage, ports et accessoires inclus."
    },
    {
      q: "La même image produit peut-elle servir sur toutes les marketplaces ?",
      a: "Réutilisez le maître PNG transparent, mais créez tailles, cadrage, marges et fonds finaux pour chaque marketplace et politique de catégorie actuelle."
    },
    {
      q: "Puis-je transformer le détourage en image lifestyle produit ?",
      a: "Oui. Continuez avec le PNG transparent dans Seedream ou FLUX, et vérifiez que structure, couleur et branding du produit restent exacts."
    }
  ]
}

var frArticles = {
  "ai-background-remover-online": {
    title: "Suppression d'arrière-plan IA gratuite pour créer un PNG transparent en ligne",
    excerpt: "Supprimez gratuitement l'arrière-plan d'une image : importez un JPG, PNG ou WebP, laissez l'IA détecter le sujet et téléchargez un PNG transparent.",
    metaTitle: "Suppression d'arrière-plan IA gratuite en ligne | Miral",
    metaDescription: "Utilisez Miral AI Background Remover gratuitement après connexion pour supprimer automatiquement les arrière-plans photo et exporter des détourages PNG transparents.",
    target: {
      label: "Ouvrir la suppression d’arrière-plan",
      path: "/tools/background-remover"
    }
  },
  "ecommerce-product-background-removal": {
    title: "Suppression d'arrière-plan produit IA gratuite pour images e-commerce",
    excerpt: "Supprimez gratuitement les arrière-plans produit et créez des PNG transparents ou des images à fond blanc pour Amazon, Shopify, eBay et Etsy.",
    metaTitle: "Suppression d'arrière-plan produit e-commerce gratuite | Miral",
    metaDescription: "Utilisez Miral AI gratuitement après connexion pour supprimer les arrière-plans produit, exporter des PNG transparents et préparer des images e-commerce à fond blanc.",
    target: {
      label: "Ouvrir la suppression d’arrière-plan produit",
      path: "/tools/background-remover"
    }
  }
}

var esBg = {
  overview: [
    "Miral AI Background Remover es gratuito tras iniciar sesión. Analiza la imagen completa, separa el sujeto en primer plano de su entorno y elimina el fondo automáticamente, sin máscara dibujada a mano.",
    "Sube una imagen JPG, PNG o WebP de hasta 15 MB, revisa el cabello, los materiales transparentes, los orificios pequeños y los bordes de bajo contraste, y descarga el resultado como PNG transparente.",
    "El PNG transparente puede seguir en el flujo de Miral AI para mejora, limpieza de objetos o una nueva escena de producto. Un fondo transparente no es lo mismo que un fondo blanco: añade una capa blanca después si una marketplace lo exige."
  ],
  practice: [
    "La fuente más fiable tiene un sujeto completo, bordes nítidos y contraste claro entre primer plano y fondo. Las capturas recompresas y el desenfoque de movimiento dificultan separar los detalles finos.",
    "Reviso cada resultado sobre un lienzo oscuro y uno claro. Así aparecen halos blancos, bordes oscuros, huecos omitidos y mechones eliminados que pueden pasar desapercibidos en la vista previa predeterminada."
  ],
  compareIntro: "Usa AI Background Remover cuando todo el fondo deba desaparecer automáticamente. Usa Watermark Remover u Object Remover cuando solo haya que eliminar una marca u objeto concreto.",
  workflow: "Sube una imagen JPG, PNG o WebP de hasta 15 MB, deja que la IA detecte el primer plano automáticamente, revisa los bordes finos y descarga el PNG transparente.",
  scenarioIntro: "Elige el escenario más cercano a tu imagen original y revisa los bordes detectados automáticamente que más importan para ese sujeto.",
  sec: {
    tldrTitle: "Lo esencial",
    tldrCols: [
      "Qué saber",
      "Detalles"
    ],
    tldrRows: [
      [
        "Precio",
        "Gratis tras iniciar sesión"
      ],
      [
        "Subida",
        "Una imagen JPG, PNG o WebP (máx. 15 MB)"
      ],
      [
        "Proceso",
        "Detección automática del sujeto; sin contorno ni máscara que dibujar"
      ],
      [
        "Descarga",
        "Un PNG transparente"
      ],
      [
        "Conviene revisar",
        "Cabello, vidrio, pelaje, huecos finos y bordes de bajo contraste"
      ]
    ],
    tldrP: "Para un retrato o foto de producto sencillo, el trabajo suele ser subir, esperar, revisar y descargar. La revisión importa: un recorte puede verse bien en miniatura y mostrar un borde pálido sobre un diseño oscuro.",
    whatTitle: "Qué hace realmente la herramienta",
    whatP1: "Miral AI Background Remover lee la imagen completa y decide qué píxeles pertenecen al primer plano. Es mucho más rápido que trazar el sujeto con la pluma y no hay que acertar una selección antes del procesamiento.",
    whatP2: "El resultado es un PNG con transparencia, no un JPG pintado de blanco. Puedes colocar ese archivo sobre una ficha blanca, un color de marca o una escena totalmente nueva sin volver a recortar el sujeto.",
    whatTipTitle: "Una distinción útil",
    whatTipText: "Transparente y blanco no son intercambiables. La transparencia deja el lienzo abierto; un fondo blanco lo rellena permanentemente con píxeles blancos.",
    howTitle: "Un flujo sencillo en cuatro pasos",
    howP: "Empieza con el archivo original si lo tienes. Las capturas pasadas por apps de mensajería suelen tener bordes más suaves, lo que complica separar cabello fino y materiales transparentes.",
    edgeTitle: "Dónde mirar antes de descargar",
    edgeCols: [
      "Imagen",
      "Revisar de cerca",
      "Por qué"
    ],
    edgeRows: [
      [
        "Retrato",
        "Cabello suelto, gafas, pendientes",
        "Los detalles finos se recortan con facilidad"
      ],
      [
        "Producto",
        "Asas, orificios, cables, cordones",
        "El fondo puede quedar dentro de huecos cerrados"
      ],
      [
        "Vidrio o empaque transparente",
        "Reflejos y bordes translúcidos",
        "El fondo original se ve a través del objeto"
      ],
      [
        "Logo o firma",
        "Trazos finos y contras",
        "Los huecos pequeños pueden cerrarse"
      ],
      [
        "Mascota",
        "Pelaje y bigotes",
        "Una miniatura puede ocultar mechones faltantes"
      ]
    ],
    edgeP: "Coloco el PNG descargado sobre un lienzo claro y uno oscuro. Esa comprobación rápida revela halos pálidos y bordes oscuros, más fiable que juzgar solo la vista previa de cuadros.",
    bgTitle: "¿Transparente, blanco o fondo reemplazado?",
    bgCols: [
      "Resultado",
      "Qué contiene",
      "Mejor uso"
    ],
    bgRows: [
      [
        "Fondo transparente",
        "Sin color de fondo fijo; guardado como PNG",
        "Logos, fotos de perfil, recursos de diseño y recortes de producto reutilizables"
      ],
      [
        "Fondo blanco",
        "Una capa blanca bajo el recorte",
        "Fichas de producto, fotos de identificación y diseños que exigen blanco"
      ],
      [
        "Fondo color de marca",
        "Color sólido o degradado bajo el sujeto",
        "Gráficos de campaña, tarjetas de perfil e identidad visual"
      ],
      [
        "Nueva escena",
        "Recorte colocado en otro entorno",
        "Imágenes lifestyle de producto y composiciones creativas"
      ]
    ],
    bgP: "Guardo primero el PNG transparente y creo las versiones blancas o de color después. JPG no puede almacenar píxeles transparentes, así que no sirve como archivo maestro reutilizable.",
    troubleTitle: "Si el recorte se ve mal",
    troubleCols: [
      "Problema",
      "Causa probable",
      "Qué probar"
    ],
    troubleRows: [
      [
        "Borde blanco u oscuro",
        "Color del fondo antiguo que permanece en el borde",
        "Reintentar con una fuente más nítida y mayor contraste"
      ],
      [
        "Desaparece cabello o bigotes",
        "La fuente es pequeña, borrosa o muy comprimida",
        "Usar la foto original y revisar a tamaño real"
      ],
      [
        "Queda fondo en un asa",
        "Un hueco cerrado se interpretó como parte del sujeto",
        "Probar un ángulo más claro con el hueco más visible"
      ],
      [
        "El vidrio se ve incompleto",
        "La transparencia contiene colores de la escena anterior",
        "Usar un fondo más limpio y revisar el resultado manualmente"
      ],
      [
        "Bordes blanco sobre blanco desaparecen",
        "Primer plano y fondo demasiado similares",
        "Elegir una foto con más contraste"
      ]
    ],
    prosConsTitle: "Dónde ayuda — y dónde hace falta criterio",
    bestTitle: "Hábitos que mejoran el resultado",
    bestItems: [
      "Usa la foto original en lugar de una miniatura guardada desde una app de chat.",
      "Elige una imagen donde el sujeto completo sea visible y esté enfocado.",
      "Si el sujeto se confunde con el fondo, prueba otra foto con contraste más claro.",
      "Revisa el PNG sobre un lienzo claro y uno oscuro antes de usarlo.",
      "Comprueba productos blancos sobre un lienzo oscuro; allí se ven mucho mejor los restos.",
      "Procesa las imágenes importantes de una en una para revisar bien cada borde."
    ],
    miralTitle: "Seguir trabajando en Miral AI",
    miralP: "Una vez eliminado el fondo, el PNG transparente es un archivo maestro útil. Puedes afilarlo, quitar un objeto suelto, limpiar una marca de agua autorizada o convertir el producto en una nueva escena comercial.",
    miralLinksTitle: "Próximos pasos",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "AI Object Remover",
        path: "/tools/object-remover"
      },
      {
        label: "AI Watermark Remover",
        path: "/tools/watermark-remover"
      },
      {
        label: "Guía de fondos para productos e-commerce",
        path: "/hub/articles/ecommerce-product-background-removal"
      },
      {
        label: "Seedream 5",
        path: "/image-models/seedream-ai-image-generator"
      }
    ],
    faqTitle: "Preguntas frecuentes en la práctica",
    faqItems: [
      [
        "¿Cómo hacer transparente el fondo de una imagen en línea?",
        "Sube JPG, PNG o WebP, espera la eliminación automática del fondo y descarga el PNG transparente."
      ],
      [
        "¿Miral AI Background Remover es gratis?",
        "Sí. Inicia sesión, sube una imagen y usa la eliminación de fondo gratis. No hace falta software de escritorio adicional."
      ],
      [
        "¿Hay que iniciar sesión?",
        "Sí. Inicia sesión antes de subir, pero la función de eliminación de fondo es gratuita."
      ],
      [
        "¿Debo trazar el contorno del sujeto?",
        "No. La herramienta detecta el primer plano en toda la imagen automáticamente."
      ],
      [
        "¿Por qué la descarga es PNG?",
        "PNG puede conservar píxeles transparentes. JPG no puede."
      ],
      [
        "¿La eliminación de fondo cambia las dimensiones?",
        "Comprueba las dimensiones en píxeles del archivo descargado con tu diseño final antes de publicar, sobre todo si una marketplace o plantilla exige un tamaño fijo."
      ],
      [
        "¿Cómo corregir un halo blanco alrededor del recorte?",
        "Mira el PNG sobre un lienzo oscuro y reintenta con una fuente más nítida y mayor contraste alrededor del sujeto."
      ],
      [
        "¿Puede manejar cabello y pelaje de mascotas?",
        "Sí, pero los mechones finos merecen una revisión a tamaño real sobre fondo claro y oscuro."
      ],
      [
        "¿En qué se diferencia la eliminación de fondo con IA de una goma de fondo?",
        "La eliminación con IA encuentra el sujeto automáticamente. Una goma tradicional suele pedir borrar áreas a mano."
      ],
      [
        "¿Por qué un sujeto blanco desaparece sobre fondo blanco?",
        "El borde tiene muy poco contraste. Una foto con fondo más oscuro o más distinto da al modelo un límite más claro."
      ],
      [
        "¿Por qué falta parte de mi producto de vidrio?",
        "El vidrio refleja y transmite el fondo antiguo, así que el límite es ambiguo. Una foto nítida sobre fondo contrastado da un mejor punto de partida al modelo."
      ],
      [
        "¿Qué puedo subir?",
        "Imágenes JPG, PNG y WebP de hasta 15 MB cada una. La página procesa una imagen a la vez."
      ]
    ]
  },
  linksTitle: "Continuar el flujo en Miral AI",
  linksIntro: "Tras eliminar el fondo, usa el PNG transparente en otras herramientas de Miral AI o sigue con una guía enfocada para el siguiente paso.",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "AI Object Remover",
      path: "/tools/object-remover"
    },
    {
      label: "AI Watermark Remover",
      path: "/tools/watermark-remover"
    },
    {
      label: "Guía de fondos para productos e-commerce",
      path: "/hub/articles/ecommerce-product-background-removal"
    },
    {
      label: "Seedream 5",
      path: "/image-models/seedream-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "Subir la imagen original",
      text: "Elige un archivo JPG, PNG o WebP de no más de 15 MB."
    },
    {
      title: "Dejar que la IA encuentre el sujeto",
      text: "Miral elimina todo el fondo automáticamente; no hay contorno ni máscara que dibujar."
    },
    {
      title: "Revisar los bordes difíciles",
      text: "Amplía cabello, gafas, materiales transparentes, orificios de producto y otros detalles finos."
    },
    {
      title: "Descargar el PNG transparente",
      text: "Guarda el resultado como recorte reutilizable y colócalo en el lienzo final."
    }
  ],
  pros: [
    "Detección automática del sujeto sin contorno manual",
    "Admite JPG, PNG y WebP",
    "Descarga un PNG transparente reutilizable",
    "Útil para retratos, productos, logos, firmas y mascotas"
  ],
  cons: [
    "Cabello y objetos transparentes aún necesitan revisión visual",
    "Bajo contraste entre sujeto y fondo puede reducir la calidad del borde",
    "La página actual procesa una imagen a la vez",
    "Los archivos de más de 15 MB deben reducirse primero"
  ],
  tips: [
    {
      title: "Comprobar dos colores de fondo",
      text: "Coloca el PNG transparente sobre fondo oscuro y claro para revelar halos y bordes faltantes."
    },
    {
      title: "Usar la fuente más nítida",
      text: "Un original más grande y nítido suele funcionar mejor que una captura pequeña recompresa varias veces."
    },
    {
      title: "Proteger los detalles finos",
      text: "Amplía cabello, bigotes, cadenas de joyería, cordones, gafas y huecos dentro de asas de producto."
    },
    {
      title: "Corregir halos blancos u oscuros",
      text: "Un halo suele venir de contaminación de color en el borde original. Reintenta con una fuente más nítida y mayor contraste primer plano/fondo."
    },
    {
      title: "Revisar materiales transparentes",
      text: "El vidrio y el empaque transparente muestran el fondo antiguo; compara el resultado sobre lienzo blanco y oscuro."
    }
  ],
  scenarios: [
    {
      title: "Eliminación de fondo en retratos",
      text: "Revisa cabello suelto, pendientes y gafas antes de usar el recorte en foto de perfil o póster."
    },
    {
      title: "Eliminación de fondo en productos",
      text: "Inspecciona asas, orificios, cables, bordes reflectantes y empaques transparentes."
    },
    {
      title: "Eliminación de fondo en logos o firmas",
      text: "Usa una fuente de alta resolución para conservar trazos finos y recortes internos."
    },
    {
      title: "Eliminación de fondo en fotos de mascotas",
      text: "Elige un fondo simple con buen contraste e inspecciona pelaje y bigotes a tamaño real."
    }
  ],
  toolFaq: [
    {
      q: "¿Cómo eliminar el fondo de una imagen en línea?",
      a: "Sube JPG, PNG o WebP, deja que la IA detecte y elimine el fondo automáticamente y descarga el PNG transparente."
    },
    {
      q: "¿Debo seleccionar manualmente la persona o el producto?",
      a: "No. Background Remover analiza la imagen completa y detecta el primer plano automáticamente."
    },
    {
      q: "¿Por qué el resultado se descarga como PNG?",
      a: "PNG admite transparencia. JPG no puede conservar un fondo transparente."
    },
    {
      q: "¿Cómo corregir un halo blanco tras eliminar el fondo?",
      a: "Revisa primero el resultado sobre un lienzo oscuro y reintenta con una fuente más nítida y contraste sujeto/fondo más claro."
    },
    {
      q: "¿La IA puede eliminar fondos alrededor del cabello o pelaje?",
      a: "Sí, pero cabello fino, bigotes y pelaje son bordes difíciles que siempre conviene revisar a tamaño real."
    },
    {
      q: "¿Qué diferencia hay entre fondo transparente, blanco y reemplazado?",
      a: "Un PNG transparente no tiene fondo fijo. Una imagen con fondo blanco contiene píxeles blancos; un fondo reemplazado coloca el recorte en una nueva escena o color."
    },
    {
      q: "¿Por qué faltan partes de un objeto de vidrio?",
      a: "Los objetos transparentes contienen colores del fondo original. Reintenta con una fuente más nítida y de mayor contraste y revisa la transparencia manualmente."
    },
    {
      q: "¿Hay que iniciar sesión para usar Background Remover?",
      a: "Sí. Inicia sesión antes de subir y procesar la imagen."
    },
    {
      q: "¿Miral AI Background Remover es gratis?",
      a: "Sí. La eliminación de fondo es gratuita tras iniciar sesión, sin software adicional que instalar."
    },
    {
      q: "¿Qué formatos y tamaños de archivo admite?",
      a: "Acepta imágenes JPG, PNG y WebP de hasta 15 MB cada una."
    }
  ]
}

var esEcom = {
  overview: [
    "Para e-commerce, Miral AI Background Remover es gratuito tras iniciar sesión. Crea un archivo maestro PNG transparente limpio y luego produce versiones de fondo blanco, color de marca, banner y lifestyle con el mismo recorte.",
    "Miral AI Background Remover detecta el producto automáticamente tras subir una imagen JPG, PNG o WebP de hasta 15 MB. No hay paso de máscara manual. Antes de publicar, revisa asas, cadenas, cordones, empaques transparentes, vidrio, pelaje y metal reflectante.",
    "Amazon, Shopify, eBay, Etsy, Google Shopping y otros canales pueden tener reglas de imagen distintas y cambiantes. La eliminación de fondo prepara el activo, pero no garantiza automáticamente el cumplimiento de marketplace; verifica los requisitos actuales del canal y categoría exactos."
  ],
  practice: [
    "Mi flujo preferido es foto de producto original, eliminación automática de fondo, revisión de bordes, archivo maestro PNG transparente y solo entonces diseño por canal. Así evito repetir el recorte en cada tienda.",
    "Para una imagen blanca pura, coloca el PNG transparente sobre un lienzo blanco. Para banners de Shopify o anuncios sociales, reutiliza el mismo recorte sobre un color de marca o continúa en Seedream o FLUX para una escena lifestyle."
  ],
  compareIntro: "Usa Background Remover para crear el archivo maestro de producto transparente, luego añade un lienzo blanco para fichas de marketplace o continúa en Seedream y FLUX para imágenes lifestyle.",
  workflow: "Sube una foto de producto nítida de hasta 15 MB, deja que la IA elimine todo el fondo automáticamente, revisa los bordes del producto y descarga el archivo maestro PNG transparente.",
  scenarioIntro: "Elige el escenario e-commerce más cercano a tu producto y revisa el borde detectado automáticamente antes de crear cada diseño por canal.",
  sec: {
    tldrTitle: "El flujo que recomiendo",
    tldrCols: [
      "Etapa",
      "Conservar",
      "Revisar"
    ],
    tldrRows: [
      [
        "Eliminar el fondo",
        "Un archivo maestro PNG transparente",
        "Bordes, orificios, piezas finas y materiales transparentes"
      ],
      [
        "Crear versión blanca",
        "Una exportación aplanada separada",
        "Espaciado y reglas actuales de marketplace"
      ],
      [
        "Crear versiones de marca",
        "Archivos para tarjetas, banners y anuncios",
        "Color, forma, logo y texto del empaque del producto"
      ],
      [
        "Archivar el maestro",
        "El PNG transparente revisado",
        "No sobrescribirlo con un fondo específico del canal"
      ]
    ],
    tldrP: "Miral AI Background Remover es gratis tras iniciar sesión. Eliminaría el fondo una vez, conservaría ese maestro transparente y construiría cada versión blanca, de marca o lifestyle a partir de él. Es más limpio que volver a recortar el mismo producto para cada tienda.",
    workflowTitle: "De la foto original al recorte de producto reutilizable",
    workflowP1: "Elige una fotografía donde el artículo completo sea visible y esté enfocado. Súbela a Miral AI Background Remover, deja que la herramienta encuentre el producto automáticamente e inspecciona el resultado antes de descargar el PNG.",
    workflowP2: "La última parte es fácil de saltarse. Revisa asas, puertos, cordones, cadenas, empaques transparentes y cualquier hueco donde el fondo antiguo debería verse. Esos detalles deciden si la imagen sigue siendo creíble en un lienzo nuevo.",
    transTitle: "Por qué guardo primero la versión transparente",
    transP: "Un PNG transparente es el activo flexible. Puede ir hoy a un lienzo blanco puro de marketplace, mañana a una tarjeta de marca de Shopify y el mes que viene a un banner de temporada. Si solo guardas la versión blanca, cada fondo nuevo empieza con otra limpieza.",
    transTipTitle: "Mantener las capas separadas",
    transTipText: "Archiva el maestro transparente y exporta las versiones por canal como archivos separados. Las revisiones son mucho menos dolorosas.",
    platTitle: "Un maestro, distintas tiendas",
    platCols: [
      "Canal",
      "Uso típico",
      "Nota práctica"
    ],
    platRows: [
      [
        "Amazon",
        "Imágenes de producto principales y secundarias",
        "Añade blanco solo cuando haga falta y revisa la política de categoría actual"
      ],
      [
        "Shopify",
        "Tarjetas de producto, páginas de colección y banners",
        "La transparencia encaja bien con colores de tema y diseños responsivos"
      ],
      [
        "eBay",
        "Portada de ficha e imágenes de galería",
        "Busca restos alrededor de la silueta del producto"
      ],
      [
        "Etsy",
        "Portadas y detalles de productos hechos a mano",
        "Mantén materiales y detalle artesanal fieles"
      ],
      [
        "Google Shopping",
        "Activos publicitarios de producto",
        "Coincide el artículo con la página de destino y verifica las reglas publicitarias actuales"
      ]
    ],
    platP: "Las reglas de marketplace cambian y las categorías pueden diferir dentro de la misma marketplace. La eliminación de fondo prepara el archivo; no certifica la imagen final para una ficha concreta.",
    qualityTitle: "Los productos más fáciles de fallar",
    qualityItems: [
      "Vidrio, cristal y empaques transparentes pueden perder sus áreas transparentes.",
      "Cadenas de joyería, cordones y mallas pueden romperse en piezas desconectadas.",
      "Productos blancos sobre blanco y oscuros sobre oscuro tienen contraste de borde débil.",
      "Polar, pelaje y textiles suaves necesitan revisión sobre fondos claros y oscuros.",
      "El metal reflectante puede conservar colores del entorno original."
    ],
    casesTitle: "Los productos que merecen una mirada más atenta",
    casesCols: [
      "Producto",
      "Fallo habitual",
      "Revisión"
    ],
    casesRows: [
      [
        "Ropa y calzado",
        "Desaparecen deshilachados, cordones o malla",
        "Sigue el contorno y cada cordón que se cruza"
      ],
      [
        "Joyería",
        "Se rompen cadenas o se rellenan aberturas pequeñas",
        "Amplía eslabones, garras, ganchos y espacio negativo"
      ],
      [
        "Vidrio y empaque transparente",
        "Las áreas transparentes se vuelven sólidas o incompletas",
        "Revisa sobre fondos blanco y oscuro"
      ],
      [
        "Empaque de belleza",
        "Huecos de bomba y botellas transparentes pierden detalle",
        "Protege etiquetas, bordes de tapa y color real del producto"
      ],
      [
        "Electrónica",
        "Cambian puertos, cables y bordes reflectantes",
        "Confirma cada pieza incluida y conector"
      ],
      [
        "Muebles",
        "El espacio entre patas queda relleno",
        "Inspecciona los huecos internos con el mismo cuidado que el borde exterior"
      ]
    ],
    acceptTitle: "Mi comprobación previa a publicar",
    acceptItems: [
      "Sin halo pálido, borde oscuro, borde dentado ni parche del fondo antiguo.",
      "Asas, orificios, cadenas, cordones, mallas y otros espacios internos abiertos donde deben estarlo.",
      "Vidrio, plástico transparente, pelaje y metal reflectante siguen pareciendo el material real.",
      "Color, logo, texto del empaque, puertos y accesorios coinciden con el producto original.",
      "El maestro transparente se guarda aparte de las exportaciones blancas y lifestyle.",
      "Recorte, espaciado, fondo y contenido finales siguen las reglas actuales de la marketplace."
    ],
    prosConsTitle: "Qué resuelve este flujo",
    miralTitle: "Construir el resto en Miral AI",
    miralP: "Tras pasar la revisión, el recorte puede ir a mejora de imagen o una nueva escena comercial. Sigue comprobando la identidad del producto; un fondo pulido no sirve si cambia la forma del frasco, el color del zapato o la etiqueta del paquete.",
    miralLinksTitle: "Próximos pasos",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "Guía general de eliminación de fondo con IA",
        path: "/hub/articles/ai-background-remover-online"
      },
      {
        label: "Seedream 5 imágenes de producto",
        path: "/image-models/seedream-ai-image-generator"
      },
      {
        label: "FLUX.2 fotografía de producto",
        path: "/image-models/flux-2-ai-image-generator"
      },
      {
        label: "GPT Image pósters con texto",
        path: "/image-models/gpt-image-ai-image-generator"
      }
    ],
    faqTitle: "Preguntas frecuentes de e-commerce",
    faqItems: [
      [
        "¿La eliminación de fondo de producto es gratis en Miral AI?",
        "Sí. Inicia sesión para usar el background remover gratis y descargar el PNG transparente."
      ],
      [
        "¿Cómo hacer una imagen de Amazon con fondo blanco?",
        "Elimina el fondo original, conserva el PNG transparente, coloca una copia sobre un lienzo blanco puro y revisa los requisitos actuales de la categoría exacta."
      ],
      [
        "¿Las imágenes de producto de Shopify deben tener fondo blanco?",
        "No necesariamente. Los archivos transparentes suelen ser útiles para tarjetas y banners temáticos, pero la decisión final depende del diseño de la tienda."
      ],
      [
        "¿Qué diferencia hay entre fondo de producto transparente y blanco?",
        "Un PNG transparente no tiene fondo fijo. Una imagen con fondo blanco ya contiene píxeles blancos y no puede mostrar otro lienzo debajo."
      ],
      [
        "¿Puedo procesar todo un catálogo de una vez?",
        "La página actual procesa una imagen a la vez."
      ],
      [
        "¿Por qué un producto de vidrio se ve incompleto?",
        "El vidrio y el empaque transparente contienen colores del fondo antiguo. Prueba una fuente más nítida con contraste más claro y revisa las áreas transparentes manualmente."
      ],
      [
        "¿Cómo corregir un borde blanco alrededor del producto?",
        "Mira el PNG sobre un lienzo oscuro para confirmar el borde y reintenta con una fuente más nítida y mayor contraste alrededor del producto."
      ],
      [
        "¿Cómo guardar la imagen de producto transparente?",
        "Conserva un archivo maestro PNG transparente sin fondo fijo y exporta por separado versiones blancas, de marca y lifestyle."
      ],
      [
        "¿Puedo reutilizar una imagen en todas las marketplaces?",
        "Reutiliza el maestro transparente, pero exporta recorte, espaciado y fondo por separado para cada canal y categoría."
      ],
      [
        "¿Puedo convertir el recorte en imagen lifestyle?",
        "Sí. Continúa con el PNG transparente en Seedream o FLUX y comprueba que forma, color, logo y empaque del producto sigan siendo exactos."
      ]
    ]
  },
  linksTitle: "Construir el flujo de imágenes de producto en Miral AI",
  linksIntro: "Conserva un archivo maestro de producto transparente y continúa en Miral AI con mejora, generación de escenas comerciales o diseño promocional orientado a texto.",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "Guía general de eliminación de fondo con IA",
      path: "/hub/articles/ai-background-remover-online"
    },
    {
      label: "Seedream 5 imágenes de producto",
      path: "/image-models/seedream-ai-image-generator"
    },
    {
      label: "FLUX.2 fotografía de producto",
      path: "/image-models/flux-2-ai-image-generator"
    },
    {
      label: "GPT Image pósters con texto",
      path: "/image-models/gpt-image-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "Elegir una foto de producto nítida",
      text: "Usa JPG, PNG o WebP de hasta 15 MB con el artículo completo visible y enfocado."
    },
    {
      title: "Eliminar el fondo original",
      text: "Miral AI detecta el producto y borra todo el fondo automáticamente, sin máscara manual."
    },
    {
      title: "Revisar los detalles del producto",
      text: "Inspecciona huecos internos, piezas finas, secciones transparentes, pelaje, vidrio y bordes reflectantes."
    },
    {
      title: "Guardar el maestro transparente",
      text: "Descarga el PNG antes de añadir un fondo o diseño específico de marketplace."
    },
    {
      title: "Crear la versión por canal",
      text: "Añade un lienzo blanco o de marca y verifica los requisitos actuales de la marketplace de destino."
    }
  ],
  pros: [
    "Un maestro transparente puede servir varios canales de venta",
    "La detección automática del producto ahorra tiempo de contorno manual",
    "Facilita estandarizar fondos y espaciado en la tienda",
    "El recorte puede continuar en escenas de Seedream o FLUX"
  ],
  cons: [
    "Los requisitos de marketplace deben revisarse antes de publicar",
    "Vidrio, pelaje, cadenas finas y materiales reflectantes necesitan revisión manual",
    "La eliminación de fondo no hace el dimensionado y diseño final de marketplace",
    "La herramienta actual procesa una imagen a la vez"
  ],
  tips: [
    {
      title: "Separar eliminación y diseño",
      text: "Conserva el maestro PNG transparente y crea derivados de fondo blanco y de marca sin repetir el recorte."
    },
    {
      title: "Inspeccionar materiales difíciles",
      text: "Vidrio, empaque transparente, cadenas de joyería, pelaje y metal reflectante son los primeros puntos a revisar."
    },
    {
      title: "Verificar reglas actuales de marketplace",
      text: "Tamaño de imagen, fondo, encuadre y políticas de contenido pueden cambiar y variar por categoría."
    },
    {
      title: "Usar una lista de aceptación de producto",
      text: "Confirma contorno, huecos internos, color, logo, texto del empaque, puertos, accesorios y áreas transparentes antes de publicar."
    },
    {
      title: "Mantener un solo maestro transparente",
      text: "Guarda el PNG transparente revisado por separado y deriva cada versión blanca, de marca y lifestyle de ese archivo."
    }
  ],
  scenarios: [
    {
      title: "Imágenes de producto Amazon con fondo blanco",
      text: "Coloca el PNG transparente revisado sobre un lienzo blanco puro y verifica los requisitos de categoría actuales."
    },
    {
      title: "Tarjetas de producto y banners de Shopify",
      text: "Reutiliza el producto transparente en tarjetas responsivas, colores de marca y composiciones de página de inicio."
    },
    {
      title: "Imágenes de ficha eBay y Etsy",
      text: "Mantén el artículo completo y fiel e inspecciona el borde por restos de fondo antes de subir."
    },
    {
      title: "Creativos e-commerce transfronterizos",
      text: "Crea varios tamaños por canal desde un maestro PNG transparente preservando forma, color y branding reales del producto."
    },
    {
      title: "Anuncios de producto Google Shopping",
      text: "Alinea el artículo con la página de destino y crea activos desde el maestro transparente según las reglas publicitarias actuales."
    }
  ],
  toolFaq: [
    {
      q: "¿La eliminación de fondo de producto e-commerce es gratis en Miral AI?",
      a: "Sí. Inicia sesión para usar la eliminación de fondo gratis y descargar el PNG transparente."
    },
    {
      q: "¿Cómo hacer una imagen de producto Amazon con fondo blanco?",
      a: "Elimina el fondo original, descarga el PNG transparente, colócalo sobre un lienzo blanco puro y verifica los requisitos actuales de la categoría de producto."
    },
    {
      q: "¿Una imagen de producto Shopify debe usar fondo blanco?",
      a: "No siempre. Un PNG transparente es útil para tarjetas y banners de color de marca; elige el fondo final según el tema y diseño de la tienda."
    },
    {
      q: "¿Qué diferencia hay entre fondo transparente y blanco?",
      a: "Una imagen transparente no tiene fondo fijo y puede ir sobre cualquier lienzo. Una imagen con fondo blanco contiene píxeles blancos."
    },
    {
      q: "¿Puedo eliminar fondos de un catálogo entero de una vez?",
      a: "La página actual de Background Remover procesa una imagen a la vez, así que este artículo no promete un flujo por lotes."
    },
    {
      q: "¿Por qué un producto de vidrio se ve incompleto tras eliminar el fondo?",
      a: "Transparencia y reflejos son difíciles de separar. Reintenta con una imagen más nítida y mayor contraste, luego revisa el resultado manualmente."
    },
    {
      q: "¿Cómo corregir un halo blanco alrededor de un recorte de producto?",
      a: "Coloca el PNG transparente sobre un lienzo oscuro para localizar el halo y reintenta con una fuente de mayor resolución y contraste de borde más fuerte."
    },
    {
      q: "¿Qué revisar antes de publicar un recorte de producto?",
      a: "Comprueba a tamaño real contorno, orificios, cadenas, cordones, transparencia, color, logo, texto del empaque, puertos y accesorios incluidos."
    },
    {
      q: "¿Puede usarse la misma imagen de producto en todas las marketplaces?",
      a: "Reutiliza el maestro PNG transparente, pero crea tamaños, encuadre, espaciado y fondos finales para cada marketplace y política de categoría actual."
    },
    {
      q: "¿Puedo convertir el recorte en imagen lifestyle de producto?",
      a: "Sí. Continúa con el PNG transparente en Seedream o FLUX y verifica que estructura, color y branding del producto sigan siendo exactos."
    }
  ]
}

var esArticles = {
  "ai-background-remover-online": {
    title: "Eliminador de fondo con IA gratis para crear un PNG transparente en línea",
    excerpt: "Elimina gratis el fondo de una imagen: sube JPG, PNG o WebP, deja que la IA detecte el sujeto y descarga un PNG transparente.",
    metaTitle: "Eliminador de fondo con IA gratis en línea | Miral",
    metaDescription: "Usa Miral AI Background Remover gratis tras iniciar sesión para eliminar fondos de fotos automáticamente y exportar recortes PNG transparentes.",
    target: {
      label: "Abrir eliminador de fondo",
      path: "/tools/background-remover"
    }
  },
  "ecommerce-product-background-removal": {
    title: "Eliminador de fondo de producto con IA gratis para imágenes e-commerce",
    excerpt: "Elimina gratis fondos de producto y crea PNG transparentes o imágenes con fondo blanco para Amazon, Shopify, eBay y Etsy.",
    metaTitle: "Eliminador de fondo de producto e-commerce gratis | Miral",
    metaDescription: "Usa Miral AI gratis tras iniciar sesión para eliminar fondos de producto, exportar PNG transparentes y preparar imágenes e-commerce con fondo blanco.",
    target: {
      label: "Abrir eliminador de fondo de producto",
      path: "/tools/background-remover"
    }
  }
}

var itBg = {
  overview: [
    "Miral AI Background Remover è gratuito dopo l'accesso. Analizza l'intera immagine, separa il soggetto in primo piano dall'ambiente circostante e rimuove lo sfondo automaticamente, senza maschera disegnata a mano.",
    "Carica un'immagine JPG, PNG o WebP fino a 15 MB, controlla capelli, materiali trasparenti, piccoli fori e bordi a basso contrasto, quindi scarica il risultato come PNG trasparente.",
    "Il PNG trasparente può restare nel flusso di lavoro Miral AI per miglioramenti, pulizia degli oggetti o una nuova scena prodotto. Uno sfondo trasparente non è uguale a uno sfondo bianco: aggiungi un livello bianco in seguito quando un marketplace lo richiede specificamente."
  ],
  practice: [
    "La fonte più affidabile ha un soggetto completo, bordi nitidi e un contrasto chiaro tra primo piano e sfondo. Screenshot ricompressi e motion blur rendono più difficile separare i dettagli fini.",
    "Controllo ogni risultato su una tela scura e su una chiara. Così emergono aloni bianchi, bordi scuri, spazi mancati e ciocche rimosse che possono essere invisibili nell'anteprima predefinita."
  ],
  compareIntro: "Usa AI Background Remover quando l'intero sfondo deve scomparire automaticamente. Usa Watermark Remover o Object Remover quando serve eliminare solo un segno o un oggetto indesiderato.",
  workflow: "Carica un'immagine JPG, PNG o WebP fino a 15 MB, lascia che l'AI rilevi automaticamente il primo piano, controlla i bordi fini e scarica il PNG trasparente.",
  scenarioIntro: "Scegli lo scenario più vicino all'immagine di origine, poi controlla i dettagli del bordo rilevati automaticamente che contano di più per quel soggetto.",
  sec: {
    tldrTitle: "In breve",
    tldrCols: [
      "Da sapere",
      "Dettagli"
    ],
    tldrRows: [
      [
        "Prezzo",
        "Gratuito dopo l'accesso"
      ],
      [
        "Caricamento",
        "Un'immagine JPG, PNG o WebP fino a 15 MB"
      ],
      [
        "Elaborazione",
        "Rilevamento automatico del soggetto; nessun contorno o maschera da disegnare"
      ],
      [
        "Download",
        "Un PNG trasparente"
      ],
      [
        "Da controllare",
        "Capelli, vetro, pelliccia, spazi fini e bordi a basso contrasto"
      ]
    ],
    tldrP: "Per un ritratto o una foto prodotto semplice, di solito basta caricare, attendere, controllare e scaricare. Il controllo conta: un ritaglio può sembrare a posto in un'anteprima piccola e mostrare comunque un bordo pallido su un design scuro.",
    whatTitle: "Cosa fa davvero il rimuovi sfondo",
    whatP1: "Miral AI Background Remover legge l'intera immagine e decide quali pixel appartengono al primo piano. È molto più veloce che tracciare un soggetto con lo strumento penna e non c'è alcun passaggio di selezione da impostare prima dell'elaborazione.",
    whatP2: "Il risultato è un PNG con trasparenza, non un JPG dipinto di bianco. Puoi posizionare quel file su una scheda prodotto bianca, un colore del brand o una scena completamente nuova senza ritagliare di nuovo il soggetto.",
    whatTipTitle: "Una distinzione utile",
    whatTipText: "Trasparente e bianco non sono intercambiabili. La trasparenza lascia la tela aperta; uno sfondo bianco la riempie permanentemente con pixel bianchi.",
    howTitle: "Un semplice flusso in quattro passaggi",
    howP: "Parti dal file originale se lo hai. Gli screenshot passati da app di messaggistica tendono ad avere bordi più morbidi, il che rende più difficile separare capelli sottili e materiali trasparenti.",
    edgeTitle: "Dove guardare prima di scaricare",
    edgeCols: [
      "Immagine",
      "Controlla attentamente",
      "Perché"
    ],
    edgeRows: [
      [
        "Ritratto",
        "Capelli sciolti, occhiali, orecchini",
        "I dettagli sottili vengono tagliati facilmente"
      ],
      [
        "Prodotto",
        "Maniglie, fori, cavi, lacci",
        "Lo sfondo può restare dentro spazi chiusi"
      ],
      [
        "Vetro o imballaggio trasparente",
        "Riflessi e bordi traslucidi",
        "Lo sfondo originale si vede attraverso l'oggetto"
      ],
      [
        "Logo o firma",
        "Tratti sottili e spazi interni",
        "Piccoli vuoti possono chiudersi"
      ],
      [
        "Animale",
        "Pelliccia e baffi",
        "Una miniatura può nascondere ciocche mancanti"
      ]
    ],
    edgeP: "Mi piace posizionare il PNG scaricato su una tela chiara e su una scura. Questo controllo rapido rivela aloni pallidi e bordi scuri ed è più affidabile che giudicare solo l'anteprima a scacchiera.",
    bgTitle: "Trasparente, bianco o sfondo sostituito?",
    bgCols: [
      "Risultato",
      "Cosa contiene",
      "Ideale per"
    ],
    bgRows: [
      [
        "Sfondo trasparente",
        "Nessun colore di sfondo fisso; salvato come PNG",
        "Loghi, immagini profilo, asset di design e ritagli prodotto riutilizzabili"
      ],
      [
        "Sfondo bianco",
        "Un livello bianco sotto il ritaglio",
        "Schede prodotto, foto documento e layout che richiedono il bianco"
      ],
      [
        "Sfondo colore brand",
        "Un colore pieno o gradiente sotto il soggetto",
        "Grafiche campagna, schede profilo e visual del brand"
      ],
      [
        "Nuova scena",
        "Il ritaglio posizionato in un altro ambiente",
        "Immagini lifestyle prodotto e composizioni creative"
      ]
    ],
    bgP: "Conservo prima il PNG trasparente e creo le versioni bianche o colorate in seguito. Il JPG non può memorizzare pixel trasparenti, quindi non va bene come file master riutilizzabile.",
    troubleTitle: "Se il ritaglio sembra sbagliato",
    troubleCols: [
      "Problema",
      "Probabile causa",
      "Cosa provare"
    ],
    troubleRows: [
      [
        "Bordo bianco o scuro",
        "Il colore del vecchio sfondo resta sul bordo",
        "Riprova con una fonte più nitida e un contrasto più forte"
      ],
      [
        "Capelli o baffi scompaiono",
        "La fonte è piccola, sfocata o molto compressa",
        "Usa la foto originale e controlla a dimensione reale"
      ],
      [
        "Sfondo resta in una maniglia",
        "Uno spazio chiuso è stato letto come parte del soggetto",
        "Prova un angolo più chiaro con uno spazio più visibile"
      ],
      [
        "Il vetro sembra incompleto",
        "La trasparenza contiene colori della vecchia scena",
        "Usa uno sfondo più pulito e controlla il risultato manualmente"
      ],
      [
        "Bordi bianco su bianco scompaiono",
        "Primo piano e sfondo sono troppo simili",
        "Scegli una foto con più contrasto"
      ]
    ],
    prosConsTitle: "Dove aiuta — e dove serve ancora giudizio",
    bestTitle: "Abitudini che migliorano il risultato",
    bestItems: [
      "Usa la foto originale invece di una miniatura salvata da un'app di chat.",
      "Scegli un'immagine in cui l'intero soggetto è visibile e a fuoco.",
      "Se il soggetto si confonde con lo sfondo, prova un'altra foto con contrasto più chiaro.",
      "Controlla il PNG su una tela chiara e su una scura prima di usarlo.",
      "Controlla i prodotti bianchi su una tela scura: i residui si vedono molto meglio lì.",
      "Lavora le immagini importanti una alla volta così ogni bordo riceve un controllo adeguato."
    ],
    miralTitle: "Continua a lavorare in Miral AI",
    miralP: "Una volta eliminato lo sfondo, il PNG trasparente è un file master utile. Puoi aumentarne la nitidezza, rimuovere un oggetto fuori posto, pulire una filigrana che hai il permesso di rimuovere o trasformare il prodotto in una nuova scena commerciale.",
    miralLinksTitle: "Passi successivi utili",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "AI Object Remover",
        path: "/tools/object-remover"
      },
      {
        label: "AI Watermark Remover",
        path: "/tools/watermark-remover"
      },
      {
        label: "Guida sfondo prodotto e-commerce",
        path: "/hub/articles/ecommerce-product-background-removal"
      },
      {
        label: "Seedream 5",
        path: "/image-models/seedream-ai-image-generator"
      }
    ],
    faqTitle: "Domande che emergono in pratica",
    faqItems: [
      [
        "Come rendo trasparente lo sfondo di un'immagine online?",
        "Carica un'immagine JPG, PNG o WebP, attendi la rimozione automatica dello sfondo e scarica il PNG trasparente."
      ],
      [
        "Miral AI Background Remover è gratuito?",
        "Sì. Accedi, carica un'immagine e usa la funzione di rimozione sfondo gratuitamente. Non serve software desktop aggiuntivo."
      ],
      [
        "Devo accedere?",
        "Sì. Accedi prima di caricare, ma la funzione di rimozione sfondo è gratuita."
      ],
      [
        "Devo tracciare il contorno del soggetto?",
        "No. Lo strumento rileva automaticamente il primo piano sull'intera immagine."
      ],
      [
        "Perché il download usa il PNG?",
        "Il PNG può conservare pixel trasparenti. Il JPG no."
      ],
      [
        "La rimozione dello sfondo cambia le dimensioni dell'immagine?",
        "Controlla le dimensioni in pixel del download rispetto al layout finale prima di pubblicare, soprattutto quando un marketplace o un template ha una dimensione fissa."
      ],
      [
        "Come correggo un alo bianco intorno al ritaglio?",
        "Visualizza il PNG su una tela scura, poi riprova con una fonte più nitida e un contrasto più forte intorno al soggetto."
      ],
      [
        "Può gestire capelli e pelliccia di animali?",
        "Sì, ma le ciocche fini meritano un controllo a dimensione reale su sfondo chiaro e scuro."
      ],
      [
        "Qual è la differenza tra rimozione sfondo AI e gomma sfondo?",
        "La rimozione sfondo AI trova il soggetto automaticamente. Una gomma sfondo tradizionale di solito chiede di eliminare le aree a mano."
      ],
      [
        "Perché un soggetto bianco scompare su sfondo bianco?",
        "Il bordo ha pochissimo contrasto. Una foto con uno sfondo più scuro o più distinto offre al modello un confine più chiaro."
      ],
      [
        "Perché manca parte del mio prodotto in vetro?",
        "Il vetro riflette e trasmette il vecchio sfondo, quindi il confine è ambiguo. Una foto più nitida su uno sfondo contrastante dà al modello un punto di partenza migliore."
      ],
      [
        "Cosa posso caricare?",
        "Immagini JPG, PNG e WebP fino a 15 MB ciascuna. La pagina elabora un'immagine alla volta."
      ]
    ]
  },
  linksTitle: "Continua il flusso di lavoro in Miral AI",
  linksIntro: "Dopo la rimozione dello sfondo, usa il PNG trasparente in altri strumenti Miral AI o continua con una guida dedicata al passo successivo.",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "AI Object Remover",
      path: "/tools/object-remover"
    },
    {
      label: "AI Watermark Remover",
      path: "/tools/watermark-remover"
    },
    {
      label: "Guida sfondo prodotto e-commerce",
      path: "/hub/articles/ecommerce-product-background-removal"
    },
    {
      label: "Seedream 5",
      path: "/image-models/seedream-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "Carica l'immagine originale",
      text: "Scegli un file JPG, PNG o WebP non superiore a 15 MB."
    },
    {
      title: "Lascia che l'AI trovi il soggetto",
      text: "Miral rimuove l'intero sfondo automaticamente; non serve tracciare contorni o maschere."
    },
    {
      title: "Controlla i bordi difficili",
      text: "Ingrandisci capelli, occhiali, materiali trasparenti, fori del prodotto e altri dettagli fini."
    },
    {
      title: "Scarica il PNG trasparente",
      text: "Salva il risultato come ritaglio riutilizzabile, poi posizionalo sulla tela finale."
    }
  ],
  pros: [
    "Rilevamento automatico del soggetto senza contorno manuale",
    "Supporta input JPG, PNG e WebP",
    "Scarica un PNG trasparente riutilizzabile",
    "Utile per ritratti, prodotti, loghi, firme e animali"
  ],
  cons: [
    "Capelli e oggetti trasparenti richiedono ancora un controllo visivo",
    "Basso contrasto tra soggetto e sfondo può ridurre la qualità dei bordi",
    "La pagina attuale elabora un'immagine alla volta",
    "I file superiori a 15 MB vanno ridotti prima"
  ],
  tips: [
    {
      title: "Controlla due colori di sfondo",
      text: "Posiziona il PNG trasparente su sfondi scuro e chiaro per rivelare aloni e bordi mancanti."
    },
    {
      title: "Usa la fonte più nitida",
      text: "Un originale più grande e più nitido di solito funziona meglio di uno screenshot piccolo ricompresso più volte."
    },
    {
      title: "Proteggi i dettagli fini",
      text: "Ingrandisci capelli, baffi, catene di gioielli, lacci, occhiali e spazi interni nelle maniglie dei prodotti."
    },
    {
      title: "Correggi aloni bianchi o scuri",
      text: "Un alo spesso deriva da contaminazione cromatica sul bordo originale. Riprova con una fonte più nitida e un contrasto più forte tra primo piano e sfondo."
    },
    {
      title: "Controlla i materiali trasparenti",
      text: "Vetro e imballaggio trasparente mostrano il vecchio sfondo attraverso l'oggetto, quindi confronta il risultato su tele bianche e scure."
    }
  ],
  scenarios: [
    {
      title: "Rimozione sfondo ritratto",
      text: "Controlla capelli sciolti, orecchini e occhiali prima di usare il ritaglio in un'immagine profilo o in un poster."
    },
    {
      title: "Rimozione sfondo prodotto",
      text: "Ispeziona maniglie, fori, cavi, bordi riflettenti e imballaggio trasparente."
    },
    {
      title: "Rimozione sfondo logo o firma",
      text: "Usa una fonte ad alta risoluzione così tratti sottili e ritagli interni restano intatti."
    },
    {
      title: "Rimozione sfondo foto animale",
      text: "Scegli uno sfondo semplice con contrasto forte e controlla pelliccia e baffi a dimensione reale."
    }
  ],
  toolFaq: [
    {
      q: "Come rimuovo lo sfondo di un'immagine online?",
      a: "Carica un'immagine JPG, PNG o WebP, lascia che l'AI rilevi e rimuova lo sfondo automaticamente, poi scarica il PNG trasparente."
    },
    {
      q: "Devo selezionare manualmente la persona o il prodotto?",
      a: "No. Background Remover analizza l'intera immagine e rileva automaticamente il primo piano."
    },
    {
      q: "Perché il risultato viene scaricato come PNG?",
      a: "Il PNG supporta la trasparenza. Il JPG non può preservare uno sfondo trasparente."
    },
    {
      q: "Come correggo un alo bianco dopo la rimozione dello sfondo?",
      a: "Controlla prima il risultato su una tela scura, poi riprova con una fonte più nitida e un contrasto più chiaro tra soggetto e sfondo."
    },
    {
      q: "L'AI può rimuovere lo sfondo intorno a capelli o pelliccia?",
      a: "Sì, ma capelli fini, baffi e pelliccia sono bordi difficili e vanno sempre controllati a dimensione reale."
    },
    {
      q: "Qual è la differenza tra sfondo trasparente, bianco e sostituito?",
      a: "Un PNG trasparente non ha uno sfondo fisso. Un'immagine con sfondo bianco contiene pixel bianchi, mentre uno sfondo sostituito posiziona il ritaglio in una nuova scena o colore."
    },
    {
      q: "Perché mancano parti di un oggetto in vetro?",
      a: "Gli oggetti trasparenti contengono colori dello sfondo originale. Riprova con una fonte più nitida e ad alto contrasto e controlla la trasparenza manualmente."
    },
    {
      q: "Devo accedere per usare Background Remover?",
      a: "Sì. Accedi prima di caricare ed elaborare l'immagine."
    },
    {
      q: "Miral AI Background Remover è gratuito?",
      a: "Sì. La funzione di rimozione sfondo è gratuita dopo l'accesso, senza software aggiuntivo da installare."
    },
    {
      q: "Quali formati e dimensioni file sono supportati?",
      a: "Lo strumento accetta immagini JPG, PNG e WebP fino a 15 MB ciascuna."
    }
  ]
}

var itEcom = {
  overview: [
    "Per il lavoro e-commerce, Miral AI Background Remover è gratuito dopo l'accesso. Crea un master PNG trasparente pulito, poi produci versioni con sfondo bianco, colore brand, banner e lifestyle dallo stesso ritaglio.",
    "Miral AI Background Remover rileva automaticamente il prodotto dopo il caricamento di un'immagine JPG, PNG o WebP fino a 15 MB. Non c'è alcun passaggio di maschera manuale. Prima di pubblicare, controlla maniglie, catene, lacci, imballaggio trasparente, vetro, pelliccia e metallo riflettente.",
    "Amazon, Shopify, eBay, Etsy, Google Shopping e altri canali possono avere regole immagine diverse e in evoluzione. La rimozione dello sfondo prepara l'asset, ma non garantisce automaticamente la conformità al marketplace; verifica i requisiti attuali per il canale e la categoria esatti."
  ],
  practice: [
    "Il mio flusso preferito è foto prodotto originale, rimozione sfondo automatica, controllo bordi, master PNG trasparente e solo dopo layout specifico per canale. Così evito di ripetere il ritaglio per ogni vetrina.",
    "Per un'immagine completamente bianca, posiziona il PNG trasparente su una tela bianca. Per banner Shopify o annunci social, riutilizza lo stesso ritaglio su un colore brand o continua in Seedream o FLUX per una scena lifestyle."
  ],
  compareIntro: "Usa Background Remover per creare il master prodotto trasparente, poi aggiungi una tela bianca per le schede marketplace o continua in Seedream e FLUX per immagini lifestyle.",
  workflow: "Carica un'immagine prodotto nitida fino a 15 MB, lascia che l'AI rimuova automaticamente l'intero sfondo, controlla i bordi del prodotto e scarica il master PNG trasparente.",
  scenarioIntro: "Scegli lo scenario e-commerce più vicino al tuo prodotto, poi controlla il bordo prodotto rilevato automaticamente prima di creare ogni layout specifico per canale.",
  sec: {
    tldrTitle: "Il flusso che consiglio",
    tldrCols: [
      "Fase",
      "Conserva",
      "Controlla"
    ],
    tldrRows: [
      [
        "Rimuovi lo sfondo",
        "Un master PNG trasparente",
        "Bordi, fori, parti fini e materiali trasparenti"
      ],
      [
        "Crea una versione bianca",
        "Un export appiattito separato",
        "Spaziatura e regole marketplace attuali"
      ],
      [
        "Crea versioni brand",
        "File per schede, banner e annunci",
        "Colore prodotto, forma, logo e testo imballaggio"
      ],
      [
        "Archivia il master",
        "Il PNG trasparente controllato",
        "Non sovrascriverlo con uno sfondo specifico per canale"
      ]
    ],
    tldrP: "Miral AI Background Remover è gratuito dopo l'accesso. Rimuoverei lo sfondo una volta sola, conserverei quel master trasparente e costruirei ogni versione bianca, brand o lifestyle a partire da lì. È più pulito che ritagliare di nuovo lo stesso prodotto per ogni vetrina.",
    workflowTitle: "Dalla foto originale al ritaglio prodotto riutilizzabile",
    workflowP1: "Scegli una fotografia in cui l'intero articolo è visibile e a fuoco. Caricala su Miral AI Background Remover, lascia che lo strumento trovi automaticamente il prodotto e controlla il risultato prima di scaricare il PNG.",
    workflowP2: "L'ultima parte è facile da saltare. Controlla maniglie, porte, lacci, catene, imballaggio trasparente e ogni spazio dove il vecchio sfondo dovrebbe trasparire. Quei dettagli decidono se l'immagine resta credibile su una nuova tela.",
    transTitle: "Perché conservo prima la versione trasparente",
    transP: "Un PNG trasparente è l'asset flessibile. Può stare oggi su una tela marketplace completamente bianca, domani su una scheda brand Shopify e il mese prossimo su un banner stagionale. Se salvi solo la versione bianca, ogni nuovo sfondo ricomincia con un altro passaggio di pulizia.",
    transTipTitle: "Tieni i livelli separati",
    transTipText: "Archivia il master trasparente ed esporta le versioni per canale come file separati. Le revisioni diventano molto meno dolorose.",
    platTitle: "Un master, vetrine diverse",
    platCols: [
      "Canale",
      "Uso tipico",
      "Nota pratica"
    ],
    platRows: [
      [
        "Amazon",
        "Immagini prodotto principali e di supporto",
        "Aggiungi il bianco solo quando richiesto, poi controlla la policy attuale della categoria"
      ],
      [
        "Shopify",
        "Schede prodotto, pagine collezione e banner",
        "La trasparenza funziona bene con i colori del tema e i layout responsive"
      ],
      [
        "eBay",
        "Copertina listing e immagini galleria",
        "Cerca residui intorno alla silhouette del prodotto"
      ],
      [
        "Etsy",
        "Copertine prodotto artigianale e dettagli",
        "Mantieni materiali e dettagli artigianali veritieri"
      ],
      [
        "Google Shopping",
        "Asset pubblicitari prodotto",
        "Allinea l'articolo mostrato sulla landing page e verifica le regole annuncio attuali"
      ]
    ],
    platP: "Le regole dei marketplace cambiano e le categorie possono differire nello stesso marketplace. La rimozione dello sfondo prepara il file; non certifica l'immagine finale per una specifica inserzione.",
    qualityTitle: "I prodotti più facili da sbagliare",
    qualityItems: [
      "Vetro, cristallo e imballaggio trasparente possono perdere le aree trasparenti.",
      "Catene di gioielli, lacci e rete possono spezzarsi in pezzi scollegati.",
      "Prodotti bianchi su bianco e scuri su scuro hanno un contrasto di bordo debole.",
      "Pile, pelliccia e tessuti morbidi vanno controllati su sfondi chiari e scuri.",
      "Il metallo riflettente può conservare colori dell'ambiente originale."
    ],
    casesTitle: "I prodotti che meritano un controllo più attento",
    casesCols: [
      "Prodotto",
      "Errore comune",
      "Controllo"
    ],
    casesRows: [
      [
        "Abbigliamento e scarpe",
        "Tessuto sfilacciato, lacci o rete scompaiono",
        "Segui il contorno e ogni incrocio di lacci"
      ],
      [
        "Gioielli",
        "Le catene si spezzano o piccoli vuoti si riempiono",
        "Ingrandisci anelli, griffe, ganci e spazi negativi"
      ],
      [
        "Vetro e imballaggio trasparente",
        "Le aree trasparenti diventano piene o incomplete",
        "Controlla su sfondi bianchi e scuri"
      ],
      [
        "Imballaggio beauty",
        "Spazi della pompa e bottiglie trasparenti perdono dettaglio",
        "Proteggi etichette, bordi del tappo e colore prodotto reale"
      ],
      [
        "Elettronica",
        "Porte, cavi e bordi riflettenti cambiano",
        "Conferma ogni parte e connettore incluso"
      ],
      [
        "Mobili",
        "Lo spazio tra le gambe resta riempito",
        "Ispeziona gli spazi interni con la stessa cura del bordo esterno"
      ]
    ],
    acceptTitle: "Il mio controllo pre-pubblicazione",
    acceptItems: [
      "Nessun alo pallido, bordo scuro, bordo frastagliato o pezzo del vecchio sfondo.",
      "Maniglie, fori, catene, lacci, rete e altri spazi interni sono aperti dove devono esserlo.",
      "Vetro, plastica trasparente, pelliccia e metallo riflettente sembrano ancora il materiale reale.",
      "Colore, logo, testo imballaggio, porte e accessori corrispondono al prodotto originale.",
      "Il master trasparente è salvato separatamente dagli export bianchi e lifestyle.",
      "Ritaglio finale, spaziatura, sfondo e contenuto seguono le regole attuali del marketplace."
    ],
    prosConsTitle: "Cosa risolve questo flusso",
    miralTitle: "Costruisci il resto in Miral AI",
    miralP: "Dopo che il ritaglio supera il controllo, può passare al miglioramento immagine o a una nuova scena commerciale. Continua a verificare l'identità del prodotto: uno sfondo curato non serve se cambiano la forma della bottiglia, il colore della scarpa o l'etichetta del packaging.",
    miralLinksTitle: "Passi successivi utili",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "Guida generale rimozione sfondo AI",
        path: "/hub/articles/ai-background-remover-online"
      },
      {
        label: "Seedream 5 immagini prodotto",
        path: "/image-models/seedream-ai-image-generator"
      },
      {
        label: "FLUX.2 fotografia prodotto",
        path: "/image-models/flux-2-ai-image-generator"
      },
      {
        label: "GPT Image poster testuali",
        path: "/image-models/gpt-image-ai-image-generator"
      }
    ],
    faqTitle: "Domande e-commerce frequenti",
    faqItems: [
      [
        "La rimozione sfondo prodotto è gratuita in Miral AI?",
        "Sì. Accedi per usare gratuitamente il rimuovi sfondo e scaricare il PNG trasparente."
      ],
      [
        "Come creo un'immagine Amazon con sfondo bianco?",
        "Rimuovi lo sfondo originale, conserva il PNG trasparente, posiziona una copia su una tela completamente bianca e controlla i requisiti attuali per la categoria esatta."
      ],
      [
        "Le immagini prodotto Shopify devono avere sfondo bianco?",
        "Non necessariamente. I file trasparenti sono spesso utili per schede prodotto tematiche e banner, ma la scelta finale dipende dal design del negozio."
      ],
      [
        "Qual è la differenza tra sfondo prodotto trasparente e bianco?",
        "Un PNG trasparente non ha uno sfondo fisso. Un'immagine con sfondo bianco contiene già pixel bianchi e non può rivelare un'altra tela sotto."
      ],
      [
        "Posso elaborare un intero catalogo in una volta?",
        "La pagina attuale gestisce un'immagine alla volta."
      ],
      [
        "Perché un prodotto in vetro sembra incompleto?",
        "Vetro e imballaggio trasparente contengono colori del vecchio sfondo. Prova una fonte più nitida con contrasto più chiaro e controlla manualmente le aree trasparenti."
      ],
      [
        "Come correggo un bordo bianco intorno al prodotto?",
        "Visualizza il PNG su una tela scura per confermare il bordo, poi riprova con una fonte più nitida e un contrasto più forte intorno al prodotto."
      ],
      [
        "Come devo salvare l'immagine prodotto trasparente?",
        "Conserva un master PNG trasparente senza sfondo fisso, poi esporta versioni bianche, brand e lifestyle separate da lì."
      ],
      [
        "Posso riutilizzare un'immagine su ogni marketplace?",
        "Riutilizza il master trasparente, ma esporta ritaglio finale, spaziatura e sfondo separatamente per ogni canale e categoria."
      ],
      [
        "Posso trasformare il ritaglio in un'immagine lifestyle?",
        "Sì. Continua con il PNG trasparente in Seedream o FLUX, poi verifica che forma, colore, logo e imballaggio del prodotto restino accurati."
      ]
    ]
  },
  linksTitle: "Costruisci il flusso immagini prodotto in Miral AI",
  linksIntro: "Conserva un master prodotto trasparente, poi continua in Miral AI con miglioramento, generazione scene commerciali o design promozionale guidato dal testo.",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "Guida generale rimozione sfondo AI",
      path: "/hub/articles/ai-background-remover-online"
    },
    {
      label: "Seedream 5 immagini prodotto",
      path: "/image-models/seedream-ai-image-generator"
    },
    {
      label: "FLUX.2 fotografia prodotto",
      path: "/image-models/flux-2-ai-image-generator"
    },
    {
      label: "GPT Image poster testuali",
      path: "/image-models/gpt-image-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "Scegli una foto prodotto nitida",
      text: "Usa un JPG, PNG o WebP fino a 15 MB con l'articolo completo visibile e a fuoco."
    },
    {
      title: "Rimuovi lo sfondo originale",
      text: "Miral AI rileva il prodotto e cancella l'intero sfondo automaticamente, senza maschera manuale."
    },
    {
      title: "Controlla i dettagli del prodotto",
      text: "Ispeziona spazi interni, parti fini, sezioni trasparenti, pelliccia, vetro e bordi riflettenti."
    },
    {
      title: "Salva il master trasparente",
      text: "Scarica il PNG prima di aggiungere uno sfondo o un layout specifico per marketplace."
    },
    {
      title: "Crea la versione per canale",
      text: "Aggiungi una tela bianca o brand, poi verifica i requisiti attuali del marketplace di destinazione."
    }
  ],
  pros: [
    "Un master trasparente può servire più canali di vendita",
    "Il rilevamento automatico del prodotto risparmia tempo di contorno manuale",
    "Rende più facile standardizzare sfondi e spaziatura delle vetrine",
    "Il ritaglio può continuare in scene Seedream o FLUX"
  ],
  cons: [
    "I requisiti marketplace vanno ancora verificati prima della pubblicazione",
    "Vetro, pelliccia, catene fini e materiali riflettenti richiedono controllo manuale",
    "La rimozione sfondo non esegue dimensionamento e layout marketplace finali",
    "Lo strumento attuale elabora un'immagine alla volta"
  ],
  tips: [
    {
      title: "Separa rimozione e layout",
      text: "Conserva il master PNG trasparente, poi crea derivati con sfondo bianco e brand senza ripetere il ritaglio."
    },
    {
      title: "Ispeziona materiali difficili",
      text: "Vetro, imballaggio trasparente, catene di gioielli, pelliccia e metallo riflettente sono i primi posti da controllare."
    },
    {
      title: "Verifica le regole marketplace attuali",
      text: "Dimensione immagine, sfondo, inquadratura e policy contenuti possono cambiare e differire per categoria."
    },
    {
      title: "Usa una checklist di accettazione prodotto",
      text: "Conferma contorno, spazi interni, colore, logo, testo imballaggio, porte, accessori e aree trasparenti prima di pubblicare."
    },
    {
      title: "Conserva un solo master trasparente",
      text: "Salva separatamente il PNG trasparente controllato, poi deriva ogni versione bianca, brand e lifestyle da quel file."
    }
  ],
  scenarios: [
    {
      title: "Immagini prodotto Amazon con sfondo bianco",
      text: "Posiziona il PNG trasparente controllato su una tela completamente bianca, poi verifica i requisiti attuali della categoria."
    },
    {
      title: "Schede prodotto e banner Shopify",
      text: "Riutilizza il prodotto trasparente su schede responsive, colori brand e composizioni homepage."
    },
    {
      title: "Immagini listing eBay ed Etsy",
      text: "Mantieni l'articolo completo e veritiero e controlla il bordo per residui di sfondo prima del caricamento."
    },
    {
      title: "Creative e-commerce cross-border",
      text: "Crea più dimensioni per canale da un master PNG trasparente preservando forma, colore e branding reali del prodotto."
    },
    {
      title: "Annunci prodotto Google Shopping",
      text: "Allinea l'articolo alla landing page e crea asset dal master trasparente secondo le regole annuncio attuali."
    }
  ],
  toolFaq: [
    {
      q: "La rimozione sfondo prodotto e-commerce è gratuita in Miral AI?",
      a: "Sì. Accedi per usare gratuitamente la funzione di rimozione sfondo e scaricare il PNG trasparente."
    },
    {
      q: "Come creo un'immagine prodotto Amazon con sfondo bianco?",
      a: "Rimuovi lo sfondo originale, scarica il PNG trasparente, posizionalo su una tela completamente bianca e verifica i requisiti attuali per la categoria prodotto."
    },
    {
      q: "Un'immagine prodotto Shopify deve usare sfondo bianco?",
      a: "Non sempre. Un PNG trasparente è utile per schede e banner con colore brand; scegli lo sfondo finale per tema e layout del negozio."
    },
    {
      q: "Qual è la differenza tra sfondi trasparente e bianco?",
      a: "Un'immagine trasparente non ha uno sfondo fisso e può stare su qualsiasi tela. Un'immagine con sfondo bianco contiene pixel bianchi."
    },
    {
      q: "Posso rimuovere lo sfondo da un intero catalogo prodotto in una volta?",
      a: "La pagina Background Remover attuale elabora un'immagine alla volta, quindi questo articolo non descrive un flusso batch."
    },
    {
      q: "Perché un prodotto in vetro sembra incompleto dopo la rimozione dello sfondo?",
      a: "Trasparenza e riflessi sono difficili da separare. Riprova con un'immagine più nitida e contrasto più forte, poi controlla il risultato manualmente."
    },
    {
      q: "Come correggo un alo bianco intorno a un ritaglio prodotto?",
      a: "Posiziona il PNG trasparente su una tela scura per individuare l'alo, poi riprova con una fonte ad alta risoluzione e contrasto di bordo più forte."
    },
    {
      q: "Cosa devo controllare prima di pubblicare un ritaglio prodotto?",
      a: "Controlla a dimensione reale contorno, fori, catene, lacci, trasparenza, colore, logo, testo imballaggio, porte e accessori inclusi."
    },
    {
      q: "La stessa immagine prodotto può essere usata su ogni marketplace?",
      a: "Riutilizza il master PNG trasparente, ma crea dimensioni finali, inquadratura, spaziatura e sfondi per ogni marketplace e policy di categoria attuale."
    },
    {
      q: "Posso trasformare il ritaglio in un'immagine prodotto lifestyle?",
      a: "Sì. Continua con il PNG trasparente in Seedream o FLUX e verifica che struttura, colore e branding del prodotto restino accurati."
    }
  ]
}

var itArticles = {
  "ai-background-remover-online": {
    title: "Rimozione gratuita dello sfondo con IA per creare PNG trasparenti online",
    excerpt: "Rimuovi lo sfondo delle immagini gratis: carica JPG, PNG o WebP, lascia che l'AI rilevi il soggetto e scarica un PNG trasparente.",
    metaTitle: "Rimuovi sfondo AI gratuito online | Miral",
    metaDescription: "Usa gratuitamente Miral AI Background Remover dopo l'accesso per rimuovere automaticamente lo sfondo dalle foto ed esportare ritagli PNG trasparenti.",
    target: {
      label: "Apri rimozione sfondo",
      path: "/tools/background-remover"
    }
  },
  "ecommerce-product-background-removal": {
    title: "Rimuovi sfondo prodotto AI gratuito per immagini e-commerce",
    excerpt: "Rimuovi gratuitamente lo sfondo del prodotto e crea PNG trasparenti o immagini con sfondo bianco per Amazon, Shopify, eBay ed Etsy.",
    metaTitle: "Rimuovi sfondo prodotto e-commerce gratuito | Miral",
    metaDescription: "Usa gratuitamente Miral AI dopo l'accesso per rimuovere lo sfondo del prodotto, esportare PNG trasparenti e preparare immagini e-commerce con sfondo bianco.",
    target: {
      label: "Apri rimozione sfondo prodotto",
      path: "/tools/background-remover"
    }
  }
}

var deBg = {
  overview: [
    "Miral AI Background Remover ist nach der Anmeldung kostenlos nutzbar. Das Tool analysiert das gesamte Bild, trennt das Vordergrundmotiv von der Umgebung und entfernt den Hintergrund automatisch – ohne handgezeichnete Maske.",
    "Laden Sie ein JPG-, PNG- oder WebP-Bild bis 15 MB hoch, prüfen Sie Haare, transparente Materialien, kleine Öffnungen und Kanten mit geringem Kontrast und laden Sie das Ergebnis als transparentes PNG herunter.",
    "Das transparente PNG lässt sich im Miral-AI-Workflow für Verbesserung, Objektbereinigung oder eine neue Produktszene weiterverwenden. Transparenter Hintergrund ist nicht dasselbe wie weißer Hintergrund: Fügen Sie bei Bedarf nachträglich eine weiße Ebene hinzu, wenn eine Marketplace das verlangt."
  ],
  practice: [
    "Die zuverlässigste Quelle zeigt ein vollständiges Motiv, scharfe Kanten und klaren Kontrast zwischen Vorder- und Hintergrund. Rekomprimierte Screenshots und Bewegungsunschärfe erschweren feine Details.",
    "Ich prüfe jedes Ergebnis auf hellem und dunklem Hintergrund. So werden weiße Halos, dunkle Ränder, übersehene Lücken und fehlende Strähnen sichtbar, die in der Standardvorschau unsichtbar bleiben können."
  ],
  compareIntro: "Nutzen Sie AI Background Remover, wenn der gesamte Hintergrund automatisch verschwinden soll. Nutzen Sie Watermark Remover oder Object Remover, wenn nur eine bestimmte unerwünschte Markierung oder ein Objekt entfernt werden muss.",
  workflow: "Laden Sie ein JPG-, PNG- oder WebP-Bild bis 15 MB hoch, lassen Sie die KI den Vordergrund automatisch erkennen, prüfen Sie feine Kanten und laden Sie das transparente PNG herunter.",
  scenarioIntro: "Wählen Sie das Szenario, das am ehesten zu Ihrem Ausgangsbild passt, und prüfen Sie dann die automatisch erkannten Kantendetails, die für dieses Motiv am wichtigsten sind.",
  sec: {
    tldrTitle: "Das Wichtigste",
    tldrCols: [
      "Wissenswert",
      "Details"
    ],
    tldrRows: [
      [
        "Preis",
        "Kostenlos nach Anmeldung"
      ],
      [
        "Upload",
        "Ein JPG-, PNG- oder WebP-Bild (max. 15 MB)"
      ],
      [
        "Verarbeitung",
        "Automatische Motiverkennung; kein Umriss oder keine Maske nötig"
      ],
      [
        "Download",
        "Ein transparentes PNG"
      ],
      [
        "Prüfen lohnt sich",
        "Haare, Glas, Fell, feine Lücken und Kanten mit geringem Kontrast"
      ]
    ],
    tldrP: "Bei einem einfachen Porträt oder Produktfoto reicht meist Hochladen, Warten, Prüfen und Herunterladen. Die Prüfung zählt: Ein Freisteller kann in der kleinen Vorschau gut aussehen und auf dunklem Design dennoch einen blassen Rand zeigen.",
    whatTitle: "Was das Tool wirklich macht",
    whatP1: "Miral AI Background Remover liest das gesamte Bild und entscheidet, welche Pixel zum Vordergrund gehören. Das ist deutlich schneller als das Motiv mit dem Stift nachzuzeichnen, und es gibt keinen Auswahlschritt vor der Verarbeitung.",
    whatP2: "Das Ergebnis ist ein PNG mit Transparenz, kein weiß übermaltes JPG. Sie können die Datei auf eine weiße Produktkarte, eine Markenfarbe oder eine ganz neue Szene legen, ohne das Motiv erneut auszuschneiden.",
    whatTipTitle: "Ein nützlicher Unterschied",
    whatTipText: "Transparent und weiß sind nicht austauschbar. Transparenz lässt die Leinwand offen; ein weißer Hintergrund füllt sie dauerhaft mit weißen Pixeln.",
    howTitle: "Ein einfacher Workflow in vier Schritten",
    howP: "Starten Sie nach Möglichkeit mit der Originaldatei. Screenshots aus Messenger-Apps haben oft weichere Kanten, wodurch feines Haar und transparente Materialien schwerer zu trennen sind.",
    edgeTitle: "Worauf ich vor dem Download achte",
    edgeCols: [
      "Bild",
      "Genau prüfen",
      "Warum"
    ],
    edgeRows: [
      [
        "Porträt",
        "Lose Haare, Brille, Ohrringe",
        "Feine Details werden leicht abgeschnitten"
      ],
      [
        "Produkt",
        "Griffe, Öffnungen, Kabel, Schnürsenkel",
        "Hintergrund kann in geschlossenen Lücken bleiben"
      ],
      [
        "Glas oder transparente Verpackung",
        "Reflexionen und transluzente Kanten",
        "Der ursprüngliche Hintergrund scheint durch das Objekt"
      ],
      [
        "Logo oder Signatur",
        "Feine Striche und Negativräume",
        "Kleine Lücken können sich schließen"
      ],
      [
        "Haustier",
        "Fell und Schnurrhaare",
        "Ein Thumbnail kann fehlende Strähnen verbergen"
      ]
    ],
    edgeP: "Ich lege das heruntergeladene PNG auf eine helle und eine dunkle Leinwand. Dieser schnelle Check zeigt blasse Halos und dunkle Ränder – zuverlässiger als nur das Schachbrett in der Vorschau.",
    bgTitle: "Transparent, weiß oder ersetzter Hintergrund?",
    bgCols: [
      "Ergebnis",
      "Inhalt",
      "Am besten geeignet für"
    ],
    bgRows: [
      [
        "Transparenter Hintergrund",
        "Keine feste Hintergrundfarbe; als PNG gespeichert",
        "Logos, Profilbilder, Design-Assets und wiederverwendbare Produktausschnitte"
      ],
      [
        "Weißer Hintergrund",
        "Eine weiße Ebene unter dem Freisteller",
        "Produktlistings, Passfotos und Layouts, die Weiß verlangen"
      ],
      [
        "Markenfarb-Hintergrund",
        "Vollton oder Verlauf unter dem Motiv",
        "Kampagnen-Grafiken, Profilkarten und Markenvisuals"
      ],
      [
        "Neue Szene",
        "Freisteller in anderer Umgebung platziert",
        "Produkt-Lifestyle-Bilder und kreative Kompositionen"
      ]
    ],
    bgP: "Ich behalte zuerst das transparente PNG und erstelle danach die weißen oder farbigen Versionen. JPG kann keine transparenten Pixel speichern und eignet sich daher schlecht als wiederverwendbare Masterdatei.",
    troubleTitle: "Wenn der Freisteller falsch aussieht",
    troubleCols: [
      "Problem",
      "Wahrscheinliche Ursache",
      "Was versuchen"
    ],
    troubleRows: [
      [
        "Weißer oder dunkler Rand",
        "Farbe des alten Hintergrunds bleibt an der Kante",
        "Mit schärferer Quelle und stärkerem Kontrast erneut versuchen"
      ],
      [
        "Haare oder Schnurrhaare verschwinden",
        "Quelle ist klein, unscharf oder stark komprimiert",
        "Originalfoto nutzen und in voller Größe prüfen"
      ],
      [
        "Hintergrund bleibt in einem Griff",
        "Geschlossene Lücke wurde als Teil des Motivs gelesen",
        "Klareren Winkel mit sichtbarerer Lücke versuchen"
      ],
      [
        "Glas wirkt unvollständig",
        "Transparenz enthält Farben der alten Szene",
        "Saubereren Hintergrund nutzen und Ergebnis manuell prüfen"
      ],
      [
        "Weiß-auf-weiß-Kanten verschwinden",
        "Vorder- und Hintergrund sind zu ähnlich",
        "Foto mit mehr Kontrast wählen"
      ]
    ],
    prosConsTitle: "Wo es hilft – und wo Urteilsvermögen nötig bleibt",
    bestTitle: "Gewohnheiten, die das Ergebnis verbessern",
    bestItems: [
      "Nutzen Sie das Originalfoto statt eines Thumbnails aus einer Chat-App.",
      "Wählen Sie ein Bild, auf dem das gesamte Motiv sichtbar und scharf ist.",
      "Wenn das Motiv im Hintergrund verschwindet, probieren Sie ein Foto mit klarerem Kontrast.",
      "Prüfen Sie das PNG auf heller und dunkler Leinwand, bevor Sie es verwenden.",
      "Kontrollieren Sie weiße Produkte auf dunkler Leinwand; Reste sind dort viel besser sichtbar.",
      "Bearbeiten Sie wichtige Bilder einzeln, damit jede Kante gründlich geprüft wird."
    ],
    miralTitle: "Weiterarbeiten in Miral AI",
    miralP: "Sobald der Hintergrund weg ist, ist das transparente PNG eine nützliche Masterdatei. Sie können es schärfen, ein störendes Objekt entfernen, ein erlaubtes Wasserzeichen bereinigen oder das Produkt in eine neue kommerzielle Szene überführen.",
    miralLinksTitle: "Nächste Schritte",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "AI Object Remover",
        path: "/tools/object-remover"
      },
      {
        label: "AI Watermark Remover",
        path: "/tools/watermark-remover"
      },
      {
        label: "E-Commerce-Produkthintergrund-Leitfaden",
        path: "/hub/articles/ecommerce-product-background-removal"
      },
      {
        label: "Seedream 5",
        path: "/image-models/seedream-ai-image-generator"
      }
    ],
    faqTitle: "Fragen aus der Praxis",
    faqItems: [
      [
        "Wie mache ich einen Bildhintergrund online transparent?",
        "Laden Sie JPG, PNG oder WebP hoch, warten Sie auf die automatische Hintergrundentfernung und laden Sie das transparente PNG herunter."
      ],
      [
        "Ist Miral AI Background Remover kostenlos?",
        "Ja. Melden Sie sich an, laden Sie ein Bild hoch und nutzen Sie die Hintergrundentfernung kostenlos. Keine zusätzliche Desktop-Software nötig."
      ],
      [
        "Muss ich mich anmelden?",
        "Ja. Melden Sie sich vor dem Upload an, die Hintergrundentfernung selbst ist jedoch kostenlos."
      ],
      [
        "Muss ich das Motiv umranden?",
        "Nein. Das Tool erkennt den Vordergrund automatisch im gesamten Bild."
      ],
      [
        "Warum wird als PNG heruntergeladen?",
        "PNG kann transparente Pixel behalten. JPG kann das nicht."
      ],
      [
        "Ändert die Hintergrundentfernung die Bildabmessungen?",
        "Prüfen Sie die heruntergeladenen Pixelmaße gegen Ihr finales Layout vor der Veröffentlichung, besonders wenn Marketplace oder Vorlage eine feste Größe verlangen."
      ],
      [
        "Wie behebe ich einen weißen Halo um den Freisteller?",
        "Zeigen Sie das PNG auf dunkler Leinwand und versuchen Sie es erneut mit schärferer Quelle und stärkerem Kontrast um das Motiv."
      ],
      [
        "Kann es Haare und Tierfell verarbeiten?",
        "Ja, aber feine Strähnen sollten in voller Größe auf hellem und dunklem Hintergrund geprüft werden."
      ],
      [
        "Worin unterscheidet sich KI-Hintergrundentfernung von einem Hintergrund-Radierer?",
        "KI-Hintergrundentfernung findet das Motiv automatisch. Ein klassischer Hintergrund-Radierer verlangt meist manuelles Entfernen von Bereichen."
      ],
      [
        "Warum verschwindet ein weißes Motiv auf weißem Hintergrund?",
        "Die Kante hat sehr wenig Kontrast. Ein Foto mit dunklerem oder deutlicherem Hintergrund gibt dem Modell eine klarere Grenze."
      ],
      [
        "Warum fehlt ein Teil meines Glasprodukts?",
        "Glas reflektiert und überträgt den alten Hintergrund, daher ist die Grenze mehrdeutig. Ein scharfes Foto vor kontrastierendem Hintergrund ist ein besserer Ausgangspunkt."
      ],
      [
        "Was kann ich hochladen?",
        "JPG-, PNG- und WebP-Bilder bis 15 MB je Datei. Die Seite verarbeitet ein Bild gleichzeitig."
      ]
    ]
  },
  linksTitle: "Workflow in Miral AI fortsetzen",
  linksIntro: "Nach der Hintergrundentfernung nutzen Sie das transparente PNG in anderen Miral-AI-Tools oder folgen einem fokussierten Leitfaden für den nächsten Schritt.",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "AI Object Remover",
      path: "/tools/object-remover"
    },
    {
      label: "AI Watermark Remover",
      path: "/tools/watermark-remover"
    },
    {
      label: "E-Commerce-Produkthintergrund-Leitfaden",
      path: "/hub/articles/ecommerce-product-background-removal"
    },
    {
      label: "Seedream 5",
      path: "/image-models/seedream-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "Originalbild hochladen",
      text: "Wählen Sie eine JPG-, PNG- oder WebP-Datei mit maximal 15 MB."
    },
    {
      title: "KI das Motiv finden lassen",
      text: "Miral entfernt den gesamten Hintergrund automatisch; kein Umriss oder keine Maske nötig."
    },
    {
      title: "Schwierige Kanten prüfen",
      text: "Zoomen Sie auf Haare, Brille, transparente Materialien, Produktöffnungen und andere feine Details."
    },
    {
      title: "Transparentes PNG herunterladen",
      text: "Speichern Sie das Ergebnis als wiederverwendbaren Freisteller und platzieren Sie es auf der finalen Leinwand."
    }
  ],
  pros: [
    "Automatische Motiverkennung ohne manuelles Umrisszeichnen",
    "Unterstützt JPG, PNG und WebP",
    "Lädt wiederverwendbares transparentes PNG herunter",
    "Nützlich für Porträts, Produkte, Logos, Signaturen und Haustiere"
  ],
  cons: [
    "Haare und transparente Objekte brauchen weiterhin visuelle Prüfung",
    "Geringer Kontrast zwischen Motiv und Hintergrund kann Kantenqualität senken",
    "Die aktuelle Seite verarbeitet ein Bild gleichzeitig",
    "Dateien über 15 MB müssen zuerst verkleinert werden"
  ],
  tips: [
    {
      title: "Zwei Hintergrundfarben prüfen",
      text: "Legen Sie das transparente PNG auf dunklen und hellen Hintergrund, um Halos und fehlende Kanten zu finden."
    },
    {
      title: "Schärfste Quelle nutzen",
      text: "Ein größeres, schärferes Original funktioniert meist besser als ein kleiner, mehrfach komprimierter Screenshot."
    },
    {
      title: "Feine Details schützen",
      text: "Zoomen Sie auf Haare, Schnurrhaare, Schmuckketten, Schnürsenkel, Brille und Lücken in Produktgriffen."
    },
    {
      title: "Weiße oder dunkle Halos beheben",
      text: "Ein Halo kommt oft von Farbresten an der ursprünglichen Kante. Versuchen Sie es mit schärferer Quelle und stärkerem Vorder-/Hintergrundkontrast erneut."
    },
    {
      title: "Transparente Materialien prüfen",
      text: "Glas und transparente Verpackung zeigen den alten Hintergrund; vergleichen Sie das Ergebnis auf weißer und dunkler Leinwand."
    }
  ],
  scenarios: [
    {
      title: "Porträthintergrund entfernen",
      text: "Prüfen Sie lose Haare, Ohrringe und Brille, bevor Sie den Freisteller im Profilbild oder Poster nutzen."
    },
    {
      title: "Produkthintergrund entfernen",
      text: "Kontrollieren Sie Griffe, Öffnungen, Kabel, reflektierende Kanten und transparente Verpackung."
    },
    {
      title: "Logo- oder Signaturhintergrund entfernen",
      text: "Nutzen Sie eine hochauflösende Quelle, damit feine Striche und innere Ausschnitte erhalten bleiben."
    },
    {
      title: "Haustierfoto-Hintergrund entfernen",
      text: "Wählen Sie einen einfachen Hintergrund mit starkem Kontrast und prüfen Sie Fell und Schnurrhaare in voller Größe."
    }
  ],
  toolFaq: [
    {
      q: "Wie entferne ich online einen Bildhintergrund?",
      a: "Laden Sie JPG, PNG oder WebP hoch, lassen Sie die KI den Hintergrund automatisch erkennen und entfernen und laden Sie das transparente PNG herunter."
    },
    {
      q: "Muss ich Person oder Produkt manuell auswählen?",
      a: "Nein. Background Remover analysiert das gesamte Bild und erkennt den Vordergrund automatisch."
    },
    {
      q: "Warum wird das Ergebnis als PNG heruntergeladen?",
      a: "PNG unterstützt Transparenz. JPG kann keinen transparenten Hintergrund behalten."
    },
    {
      q: "Wie behebe ich einen weißen Halo nach der Hintergrundentfernung?",
      a: "Prüfen Sie das Ergebnis zuerst auf dunkler Leinwand und versuchen Sie es erneut mit schärferer Quelle und klarerem Motiv-/Hintergrundkontrast."
    },
    {
      q: "Kann die KI Hintergründe um Haare oder Tierfell entfernen?",
      a: "Ja, aber feines Haar, Schnurrhaare und Fell sind schwierige Kanten und sollten immer in voller Größe geprüft werden."
    },
    {
      q: "Was ist der Unterschied zwischen transparentem, weißem und ersetztem Hintergrund?",
      a: "Ein transparentes PNG hat keinen festen Hintergrund. Ein Bild mit weißem Hintergrund enthält weiße Pixel; ein ersetzter Hintergrund platziert den Freisteller in neuer Szene oder Farbe."
    },
    {
      q: "Warum fehlen Teile eines Glasobjekts?",
      a: "Transparente Objekte enthalten Farben des ursprünglichen Hintergrunds. Versuchen Sie es mit schärferer, kontrastreicherer Quelle und prüfen Sie die Transparenz manuell."
    },
    {
      q: "Muss ich mich anmelden, um Background Remover zu nutzen?",
      a: "Ja. Melden Sie sich an, bevor Sie das Bild hochladen und verarbeiten."
    },
    {
      q: "Ist Miral AI Background Remover kostenlos?",
      a: "Ja. Die Hintergrundentfernung ist nach Anmeldung kostenlos, ohne zusätzliche Softwareinstallation."
    },
    {
      q: "Welche Formate und Dateigrößen werden unterstützt?",
      a: "Das Tool akzeptiert JPG-, PNG- und WebP-Bilder bis 15 MB je Datei."
    }
  ]
}

var deEcom = {
  overview: [
    "Für E-Commerce ist Miral AI Background Remover nach Anmeldung kostenlos. Erstellen Sie ein sauberes transparentes PNG-Master und produzieren Sie daraus weiße, Markenfarb-, Banner- und Lifestyle-Versionen.",
    "Miral AI Background Remover erkennt das Produkt automatisch, nachdem Sie ein JPG-, PNG- oder WebP-Bild bis 15 MB hochgeladen haben. Kein manueller Maskenschritt. Prüfen Sie vor der Veröffentlichung Griffe, Ketten, Schnüre, transparente Verpackung, Glas, Fell und reflektierendes Metall.",
    "Amazon, Shopify, eBay, Etsy, Google Shopping und andere Kanäle haben unterschiedliche und sich ändernde Bildregeln. Hintergrundentfernung bereitet das Asset vor, garantiert aber keine Marketplace-Konformität; prüfen Sie die aktuellen Anforderungen für den exakten Kanal und die Kategorie."
  ],
  practice: [
    "Mein bevorzugter Workflow: Produktfoto, automatische Hintergrundentfernung, Kantenprüfung, transparentes PNG-Master, erst danach kanalspezifisches Layout. So muss der Freisteller nicht für jeden Shop neu erstellt werden.",
    "Für ein reines Weißbild legen Sie das transparente PNG auf eine weiße Leinwand. Für Shopify-Banner oder Social Ads nutzen Sie denselben Freisteller auf Markenfarbe oder setzen in Seedream oder FLUX für eine Lifestyle-Szene fort."
  ],
  compareIntro: "Nutzen Sie Background Remover für das transparente Produkt-Master, fügen Sie für Marketplace-Listings eine weiße Leinwand hinzu oder setzen Sie in Seedream und FLUX für Lifestyle-Bilder fort.",
  workflow: "Laden Sie ein klares Produktbild bis 15 MB hoch, lassen Sie die KI den gesamten Hintergrund automatisch entfernen, prüfen Sie Produktkanten und laden Sie das transparente PNG-Master herunter.",
  scenarioIntro: "Wählen Sie das E-Commerce-Szenario, das am ehesten zu Ihrem Produkt passt, und prüfen Sie die automatisch erkannte Produktkante, bevor Sie jedes kanalspezifische Layout erstellen.",
  sec: {
    tldrTitle: "Der empfohlene Workflow",
    tldrCols: [
      "Phase",
      "Behalten",
      "Prüfen"
    ],
    tldrRows: [
      [
        "Hintergrund entfernen",
        "Ein transparentes PNG-Master",
        "Kanten, Öffnungen, feine Teile und transparente Materialien"
      ],
      [
        "Weißversion erstellen",
        "Separater abgeflachter Export",
        "Abstände und aktuelle Marketplace-Regeln"
      ],
      [
        "Markenversionen erstellen",
        "Dateien für Karten, Banner und Anzeigen",
        "Produktfarbe, Form, Logo und Verpackungstext"
      ],
      [
        "Master archivieren",
        "Das geprüfte transparente PNG",
        "Nicht mit kanalspezifischem Hintergrund überschreiben"
      ]
    ],
    tldrP: "Miral AI Background Remover ist nach Anmeldung kostenlos. Ich würde den Hintergrund einmal entfernen, dieses transparente Master behalten und jede weiße, Marken- oder Lifestyle-Version daraus ableiten. Das ist sauberer, als dasselbe Produkt für jeden Shop neu auszuschneiden.",
    workflowTitle: "Vom Quellfoto zum wiederverwendbaren Produktfreisteller",
    workflowP1: "Wählen Sie ein Foto, auf dem der gesamte Artikel sichtbar und scharf ist. Laden Sie es in Miral AI Background Remover hoch, lassen Sie das Tool das Produkt automatisch finden und prüfen Sie das Ergebnis vor dem PNG-Download.",
    workflowP2: "Den letzten Schritt überspringt man leicht. Prüfen Sie Griffe, Anschlüsse, Schnüre, Ketten, transparente Verpackung und jede Lücke, durch die der alte Hintergrund sichtbar sein sollte. Diese Details entscheiden, ob das Bild auf neuer Leinwand noch glaubwürdig wirkt.",
    transTitle: "Warum ich zuerst die transparente Version behalte",
    transP: "Ein transparentes PNG ist das flexible Asset. Es kann heute auf einer rein weißen Marketplace-Leinwand liegen, morgen auf einer Shopify-Markenkarte und nächsten Monat auf einem Saisonbanner. Speichern Sie nur die Weißversion, beginnt jeder neue Hintergrund erneut mit Bereinigung.",
    transTipTitle: "Ebenen getrennt halten",
    transTipText: "Archivieren Sie das transparente Master und exportieren Sie Kanalversionen als separate Dateien. Revisionen werden deutlich weniger mühsam.",
    platTitle: "Ein Master, verschiedene Storefronts",
    platCols: [
      "Kanal",
      "Typische Nutzung",
      "Praxis-Hinweis"
    ],
    platRows: [
      [
        "Amazon",
        "Haupt- und Zusatzproduktbilder",
        "Weiß nur bei Bedarf hinzufügen und aktuelle Kategorierichtlinie prüfen"
      ],
      [
        "Shopify",
        "Produktkarten, Kollektionsseiten und Banner",
        "Transparenz passt gut zu Theme-Farben und responsiven Layouts"
      ],
      [
        "eBay",
        "Listing-Cover und Galeriebilder",
        "Auf Reste um die Produktsilhouette achten"
      ],
      [
        "Etsy",
        "Handmade-Cover und Detailaufnahmen",
        "Material und handgemachte Details authentisch halten"
      ],
      [
        "Google Shopping",
        "Produktwerbe-Assets",
        "Artikel mit Landingpage abgleichen und aktuelle Anzeigenregeln prüfen"
      ]
    ],
    platP: "Marketplace-Regeln ändern sich, und Kategorien können innerhalb desselben Marktplatzes unterschiedlich sein. Hintergrundentfernung bereitet die Datei vor; sie zertifiziert nicht das finale Bild für ein bestimmtes Listing.",
    qualityTitle: "Produkte, bei denen Fehler am leichtesten passieren",
    qualityItems: [
      "Glas, Kristall und transparente Verpackung können transparente Bereiche verlieren.",
      "Schmuckketten, Schnürsenkel und Mesh können in getrennte Stücke brechen.",
      "Weiße Produkte auf Weiß und dunkle auf Dunkel haben schwachen Kantenkontrast.",
      "Fleece, Fell und weiche Textilien brauchen Prüfung auf hellem und dunklem Hintergrund.",
      "Reflektierendes Metall kann Farben der ursprünglichen Umgebung behalten."
    ],
    casesTitle: "Produkte, die genauerer Prüfung bedürfen",
    casesCols: [
      "Produkt",
      "Häufiger Fehler",
      "Prüfung"
    ],
    casesRows: [
      [
        "Kleidung und Schuhe",
        "Ausgefranste Stoffe, Schnüre oder Mesh verschwinden",
        "Der Kontur und jedem kreuzenden Schnürsenkel folgen"
      ],
      [
        "Schmuck",
        "Ketten brechen oder kleine Öffnungen füllen sich",
        "Links, Krallen, Haken und Negativraum vergrößern"
      ],
      [
        "Glas und transparente Verpackung",
        "Transparente Bereiche werden voll oder unvollständig",
        "Auf weißem und dunklem Hintergrund prüfen"
      ],
      [
        "Beauty-Verpackung",
        "Pump-Lücken und transparente Flaschen verlieren Details",
        "Etiketten, Kappenkanten und echte Produktfarbe schützen"
      ],
      [
        "Elektronik",
        "Anschlüsse, Kabel und reflektierende Kanten ändern sich",
        "Jedes enthaltene Teil und jeden Stecker bestätigen"
      ],
      [
        "Möbel",
        "Raum zwischen Beinen bleibt gefüllt",
        "Innere Lücken so sorgfältig prüfen wie die Außenkante"
      ]
    ],
    acceptTitle: "Meine Prüfung vor der Veröffentlichung",
    acceptItems: [
      "Kein blasser Halo, dunkler Rand, gezackte Kante oder Rest des alten Hintergrunds.",
      "Griffe, Öffnungen, Ketten, Schnüre, Mesh und andere innere Räume sind offen, wo sie es sein sollten.",
      "Glas, transparentes Plastik, Fell und reflektierendes Metall sehen noch wie das echte Material aus.",
      "Farbe, Logo, Verpackungstext, Anschlüsse und Zubehör stimmen mit dem Quellprodukt überein.",
      "Das transparente Master ist getrennt von Weiß- und Lifestyle-Exporten gespeichert.",
      "Finaler Crop, Abstand, Hintergrund und Inhalt folgen den aktuellen Marketplace-Regeln."
    ],
    prosConsTitle: "Was dieser Workflow löst",
    miralTitle: "Den Rest in Miral AI aufbauen",
    miralP: "Nach bestandener Prüfung kann der Freisteller in Bildverbesserung oder eine neue kommerzielle Szene übergehen. Prüfen Sie weiter die Produktidentität; ein sauberer Hintergrund nützt nichts, wenn Flaschenform, Schuhfarbe oder Packungslabel sich ändern.",
    miralLinksTitle: "Nächste Schritte",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "Allgemeiner KI-Hintergrundentfernungs-Leitfaden",
        path: "/hub/articles/ai-background-remover-online"
      },
      {
        label: "Seedream 5 Produktbilder",
        path: "/image-models/seedream-ai-image-generator"
      },
      {
        label: "FLUX.2 Produktfotografie",
        path: "/image-models/flux-2-ai-image-generator"
      },
      {
        label: "GPT Image Textposter",
        path: "/image-models/gpt-image-ai-image-generator"
      }
    ],
    faqTitle: "Häufige E-Commerce-Fragen",
    faqItems: [
      [
        "Ist Produkt-Hintergrundentfernung in Miral AI kostenlos?",
        "Ja. Melden Sie sich an, nutzen Sie den Background Remover kostenlos und laden Sie das transparente PNG herunter."
      ],
      [
        "Wie erstelle ich ein Amazon-Bild mit weißem Hintergrund?",
        "Entfernen Sie den Originalhintergrund, behalten Sie das transparente PNG, legen Sie eine Kopie auf reine weiße Leinwand und prüfen Sie die aktuellen Anforderungen der exakten Kategorie."
      ],
      [
        "Brauchen Shopify-Produktbilder einen weißen Hintergrund?",
        "Nicht unbedingt. Transparente Dateien sind oft nützlich für thematische Produktkarten und Banner, die finale Wahl hängt vom Shop-Design ab."
      ],
      [
        "Was ist der Unterschied zwischen transparentem und weißem Produkthintergrund?",
        "Ein transparentes PNG hat keinen festen Hintergrund. Ein Bild mit weißem Hintergrund enthält bereits weiße Pixel und kann keine andere Leinwand darunter zeigen."
      ],
      [
        "Kann ich einen ganzen Katalog auf einmal verarbeiten?",
        "Die aktuelle Seite verarbeitet ein Bild gleichzeitig."
      ],
      [
        "Warum wirkt ein Glasprodukt unvollständig?",
        "Glas und transparente Verpackung enthalten Farben des alten Hintergrunds. Versuchen Sie eine schärfere Quelle mit klarerem Kontrast und prüfen Sie transparente Bereiche manuell."
      ],
      [
        "Wie behebe ich einen weißen Rand um das Produkt?",
        "Zeigen Sie das PNG auf dunkler Leinwand, bestätigen Sie den Rand und versuchen Sie es erneut mit schärferer Quelle und stärkerem Kontrast um das Produkt."
      ],
      [
        "Wie speichere ich das transparente Produktbild?",
        "Behalten Sie ein transparentes PNG-Master ohne festen Hintergrund und exportieren Sie separate weiße, Marken- und Lifestyle-Versionen."
      ],
      [
        "Kann ich ein Bild auf allen Marketplaces wiederverwenden?",
        "Wiederverwenden Sie das transparente Master, exportieren Sie aber Crop, Abstand und Hintergrund getrennt für jeden Kanal und jede Kategorie."
      ],
      [
        "Kann ich den Freisteller in ein Lifestyle-Bild überführen?",
        "Ja. Setzen Sie mit dem transparenten PNG in Seedream oder FLUX fort und prüfen Sie, dass Produktform, Farbe, Logo und Verpackung exakt bleiben."
      ]
    ]
  },
  linksTitle: "Produktbild-Workflow in Miral AI aufbauen",
  linksIntro: "Behalten Sie ein transparentes Produkt-Master und setzen Sie in Miral AI mit Verbesserung, kommerzieller Szenenerstellung oder textorientiertem Promo-Design fort.",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "Allgemeiner KI-Hintergrundentfernungs-Leitfaden",
      path: "/hub/articles/ai-background-remover-online"
    },
    {
      label: "Seedream 5 Produktbilder",
      path: "/image-models/seedream-ai-image-generator"
    },
    {
      label: "FLUX.2 Produktfotografie",
      path: "/image-models/flux-2-ai-image-generator"
    },
    {
      label: "GPT Image Textposter",
      path: "/image-models/gpt-image-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "Klares Produktfoto wählen",
      text: "Nutzen Sie JPG, PNG oder WebP bis 15 MB mit vollständig sichtbarem und scharfem Artikel."
    },
    {
      title: "Originalhintergrund entfernen",
      text: "Miral AI erkennt das Produkt und entfernt den gesamten Hintergrund automatisch, ohne manuelle Maske."
    },
    {
      title: "Produktdetails prüfen",
      text: "Kontrollieren Sie innere Lücken, feine Teile, transparente Bereiche, Fell, Glas und reflektierende Kanten."
    },
    {
      title: "Transparentes Master speichern",
      text: "Laden Sie das PNG herunter, bevor Sie marketplace-spezifischen Hintergrund oder Layout hinzufügen."
    },
    {
      title: "Kanalversion erstellen",
      text: "Fügen Sie weiße oder Marken-Leinwand hinzu und prüfen Sie die aktuellen Anforderungen der Ziel-Marketplace."
    }
  ],
  pros: [
    "Ein transparentes Master kann mehrere Vertriebskanäle bedienen",
    "Automatische Produkterkennung spart manuelles Umrisszeichnen",
    "Erleichtert Standardisierung von Storefront-Hintergründen und Abständen",
    "Freisteller kann in Seedream- oder FLUX-Szenen weitergehen"
  ],
  cons: [
    "Marketplace-Anforderungen müssen vor Veröffentlichung geprüft werden",
    "Glas, Fell, feine Ketten und reflektierende Materialien brauchen manuelle Prüfung",
    "Hintergrundentfernung übernimmt kein finales Marketplace-Sizing und Layout",
    "Das aktuelle Tool verarbeitet ein Bild gleichzeitig"
  ],
  tips: [
    {
      title: "Entfernung und Layout trennen",
      text: "Behalten Sie das transparente PNG-Master und erstellen Sie Weiß- und Marken-Derivate ohne erneuten Freisteller."
    },
    {
      title: "Schwierige Materialien prüfen",
      text: "Glas, transparente Verpackung, Schmuckketten, Fell und reflektierendes Metall sind die ersten Prüfstellen."
    },
    {
      title: "Aktuelle Marketplace-Regeln prüfen",
      text: "Bildgröße, Hintergrund, Bildausschnitt und Inhaltsrichtlinien können sich ändern und je Kategorie variieren."
    },
    {
      title: "Produkt-Abnahme-Checkliste nutzen",
      text: "Bestätigen Sie vor Veröffentlichung Kontur, innere Lücken, Farbe, Logo, Verpackungstext, Anschlüsse, Zubehör und transparente Bereiche."
    },
    {
      title: "Ein transparentes Master behalten",
      text: "Speichern Sie das geprüfte transparente PNG getrennt und leiten Sie jede Weiß-, Marken- und Lifestyle-Version davon ab."
    }
  ],
  scenarios: [
    {
      title: "Amazon-Produktbilder mit weißem Hintergrund",
      text: "Legen Sie das geprüfte transparente PNG auf reine weiße Leinwand und prüfen Sie die aktuellen Kategorieanforderungen."
    },
    {
      title: "Shopify-Produktkarten und Banner",
      text: "Wiederverwenden Sie das transparente Produkt auf responsiven Karten, Markenfarben und Homepage-Kompositionen."
    },
    {
      title: "eBay- und Etsy-Listing-Bilder",
      text: "Halten Sie den Artikel vollständig und authentisch und prüfen Sie die Kante auf Hintergrundreste vor dem Upload."
    },
    {
      title: "Cross-Border-E-Commerce-Kreatives",
      text: "Erstellen Sie mehrere Kanalgrößen aus einem transparenten PNG-Master und bewahren Sie echte Produktform, Farbe und Branding."
    },
    {
      title: "Google-Shopping-Produktanzeigen",
      text: "Gleichen Sie den Artikel mit der Landingpage ab und erstellen Sie Assets aus dem transparenten Master gemäß aktueller Anzeigenregeln."
    }
  ],
  toolFaq: [
    {
      q: "Ist E-Commerce-Produkt-Hintergrundentfernung in Miral AI kostenlos?",
      a: "Ja. Melden Sie sich an, nutzen Sie die Hintergrundentfernung kostenlos und laden Sie das transparente PNG herunter."
    },
    {
      q: "Wie erstelle ich ein Amazon-Produktbild mit weißem Hintergrund?",
      a: "Entfernen Sie den Quellhintergrund, laden Sie das transparente PNG herunter, legen Sie es auf reine weiße Leinwand und prüfen Sie die aktuellen Anforderungen der Produktkategorie."
    },
    {
      q: "Muss ein Shopify-Produktbild einen weißen Hintergrund haben?",
      a: "Nicht immer. Ein transparentes PNG ist nützlich für Markenfarb-Karten und Banner; wählen Sie den finalen Hintergrund passend zu Theme und Layout."
    },
    {
      q: "Was ist der Unterschied zwischen transparentem und weißem Hintergrund?",
      a: "Ein transparentes Bild hat keinen festen Hintergrund und passt auf jede Leinwand. Ein Bild mit weißem Hintergrund enthält weiße Pixel."
    },
    {
      q: "Kann ich Hintergründe eines ganzen Produktkatalogs auf einmal entfernen?",
      a: "Die aktuelle Background-Remover-Seite verarbeitet ein Bild gleichzeitig; dieser Artikel verspricht keinen Batch-Workflow."
    },
    {
      q: "Warum wirkt ein Glasprodukt nach Hintergrundentfernung unvollständig?",
      a: "Transparenz und Reflexionen sind schwer zu trennen. Versuchen Sie es mit schärferem Bild und stärkerem Kontrast und prüfen Sie das Ergebnis manuell."
    },
    {
      q: "Wie behebe ich einen weißen Halo um einen Produktfreisteller?",
      a: "Legen Sie das transparente PNG auf dunkle Leinwand, finden Sie den Halo und versuchen Sie es mit höher aufgelöster Quelle und stärkerem Kantenkontrast erneut."
    },
    {
      q: "Was sollte ich vor Veröffentlichung eines Produktfreistellers prüfen?",
      a: "Prüfen Sie in voller Größe Kontur, Öffnungen, Ketten, Schnüre, Transparenz, Farbe, Logo, Verpackungstext, Anschlüsse und enthaltenes Zubehör."
    },
    {
      q: "Kann dasselbe Produktbild auf allen Marketplaces genutzt werden?",
      a: "Wiederverwenden Sie das transparente PNG-Master, erstellen Sie aber finale Größen, Bildausschnitt, Abstände und Hintergründe für jede Marketplace und aktuelle Kategorierichtlinie."
    },
    {
      q: "Kann ich den Freisteller in ein Lifestyle-Produktbild überführen?",
      a: "Ja. Setzen Sie mit dem transparenten PNG in Seedream oder FLUX fort und prüfen Sie, dass Produktstruktur, Farbe und Branding exakt bleiben."
    }
  ]
}

var deArticles = {
  "ai-background-remover-online": {
    title: "Kostenloser KI-Hintergrundentferner für transparente PNGs online",
    excerpt: "Bildhintergrund kostenlos entfernen: JPG, PNG oder WebP hochladen, KI das Motiv erkennen lassen und transparentes PNG herunterladen.",
    metaTitle: "Kostenloser KI-Hintergrundentferner online | Miral",
    metaDescription: "Nutzen Sie Miral AI Background Remover nach Anmeldung kostenlos, um Fotohintergründe automatisch zu entfernen und transparente PNG-Freisteller zu exportieren.",
    target: {
      label: "Hintergrundentferner öffnen",
      path: "/tools/background-remover"
    }
  },
  "ecommerce-product-background-removal": {
    title: "Kostenloser KI-Produkthintergrund-Entferner für E-Commerce-Bilder",
    excerpt: "Produkthintergründe kostenlos entfernen und transparente PNGs oder Bilder mit weißem Hintergrund für Amazon, Shopify, eBay und Etsy erstellen.",
    metaTitle: "Kostenloser E-Commerce-Produkthintergrund-Entferner | Miral",
    metaDescription: "Nutzen Sie Miral AI nach Anmeldung kostenlos, um Produkthintergründe zu entfernen, transparente PNGs zu exportieren und E-Commerce-Bilder mit weißem Hintergrund vorzubereiten.",
    target: {
      label: "Produkthintergrund-Entferner öffnen",
      path: "/tools/background-remover"
    }
  }
}

var ptBg = {
  overview: [
    "O Miral AI Background Remover é gratuito após o login. Ele analisa a imagem inteira, separa o assunto em primeiro plano do ambiente e remove o fundo automaticamente, sem máscara desenhada à mão.",
    "Envie uma imagem JPG, PNG ou WebP de até 15 MB, verifique cabelo, materiais transparentes, pequenos buracos e bordas de baixo contraste e baixe o resultado como PNG transparente.",
    "O PNG transparente pode continuar no fluxo do Miral AI para aprimoramento, limpeza de objetos ou uma nova cena de produto. Fundo transparente não é o mesmo que fundo branco: adicione uma camada branca depois quando um marketplace exigir especificamente."
  ],
  practice: [
    "A fonte mais confiável tem um assunto completo, bordas nítidas e contraste claro entre primeiro plano e fundo. Capturas de tela recomprimidas e desfoque de movimento dificultam a separação de detalhes finos.",
    "Reviso cada resultado em uma tela escura e em uma clara. Isso revela halos brancos, bordas escuras, lacunas perdidas e fios removidos que podem ser invisíveis na pré-visualização padrão."
  ],
  compareIntro: "Use o AI Background Remover quando todo o fundo deve desaparecer automaticamente. Use o Watermark Remover ou o Object Remover quando apenas uma marca ou objeto indesejado precisa ser removido.",
  workflow: "Envie uma imagem JPG, PNG ou WebP de até 15 MB, deixe a IA detectar o primeiro plano automaticamente, revise as bordas finas e baixe o PNG transparente.",
  scenarioIntro: "Escolha o cenário mais próximo da sua imagem original e revise os detalhes de borda detectados automaticamente que mais importam para esse assunto.",
  sec: {
    tldrTitle: "Resumo rápido",
    tldrCols: [
      "O que saber",
      "Detalhes"
    ],
    tldrRows: [
      [
        "Preço",
        "Gratuito após o login"
      ],
      [
        "Upload",
        "Uma imagem JPG, PNG ou WebP de até 15 MB"
      ],
      [
        "Processo",
        "Detecção automática do assunto; sem contorno ou máscara para desenhar"
      ],
      [
        "Download",
        "Um PNG transparente"
      ],
      [
        "Vale conferir",
        "Cabelo, vidro, pelo, lacunas finas e bordas de baixo contraste"
      ]
    ],
    tldrP: "Para um retrato ou foto de produto simples, o trabalho costuma ser só enviar, aguardar, inspecionar e baixar. A inspeção importa: um recorte pode parecer bom em uma prévia pequena e ainda mostrar uma borda pálida em um design escuro.",
    whatTitle: "O que o removedor realmente faz",
    whatP1: "O Miral AI Background Remover lê a imagem completa e decide quais pixels pertencem ao primeiro plano. Isso é muito mais rápido do que traçar um assunto com a ferramenta caneta e também significa que não há etapa de seleção para acertar antes do processamento.",
    whatP2: "O resultado é um PNG com transparência, não um JPG pintado de branco. Você pode colocar esse arquivo em um card de produto branco, uma cor da marca ou uma cena completamente nova sem recortar o assunto de novo.",
    whatTipTitle: "Uma distinção útil",
    whatTipText: "Transparente e branco não são intercambiáveis. A transparência deixa a tela aberta; um fundo branco a preenche permanentemente com pixels brancos.",
    howTitle: "Um fluxo simples em quatro passos",
    howP: "Comece com o arquivo original se você o tiver. Capturas de tela passadas por apps de mensagem tendem a ter bordas mais suaves, o que dificulta separar cabelos finos e materiais transparentes.",
    edgeTitle: "Onde olhar antes de baixar",
    edgeCols: [
      "Imagem",
      "Observe de perto",
      "Por quê"
    ],
    edgeRows: [
      [
        "Retrato",
        "Cabelo solto, óculos, brincos",
        "Detalhes finos são fáceis de cortar"
      ],
      [
        "Produto",
        "Alças, buracos, cabos, cadarços",
        "O fundo pode permanecer dentro de lacunas fechadas"
      ],
      [
        "Vidro ou embalagem transparente",
        "Reflexos e bordas translúcidas",
        "O fundo original fica visível através do objeto"
      ],
      [
        "Logo ou assinatura",
        "Traços finos e espaços internos",
        "Pequenas lacunas podem se fechar"
      ],
      [
        "Animal de estimação",
        "Pelo e bigodes",
        "Uma miniatura pode esconder fios ausentes"
      ]
    ],
    edgeP: "Gosto de colocar o PNG baixado em uma tela clara e em uma escura. Essa verificação rápida revela halos pálidos e bordas escuras e é mais confiável do que julgar só a prévia em xadrez.",
    bgTitle: "Transparente, branco ou fundo substituído?",
    bgCols: [
      "Resultado",
      "O que contém",
      "Melhor uso"
    ],
    bgRows: [
      [
        "Fundo transparente",
        "Sem cor de fundo fixa; salvo como PNG",
        "Logos, imagens de perfil, assets de design e recortes de produto reutilizáveis"
      ],
      [
        "Fundo branco",
        "Uma camada branca abaixo do recorte",
        "Listagens de produto, fotos de documento e layouts que exigem branco"
      ],
      [
        "Fundo na cor da marca",
        "Cor sólida ou gradiente abaixo do assunto",
        "Gráficos de campanha, cards de perfil e visuais da marca"
      ],
      [
        "Nova cena",
        "O recorte colocado em outro ambiente",
        "Imagens lifestyle de produto e composições criativas"
      ]
    ],
    bgP: "Guardo primeiro o PNG transparente e faço as versões brancas ou coloridas depois. JPG não pode armazenar pixels transparentes, então é uma má escolha para o arquivo master reutilizável.",
    troubleTitle: "Se o recorte parecer errado",
    troubleCols: [
      "Problema",
      "Causa provável",
      "O que tentar"
    ],
    troubleRows: [
      [
        "Borda branca ou escura",
        "A cor do fundo antigo permanece na borda",
        "Tente de novo com uma fonte mais nítida e contraste mais forte"
      ],
      [
        "Cabelo ou bigodes desaparecem",
        "A fonte é pequena, borrada ou muito comprimida",
        "Use a foto original e inspecione em tamanho real"
      ],
      [
        "Fundo permanece em uma alça",
        "Uma lacuna fechada foi lida como parte do assunto",
        "Tente um ângulo mais claro com uma lacuna mais visível"
      ],
      [
        "Vidro parece incompleto",
        "A transparência contém cores da cena antiga",
        "Use um fundo mais limpo e revise o resultado manualmente"
      ],
      [
        "Bordas branco sobre branco somem",
        "Primeiro plano e fundo são muito parecidos",
        "Escolha uma foto com mais contraste"
      ]
    ],
    prosConsTitle: "Onde ajuda — e onde ainda exige julgamento",
    bestTitle: "Hábitos que melhoram o resultado",
    bestItems: [
      "Use a foto original em vez de uma miniatura salva de um app de chat.",
      "Escolha uma imagem em que todo o assunto esteja visível e em foco.",
      "Se o assunto se mistura ao fundo, tente outra foto com contraste mais claro.",
      "Revise o PNG em uma tela clara e em uma escura antes de usar.",
      "Verifique produtos brancos em uma tela escura; resíduos ficam muito mais visíveis lá.",
      "Trabalhe imagens importantes uma de cada vez para que cada borda receba uma revisão adequada."
    ],
    miralTitle: "Continue trabalhando no Miral AI",
    miralP: "Depois que o fundo some, o PNG transparente é um arquivo master útil. Você pode aumentar a nitidez, remover um objeto fora do lugar, limpar uma marca d'água que tem permissão para remover ou transformar o produto em uma nova cena comercial.",
    miralLinksTitle: "Próximos passos úteis",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "AI Object Remover",
        path: "/tools/object-remover"
      },
      {
        label: "AI Watermark Remover",
        path: "/tools/watermark-remover"
      },
      {
        label: "Guia de fundo de produto e-commerce",
        path: "/hub/articles/ecommerce-product-background-removal"
      },
      {
        label: "Seedream 5",
        path: "/image-models/seedream-ai-image-generator"
      }
    ],
    faqTitle: "Perguntas que surgem na prática",
    faqItems: [
      [
        "Como deixo o fundo de uma imagem transparente online?",
        "Envie uma imagem JPG, PNG ou WebP, aguarde a remoção automática do fundo e baixe o PNG transparente."
      ],
      [
        "O Miral AI Background Remover é gratuito?",
        "Sim. Faça login, envie uma imagem e use a remoção de fundo gratuitamente. Não há software desktop extra para instalar."
      ],
      [
        "Preciso fazer login?",
        "Sim. Faça login antes de enviar, mas a remoção de fundo em si é gratuita."
      ],
      [
        "Preciso contornar o assunto?",
        "Não. A ferramenta detecta o primeiro plano automaticamente em toda a imagem."
      ],
      [
        "Por que o download usa PNG?",
        "PNG pode manter pixels transparentes. JPG não pode."
      ],
      [
        "A remoção de fundo altera as dimensões da imagem?",
        "Confira as dimensões em pixels do download com o layout final antes de publicar, especialmente quando um marketplace ou template tem tamanho fixo."
      ],
      [
        "Como corrijo um halo branco ao redor do recorte?",
        "Veja o PNG em uma tela escura e tente de novo com uma fonte mais nítida e contraste mais forte ao redor do assunto."
      ],
      [
        "Ele lida com cabelo e pelo de animal?",
        "Sim, mas fios finos merecem verificação em tamanho real em fundo claro e escuro."
      ],
      [
        "Qual a diferença entre remoção de fundo com IA e borracha de fundo?",
        "A remoção de fundo com IA encontra o assunto automaticamente. Uma borracha de fundo tradicional geralmente pede que você remova áreas manualmente."
      ],
      [
        "Por que um assunto branco desaparece em fundo branco?",
        "A borda tem muito pouco contraste. Uma foto com fundo mais escuro ou mais distinto dá ao modelo um limite mais claro."
      ],
      [
        "Por que parte do meu produto de vidro está faltando?",
        "O vidro reflete e transmite o fundo antigo, então o limite fica ambíguo. Uma foto mais nítida em um fundo contrastante dá ao modelo um ponto de partida melhor."
      ],
      [
        "O que posso enviar?",
        "Imagens JPG, PNG e WebP de até 15 MB cada. A página processa uma imagem por vez."
      ]
    ]
  },
  linksTitle: "Continue o fluxo no Miral AI",
  linksIntro: "Depois da remoção de fundo, use o PNG transparente em outras ferramentas Miral AI ou continue com um guia focado no próximo passo.",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "AI Object Remover",
      path: "/tools/object-remover"
    },
    {
      label: "AI Watermark Remover",
      path: "/tools/watermark-remover"
    },
    {
      label: "Guia de fundo de produto e-commerce",
      path: "/hub/articles/ecommerce-product-background-removal"
    },
    {
      label: "Seedream 5",
      path: "/image-models/seedream-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "Envie a imagem original",
      text: "Escolha um arquivo JPG, PNG ou WebP de no máximo 15 MB."
    },
    {
      title: "Deixe a IA encontrar o assunto",
      text: "O Miral remove todo o fundo automaticamente; não há contorno ou máscara para desenhar."
    },
    {
      title: "Inspecione as bordas difíceis",
      text: "Amplie cabelo, óculos, materiais transparentes, buracos do produto e outros detalhes finos."
    },
    {
      title: "Baixe o PNG transparente",
      text: "Salve o resultado como recorte reutilizável e coloque-o na tela final."
    }
  ],
  pros: [
    "Detecção automática do assunto sem contorno manual",
    "Suporta entrada JPG, PNG e WebP",
    "Baixa um PNG transparente reutilizável",
    "Útil para retratos, produtos, logos, assinaturas e pets"
  ],
  cons: [
    "Cabelo e objetos transparentes ainda precisam de revisão visual",
    "Baixo contraste entre assunto e fundo pode reduzir a qualidade da borda",
    "A página atual processa uma imagem por vez",
    "Arquivos maiores que 15 MB precisam ser reduzidos primeiro"
  ],
  tips: [
    {
      title: "Verifique duas cores de fundo",
      text: "Coloque o PNG transparente em fundos escuro e claro para revelar halos e bordas ausentes."
    },
    {
      title: "Use a fonte mais nítida",
      text: "Um original maior e mais nítido costuma funcionar melhor do que uma captura pequena recomprimida várias vezes."
    },
    {
      title: "Proteja detalhes finos",
      text: "Amplie cabelo, bigodes, correntes de joias, cadarços, óculos e lacunas dentro de alças de produto."
    },
    {
      title: "Corrija halos brancos ou escuros",
      text: "Um halo muitas vezes vem de contaminação de cor na borda original. Tente de novo com uma fonte mais nítida e contraste mais forte entre primeiro plano e fundo."
    },
    {
      title: "Revise materiais transparentes",
      text: "Vidro e embalagem transparente mostram o fundo antigo através do objeto, então compare o resultado em telas brancas e escuras."
    }
  ],
  scenarios: [
    {
      title: "Remoção de fundo em retrato",
      text: "Verifique cabelo solto, brincos e óculos antes de usar o recorte em uma imagem de perfil ou pôster."
    },
    {
      title: "Remoção de fundo em produto",
      text: "Inspecione alças, buracos, cabos, bordas reflexivas e embalagem transparente."
    },
    {
      title: "Remoção de fundo em logo ou assinatura",
      text: "Use uma fonte em alta resolução para que traços finos e recortes internos permaneçam intactos."
    },
    {
      title: "Remoção de fundo em foto de pet",
      text: "Escolha um fundo simples com contraste forte e inspecione pelo e bigodes em tamanho real."
    }
  ],
  toolFaq: [
    {
      q: "Como removo o fundo de uma imagem online?",
      a: "Envie uma imagem JPG, PNG ou WebP, deixe a IA detectar e remover o fundo automaticamente e baixe o PNG transparente."
    },
    {
      q: "Preciso selecionar a pessoa ou o produto manualmente?",
      a: "Não. O Background Remover analisa a imagem completa e detecta o primeiro plano automaticamente."
    },
    {
      q: "Por que o resultado é baixado como PNG?",
      a: "PNG suporta transparência. JPG não pode preservar um fundo transparente."
    },
    {
      q: "Como corrijo um halo branco após a remoção de fundo?",
      a: "Verifique o resultado em uma tela escura primeiro e tente de novo com uma fonte mais nítida e contraste mais claro entre assunto e fundo."
    },
    {
      q: "A IA remove fundo ao redor de cabelo ou pelo de pet?",
      a: "Sim, mas cabelo fino, bigodes e pelo são bordas difíceis e sempre devem ser revisados em tamanho real."
    },
    {
      q: "Qual a diferença entre fundo transparente, branco e substituído?",
      a: "Um PNG transparente não tem fundo fixo. Uma imagem com fundo branco contém pixels brancos, enquanto um fundo substituído coloca o recorte em uma nova cena ou cor."
    },
    {
      q: "Por que partes de um objeto de vidro estão faltando?",
      a: "Objetos transparentes contêm cores do fundo original. Tente de novo com uma fonte mais nítida e de alto contraste e revise a transparência manualmente."
    },
    {
      q: "Preciso fazer login para usar o Background Remover?",
      a: "Sim. Faça login antes de enviar e processar a imagem."
    },
    {
      q: "O Miral AI Background Remover é gratuito?",
      a: "Sim. A remoção de fundo é gratuita após o login, sem software extra para instalar."
    },
    {
      q: "Quais formatos e tamanhos de arquivo são suportados?",
      a: "A ferramenta aceita imagens JPG, PNG e WebP de até 15 MB cada."
    }
  ]
}

var ptEcom = {
  overview: [
    "Para trabalho de e-commerce, o Miral AI Background Remover é gratuito após o login. Crie um master PNG transparente limpo e produza versões com fundo branco, cor da marca, banner e lifestyle a partir do mesmo recorte.",
    "O Miral AI Background Remover detecta automaticamente o produto depois que você envia uma imagem JPG, PNG ou WebP de até 15 MB. Não há etapa de máscara manual. Antes de publicar, inspecione alças, correntes, cadarços, embalagem transparente, vidro, pelo e metal reflexivo.",
    "Amazon, Shopify, eBay, Etsy, Google Shopping e outros canais podem ter regras de imagem diferentes e em mudança. A remoção de fundo prepara o asset, mas não garante automaticamente conformidade com marketplace; verifique os requisitos atuais do canal e categoria exatos."
  ],
  practice: [
    "Meu fluxo preferido é foto original do produto, remoção automática de fundo, revisão de bordas, master PNG transparente e só então layout específico por canal. Isso evita repetir o recorte para cada vitrine.",
    "Para uma imagem totalmente branca, coloque o PNG transparente em uma tela branca. Para banners Shopify ou anúncios sociais, reutilize o mesmo recorte em uma cor da marca ou continue no Seedream ou FLUX para uma cena lifestyle."
  ],
  compareIntro: "Use o Background Remover para criar o master de produto transparente, depois adicione uma tela branca para listagens de marketplace ou continue no Seedream e FLUX para imagens lifestyle.",
  workflow: "Envie uma imagem de produto nítida de até 15 MB, deixe a IA remover todo o fundo automaticamente, revise as bordas do produto e baixe o master PNG transparente.",
  scenarioIntro: "Escolha o cenário de e-commerce mais próximo do seu produto e inspecione a borda do produto detectada automaticamente antes de criar cada layout específico por canal.",
  sec: {
    tldrTitle: "O fluxo que recomendo",
    tldrCols: [
      "Etapa",
      "Manter",
      "Verificar"
    ],
    tldrRows: [
      [
        "Remover o fundo",
        "Um master PNG transparente",
        "Bordas, buracos, partes finas e materiais transparentes"
      ],
      [
        "Criar versão branca",
        "Uma exportação achatada separada",
        "Espaçamento e regras atuais do marketplace"
      ],
      [
        "Criar versões da marca",
        "Arquivos para cards, banners e anúncios",
        "Cor do produto, forma, logo e texto da embalagem"
      ],
      [
        "Arquivar o master",
        "O PNG transparente revisado",
        "Não sobrescreva com um fundo específico de canal"
      ]
    ],
    tldrP: "O Miral AI Background Remover é gratuito após o login. Eu removeria o fundo uma vez, manteria esse master transparente e construiria cada versão branca, da marca ou lifestyle a partir dele. Isso é mais limpo do que recortar o mesmo produto de novo para cada vitrine.",
    workflowTitle: "Da foto original ao recorte de produto reutilizável",
    workflowP1: "Escolha uma fotografia em que o item inteiro esteja visível e em foco. Envie para o Miral AI Background Remover, deixe a ferramenta encontrar o produto automaticamente e inspecione o resultado antes de baixar o PNG.",
    workflowP2: "A última parte é fácil de pular. Verifique alças, portas, cadarços, correntes, embalagem transparente e qualquer lacuna onde o fundo antigo deveria aparecer. Esses detalhes decidem se a imagem ainda parece crível em uma nova tela.",
    transTitle: "Por que guardo primeiro a versão transparente",
    transP: "Um PNG transparente é o asset flexível. Ele pode ficar hoje em uma tela de marketplace totalmente branca, amanhã em um card da marca Shopify e no mês que vem em um banner sazonal. Se você salvar só a versão branca, cada novo fundo começa com outra passagem de limpeza.",
    transTipTitle: "Mantenha as camadas separadas",
    transTipText: "Arquive o master transparente e exporte versões por canal como arquivos separados. Isso torna revisões muito menos dolorosas.",
    platTitle: "Um master, vitrines diferentes",
    platCols: [
      "Canal",
      "Uso típico",
      "Nota prática"
    ],
    platRows: [
      [
        "Amazon",
        "Imagens principais e de apoio do produto",
        "Adicione branco só quando exigido e verifique a política atual da categoria"
      ],
      [
        "Shopify",
        "Cards de produto, páginas de coleção e banners",
        "Transparência funciona bem com cores do tema e layouts responsivos"
      ],
      [
        "eBay",
        "Capa de listagem e imagens da galeria",
        "Procure resíduos ao redor da silhueta do produto"
      ],
      [
        "Etsy",
        "Capas de produto artesanal e detalhes",
        "Mantenha material e detalhes artesanais fiéis"
      ],
      [
        "Google Shopping",
        "Assets de anúncio de produto",
        "Combine com o item mostrado na landing page e verifique as regras atuais de anúncio"
      ]
    ],
    platP: "As regras de marketplace mudam e categorias podem diferir dentro do mesmo marketplace. A remoção de fundo prepara o arquivo; ela não certifica a imagem final para uma listagem específica.",
    qualityTitle: "Produtos mais fáceis de errar",
    qualityItems: [
      "Vidro, cristal e embalagem transparente podem perder áreas transparentes.",
      "Correntes de joias, cadarços e malha podem quebrar em pedaços desconectados.",
      "Produtos brancos sobre branco e escuros sobre escuro têm contraste de borda fraco.",
      "Fleece, pelo e tecidos macios precisam de verificação em fundos claros e escuros.",
      "Metal reflexivo pode manter cores do ambiente original."
    ],
    casesTitle: "Produtos que precisam de olhar mais atento",
    casesCols: [
      "Produto",
      "Falha comum",
      "Revisar"
    ],
    casesRows: [
      [
        "Roupas e calçados",
        "Tecido desfiado, cadarços ou malha desaparecem",
        "Siga o contorno e cada cruzamento de cadarço"
      ],
      [
        "Joias",
        "Correntes quebram ou pequenas aberturas se fecham",
        "Amplie elos, garras, ganchos e espaço negativo"
      ],
      [
        "Vidro e embalagem transparente",
        "Áreas transparentes ficam sólidas ou incompletas",
        "Verifique em fundos brancos e escuros"
      ],
      [
        "Embalagem de beleza",
        "Lacunas da bomba e garrafas transparentes perdem detalhe",
        "Proteja rótulos, bordas da tampa e cor real do produto"
      ],
      [
        "Eletrônicos",
        "Portas, cabos e bordas reflexivas mudam",
        "Confirme cada peça e conector incluído"
      ],
      [
        "Móveis",
        "Espaço entre pernas permanece preenchido",
        "Inspecione lacunas internas com o mesmo cuidado da borda externa"
      ]
    ],
    acceptTitle: "Minha verificação pré-publicação",
    acceptItems: [
      "Sem halo pálido, borda escura, borda irregular ou pedaço do fundo antigo.",
      "Alças, buracos, correntes, cadarços, malha e outros espaços internos estão abertos onde devem estar.",
      "Vidro, plástico transparente, pelo e metal reflexivo ainda parecem o material real.",
      "Cor, logo, texto da embalagem, portas e acessórios correspondem ao produto original.",
      "O master transparente está salvo separadamente das exportações brancas e lifestyle.",
      "Recorte final, espaçamento, fundo e conteúdo seguem as regras atuais do marketplace."
    ],
    prosConsTitle: "O que este fluxo resolve",
    miralTitle: "Construa o resto no Miral AI",
    miralP: "Depois que o recorte passa na revisão, ele pode seguir para aprimoramento de imagem ou uma nova cena comercial. Continue verificando a identidade do produto; um fundo polido não serve se a forma da garrafa, a cor do sapato ou o rótulo da embalagem mudarem.",
    miralLinksTitle: "Próximos passos úteis",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "Guia geral de remoção de fundo com IA",
        path: "/hub/articles/ai-background-remover-online"
      },
      {
        label: "Seedream 5 imagens de produto",
        path: "/image-models/seedream-ai-image-generator"
      },
      {
        label: "FLUX.2 fotografia de produto",
        path: "/image-models/flux-2-ai-image-generator"
      },
      {
        label: "GPT Image pôsteres com texto",
        path: "/image-models/gpt-image-ai-image-generator"
      }
    ],
    faqTitle: "Perguntas frequentes de e-commerce",
    faqItems: [
      [
        "A remoção de fundo de produto é gratuita no Miral AI?",
        "Sim. Faça login para usar o removedor de fundo gratuitamente e baixar o PNG transparente."
      ],
      [
        "Como faço uma imagem Amazon com fundo branco?",
        "Remova o fundo original, mantenha o PNG transparente, coloque uma cópia em uma tela totalmente branca e verifique os requisitos atuais da categoria exata."
      ],
      [
        "Imagens de produto Shopify precisam de fundo branco?",
        "Nem sempre. Arquivos transparentes costumam ser úteis para cards temáticos e banners, mas a escolha final depende do design da loja."
      ],
      [
        "Qual a diferença entre fundo de produto transparente e branco?",
        "Um PNG transparente não tem fundo fixo. Uma imagem com fundo branco já contém pixels brancos e não pode revelar outra tela abaixo."
      ],
      [
        "Posso processar um catálogo inteiro de uma vez?",
        "A página atual processa uma imagem por vez."
      ],
      [
        "Por que um produto de vidro parece incompleto?",
        "Vidro e embalagem transparente contêm cores do fundo antigo. Tente uma fonte mais nítida com contraste mais claro e revise manualmente as áreas transparentes."
      ],
      [
        "Como corrijo uma borda branca ao redor do produto?",
        "Veja o PNG em uma tela escura para confirmar a borda e tente de novo com uma fonte mais nítida e contraste mais forte ao redor do produto."
      ],
      [
        "Como devo salvar a imagem de produto transparente?",
        "Mantenha um master PNG transparente sem fundo fixo e exporte versões brancas, da marca e lifestyle separadas a partir dele."
      ],
      [
        "Posso reutilizar uma imagem em todo marketplace?",
        "Reutilize o master transparente, mas exporte recorte final, espaçamento e fundo separadamente para cada canal e categoria."
      ],
      [
        "Posso transformar o recorte em uma imagem lifestyle?",
        "Sim. Continue com o PNG transparente no Seedream ou FLUX e verifique se forma, cor, logo e embalagem do produto permanecem precisos."
      ]
    ]
  },
  linksTitle: "Construa o fluxo de imagem de produto no Miral AI",
  linksIntro: "Mantenha um master de produto transparente e continue no Miral AI com aprimoramento, geração de cena comercial ou design promocional guiado por texto.",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "Guia geral de remoção de fundo com IA",
      path: "/hub/articles/ai-background-remover-online"
    },
    {
      label: "Seedream 5 imagens de produto",
      path: "/image-models/seedream-ai-image-generator"
    },
    {
      label: "FLUX.2 fotografia de produto",
      path: "/image-models/flux-2-ai-image-generator"
    },
    {
      label: "GPT Image pôsteres com texto",
      path: "/image-models/gpt-image-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "Escolha uma foto de produto nítida",
      text: "Use JPG, PNG ou WebP de até 15 MB com o item completo visível e em foco."
    },
    {
      title: "Remova o fundo original",
      text: "O Miral AI detecta o produto e limpa todo o fundo automaticamente, sem máscara manual."
    },
    {
      title: "Verifique os detalhes do produto",
      text: "Inspecione lacunas internas, partes finas, seções transparentes, pelo, vidro e bordas reflexivas."
    },
    {
      title: "Salve o master transparente",
      text: "Baixe o PNG antes de adicionar fundo ou layout específico de marketplace."
    },
    {
      title: "Crie a versão do canal",
      text: "Adicione uma tela branca ou da marca e verifique os requisitos atuais do marketplace de destino."
    }
  ],
  pros: [
    "Um master transparente pode servir vários canais de venda",
    "Detecção automática de produto economiza tempo de contorno manual",
    "Facilita padronizar fundos e espaçamento das vitrines",
    "O recorte pode continuar em cenas Seedream ou FLUX"
  ],
  cons: [
    "Requisitos de marketplace ainda precisam ser verificados antes de publicar",
    "Vidro, pelo, correntes finas e materiais reflexivos precisam de revisão manual",
    "A remoção de fundo não faz dimensionamento e layout final de marketplace",
    "A ferramenta atual processa uma imagem por vez"
  ],
  tips: [
    {
      title: "Separe remoção e layout",
      text: "Mantenha o master PNG transparente e crie derivados com fundo branco e da marca sem repetir o recorte."
    },
    {
      title: "Inspecione materiais difíceis",
      text: "Vidro, embalagem transparente, correntes de joias, pelo e metal reflexivo são os primeiros lugares para verificar."
    },
    {
      title: "Verifique regras atuais de marketplace",
      text: "Tamanho de imagem, fundo, enquadramento e políticas de conteúdo podem mudar e diferir por categoria."
    },
    {
      title: "Use uma checklist de aceitação de produto",
      text: "Confirme contorno, lacunas internas, cor, logo, texto da embalagem, portas, acessórios e áreas transparentes antes de publicar."
    },
    {
      title: "Mantenha um master transparente",
      text: "Armazene separadamente o PNG transparente revisado e derive cada versão branca, da marca e lifestyle desse arquivo."
    }
  ],
  scenarios: [
    {
      title: "Imagens de produto Amazon com fundo branco",
      text: "Coloque o PNG transparente revisado em uma tela totalmente branca e verifique os requisitos atuais da categoria."
    },
    {
      title: "Cards de produto e banners Shopify",
      text: "Reutilize o produto transparente em cards responsivos, cores da marca e composições da homepage."
    },
    {
      title: "Imagens de listagem eBay e Etsy",
      text: "Mantenha o item completo e fiel e inspecione a borda em busca de resíduo de fundo antes do upload."
    },
    {
      title: "Criativos de e-commerce cross-border",
      text: "Crie vários tamanhos de canal a partir de um master PNG transparente preservando forma, cor e branding reais do produto."
    },
    {
      title: "Anúncios de produto Google Shopping",
      text: "Combine com o item da landing page e crie assets a partir do master transparente conforme as regras atuais de anúncio."
    }
  ],
  toolFaq: [
    {
      q: "A remoção de fundo de produto e-commerce é gratuita no Miral AI?",
      a: "Sim. Faça login para usar a remoção de fundo gratuitamente e baixar o PNG transparente."
    },
    {
      q: "Como faço uma imagem de produto Amazon com fundo branco?",
      a: "Remova o fundo original, baixe o PNG transparente, coloque-o em uma tela totalmente branca e verifique os requisitos atuais da categoria do produto."
    },
    {
      q: "Uma imagem de produto Shopify precisa usar fundo branco?",
      a: "Nem sempre. Um PNG transparente é útil para cards e banners na cor da marca; escolha o fundo final para o tema e layout da loja."
    },
    {
      q: "Qual a diferença entre fundos transparente e branco?",
      a: "Uma imagem transparente não tem fundo fixo e pode ficar em qualquer tela. Uma imagem com fundo branco contém pixels brancos."
    },
    {
      q: "Posso remover fundo de um catálogo inteiro de uma vez?",
      a: "A página atual do Background Remover processa uma imagem por vez, então este artigo não descreve um fluxo em lote."
    },
    {
      q: "Por que um produto de vidro parece incompleto após a remoção de fundo?",
      a: "Transparência e reflexos são difíceis de separar. Tente de novo com uma imagem mais nítida e contraste mais forte e revise o resultado manualmente."
    },
    {
      q: "Como corrijo um halo branco ao redor de um recorte de produto?",
      a: "Coloque o PNG transparente em uma tela escura para localizar o halo e tente de novo com uma fonte de maior resolução e contraste de borda mais forte."
    },
    {
      q: "O que devo verificar antes de publicar um recorte de produto?",
      a: "Verifique em tamanho real contorno, buracos, correntes, cadarços, transparência, cor, logo, texto da embalagem, portas e acessórios incluídos."
    },
    {
      q: "A mesma imagem de produto pode ser usada em todo marketplace?",
      a: "Reutilize o master PNG transparente, mas crie tamanhos finais, enquadramento, espaçamento e fundos para cada marketplace e política de categoria atual."
    },
    {
      q: "Posso transformar o recorte em uma imagem lifestyle de produto?",
      a: "Sim. Continue com o PNG transparente no Seedream ou FLUX e verifique se estrutura, cor e branding do produto permanecem precisos."
    }
  ]
}

var ptArticles = {
  "ai-background-remover-online": {
    title: "Removedor de fundo com IA gratuito para criar PNG transparentes online",
    excerpt: "Remova fundo de imagem grátis: envie JPG, PNG ou WebP, deixe a IA detectar o assunto e baixe um PNG transparente.",
    metaTitle: "Removedor de fundo com IA gratuito online | Miral",
    metaDescription: "Use gratuitamente o Miral AI Background Remover após o login para remover automaticamente o fundo de fotos e exportar recortes PNG transparentes.",
    target: {
      label: "Abrir removedor de fundo",
      path: "/tools/background-remover"
    }
  },
  "ecommerce-product-background-removal": {
    title: "Removedor de fundo de produto com IA gratuito para imagens e-commerce",
    excerpt: "Remova gratuitamente o fundo do produto e crie PNG transparentes ou imagens com fundo branco para Amazon, Shopify, eBay e Etsy.",
    metaTitle: "Removedor de fundo de produto e-commerce gratuito | Miral",
    metaDescription: "Use gratuitamente o Miral AI após o login para remover o fundo do produto, exportar PNG transparentes e preparar imagens e-commerce com fundo branco.",
    target: {
      label: "Abrir removedor de fundo de produto",
      path: "/tools/background-remover"
    }
  }
}

var plBg = {
  overview: [
    "Miral AI Background Remover jest darmowy po zalogowaniu. Analizuje cały obraz, oddziela obiekt na pierwszym planie od otoczenia i automatycznie usuwa tło bez ręcznie rysowanej maski.",
    "Prześlij obraz JPG, PNG lub WebP do 15 MB, sprawdź włosy, przezroczyste materiały, małe otwory i krawędzie o niskim kontraście, a następnie pobierz wynik jako przezroczysty PNG.",
    "Przezroczysty PNG może pozostać w workflow Miral AI do poprawy jakości, czyszczenia obiektów lub nowej sceny produktowej. Przezroczyste tło to nie to samo co białe tło — dodaj białą warstwę później, gdy marketplace tego wymaga."
  ],
  practice: [
    "Najbardziej wiarygodne źródło ma kompletny obiekt, ostre krawędzie i wyraźny kontrast między pierwszym planem a tłem. Ponownie skompresowane zrzuty ekranu i rozmycie ruchu utrudniają oddzielenie drobnych detali.",
    "Sprawdzam każdy wynik na ciemnym i jasnym tle. To ujawnia białe aureole, ciemne obwódki, pominięte szczeliny i usunięte włókna, które mogą być niewidoczne w domyślnym podglądzie."
  ],
  compareIntro: "Użyj AI Background Remover, gdy całe tło ma zniknąć automatycznie. Użyj Watermark Remover lub Object Remover, gdy trzeba usunąć tylko konkretny znak lub obiekt.",
  workflow: "Prześlij jeden obraz JPG, PNG lub WebP do 15 MB, pozwól AI automatycznie wykryć pierwszy plan, sprawdź drobne krawędzie i pobierz przezroczysty PNG.",
  scenarioIntro: "Wybierz scenariusz najbliższy obrazowi źródłowemu, a następnie sprawdź automatycznie wykryte detale krawędzi najważniejsze dla tego obiektu.",
  sec: {
    tldrTitle: "Krótka odpowiedź",
    tldrCols: [
      "Co warto wiedzieć",
      "Szczegóły"
    ],
    tldrRows: [
      [
        "Cena",
        "Darmowe po zalogowaniu"
      ],
      [
        "Przesyłanie",
        "Jeden obraz JPG, PNG lub WebP do 15 MB"
      ],
      [
        "Proces",
        "Automatyczne wykrywanie obiektu; bez konturu ani maski do rysowania"
      ],
      [
        "Pobieranie",
        "Przezroczysty PNG"
      ],
      [
        "Warto sprawdzić",
        "Włosy, szkło, futro, drobne szczeliny i krawędzie o niskim kontraście"
      ]
    ],
    tldrP: "Przy prostym portrecie lub zdjęciu produktu zwykle wystarczy przesłać, poczekać, sprawdzić i pobrać. Sprawdzenie ma znaczenie: wycięcie może wyglądać dobrze w małym podglądzie, a mimo to pokazać jasną obwódkę na ciemnym projekcie.",
    whatTitle: "Co naprawdę robi narzędzie do usuwania tła",
    whatP1: "Miral AI Background Remover czyta cały obraz i decyduje, które piksele należą do pierwszego planu. To znacznie szybsze niż obrysowywanie obiektu pędzlem i oznacza, że nie ma etapu zaznaczania przed przetwarzaniem.",
    whatP2: "Wynikiem jest PNG z przezroczystością, a nie JPG pomalowany na biało. Możesz umieścić ten plik na białej karcie produktu, kolorze marki lub zupełnie nowej scenie bez ponownego wycinania obiektu.",
    whatTipTitle: "Przydatne rozróżnienie",
    whatTipText: "Przezroczystość i biel nie są zamienne. Przezroczystość zostawia płótno otwarte; białe tło na stałe wypełnia je białymi pikselami.",
    howTitle: "Prosty czteroetapowy workflow",
    howP: "Zacznij od oryginalnego pliku, jeśli go masz. Zrzuty ekranu przesłane przez komunikatory mają zwykle miększe krawędzie, co utrudnia oddzielenie cienkich włosów i przezroczystych materiałów.",
    edgeTitle: "Gdzie patrzeć przed pobraniem",
    edgeCols: [
      "Obraz",
      "Sprawdź dokładnie",
      "Dlaczego"
    ],
    edgeRows: [
      [
        "Portret",
        "Luźne włosy, okulary, kolczyki",
        "Cienkie detale łatwo obciąć"
      ],
      [
        "Produkt",
        "Uchwyty, otwory, kable, sznurówki",
        "Tło może zostać w zamkniętych szczelinach"
      ],
      [
        "Szkło lub przezroczyste opakowanie",
        "Odbicia i półprzezroczyste krawędzie",
        "Oryginalne tło widać przez obiekt"
      ],
      [
        "Logo lub podpis",
        "Cienkie linie i wewnętrzne przestrzenie",
        "Małe szczeliny mogą się zamknąć"
      ],
      [
        "Zwierzę",
        "Futro i wąsy",
        "Miniatura może ukryć brakujące włókna"
      ]
    ],
    edgeP: "Lubię umieścić pobrany PNG na jasnym i ciemnym tle. Ta szybka kontrola ujawnia jasne aureole i ciemne obwódki i jest bardziej wiarygodna niż ocena samego podglądu w szachownicę.",
    bgTitle: "Przezroczyste, białe czy zastąpione tło?",
    bgCols: [
      "Wynik",
      "Co zawiera",
      "Najlepsze zastosowanie"
    ],
    bgRows: [
      [
        "Przezroczyste tło",
        "Bez stałego koloru tła; zapisane jako PNG",
        "Loga, zdjęcia profilowe, zasoby projektowe i wielokrotnie używane wycięcia produktów"
      ],
      [
        "Białe tło",
        "Biała warstwa pod wycięciem",
        "Listy produktów, zdjęcia dokumentów i layouty wymagające bieli"
      ],
      [
        "Tło w kolorze marki",
        "Jednolity kolor lub gradient pod obiektem",
        "Grafiki kampanii, karty profilu i wizualizacje marki"
      ],
      [
        "Nowa scena",
        "Wycięcie umieszczone w innym otoczeniu",
        "Lifestyle produktów i kompozycje kreatywne"
      ]
    ],
    bgP: "Najpierw zachowuję przezroczysty PNG, a białe lub kolorowe wersje tworzę później. JPG nie może przechowywać przezroczystych pikseli, więc nie nadaje się jako plik master do wielokrotnego użycia.",
    troubleTitle: "Gdy wycięcie wygląda źle",
    troubleCols: [
      "Problem",
      "Prawdopodobna przyczyna",
      "Co spróbować"
    ],
    troubleRows: [
      [
        "Biała lub ciemna obwódka",
        "Kolor starego tła pozostaje na krawędzi",
        "Spróbuj ponownie z ostrzejszym źródłem i silniejszym kontrastem"
      ],
      [
        "Włosy lub wąsy znikają",
        "Źródło jest małe, rozmyte lub mocno skompresowane",
        "Użyj oryginalnego zdjęcia i sprawdź w pełnym rozmiarze"
      ],
      [
        "Tło zostaje w uchwycie",
        "Zamknięta szczelina została odczytana jako część obiektu",
        "Spróbuj wyraźniejszego kąta z bardziej widoczną szczeliną"
      ],
      [
        "Szkło wygląda niekompletnie",
        "Przezroczystość zawiera kolory ze starej sceny",
        "Użyj czystszego tła i ręcznie sprawdź wynik"
      ],
      [
        "Krawędzie biały na białym znikają",
        "Pierwszy plan i tło są zbyt podobne",
        "Wybierz zdjęcie z większym kontrastem"
      ]
    ],
    prosConsTitle: "Gdzie pomaga — i gdzie nadal potrzeba oceny",
    bestTitle: "Nawyki poprawiające wynik",
    bestItems: [
      "Używaj oryginalnego zdjęcia zamiast miniatury zapisanej z aplikacji czatu.",
      "Wybierz obraz, na którym cały obiekt jest widoczny i w ostrości.",
      "Jeśli obiekt zlewa się z tłem, spróbuj innego zdjęcia z wyraźniejszym kontrastem.",
      "Sprawdź PNG na jasnym i ciemnym tle przed użyciem.",
      "Sprawdzaj białe produkty na ciemnym tle — resztki tła widać tam znacznie lepiej.",
      "Przetwarzaj ważne obrazy pojedynczo, aby każda krawędź dostała właściwą kontrolę."
    ],
    miralTitle: "Kontynuuj pracę w Miral AI",
    miralP: "Gdy tło zniknie, przezroczysty PNG to przydatny plik master. Możesz go wyostrzyć, usunąć zbędny obiekt, wyczyścić znak wodny, który masz prawo usunąć, lub przenieść produkt do nowej sceny komercyjnej.",
    miralLinksTitle: "Przydatne kolejne kroki",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "AI Object Remover",
        path: "/tools/object-remover"
      },
      {
        label: "AI Watermark Remover",
        path: "/tools/watermark-remover"
      },
      {
        label: "Przewodnik tła produktu e-commerce",
        path: "/hub/articles/ecommerce-product-background-removal"
      },
      {
        label: "Seedream 5",
        path: "/image-models/seedream-ai-image-generator"
      }
    ],
    faqTitle: "Pytania, które pojawiają się w praktyce",
    faqItems: [
      [
        "Jak online zrobić tło obrazu przezroczyste?",
        "Prześlij obraz JPG, PNG lub WebP, poczekaj na automatyczne usunięcie tła i pobierz przezroczysty PNG."
      ],
      [
        "Czy Miral AI Background Remover jest darmowy?",
        "Tak. Zaloguj się, prześlij obraz i korzystaj z usuwania tła za darmo. Nie trzeba instalować dodatkowego oprogramowania desktopowego."
      ],
      [
        "Czy muszę się zalogować?",
        "Tak. Zaloguj się przed przesłaniem, ale sama funkcja usuwania tła jest darmowa."
      ],
      [
        "Czy muszę obrysować obiekt?",
        "Nie. Narzędzie automatycznie wykrywa pierwszy plan na całym obrazie."
      ],
      [
        "Dlaczego pobieranie jest w PNG?",
        "PNG może zachować przezroczyste piksele. JPG nie może."
      ],
      [
        "Czy usuwanie tła zmieni wymiary obrazu?",
        "Sprawdź wymiary pikseli pobranego pliku względem finalnego layoutu przed publikacją, zwłaszcza gdy marketplace lub szablon ma stały rozmiar."
      ],
      [
        "Jak naprawić białą aureolę wokół wycięcia?",
        "Zobacz PNG na ciemnym tle, a następnie spróbuj ponownie z ostrzejszym źródłem i silniejszym kontrastem wokół obiektu."
      ],
      [
        "Czy radzi sobie z włosami i futrem zwierząt?",
        "Tak, ale cienkie włókna wymagają kontroli w pełnym rozmiarze na jasnym i ciemnym tle."
      ],
      [
        "Czym różni się usuwanie tła AI od gumki tła?",
        "Usuwanie tła AI automatycznie znajduje obiekt. Tradycyjna gumka tła zwykle wymaga ręcznego usuwania obszarów."
      ],
      [
        "Dlaczego biały obiekt znika na białym tle?",
        "Krawędź ma bardzo mały kontrast. Zdjęcie z ciemniejszym lub wyraźniejszym tłem daje modelowi jaśniejszą granicę."
      ],
      [
        "Dlaczego brakuje części mojego szklanego produktu?",
        "Szkło odbija i przepuszcza stare tło, więc granica jest niejednoznaczna. Ostrzejsze zdjęcie na kontrastowym tle daje modelowi lepszy punkt startowy."
      ],
      [
        "Co mogę przesłać?",
        "Obrazy JPG, PNG i WebP do 15 MB każdy. Strona przetwarza jeden obraz na raz."
      ]
    ]
  },
  linksTitle: "Kontynuuj workflow w Miral AI",
  linksIntro: "Po usunięciu tła użyj przezroczystego PNG w innych narzędziach Miral AI lub przejdź do dedykowanego przewodnika dla kolejnego kroku.",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "AI Object Remover",
      path: "/tools/object-remover"
    },
    {
      label: "AI Watermark Remover",
      path: "/tools/watermark-remover"
    },
    {
      label: "Przewodnik tła produktu e-commerce",
      path: "/hub/articles/ecommerce-product-background-removal"
    },
    {
      label: "Seedream 5",
      path: "/image-models/seedream-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "Prześlij oryginalny obraz",
      text: "Wybierz jeden plik JPG, PNG lub WebP nie większy niż 15 MB."
    },
    {
      title: "Pozwól AI znaleźć obiekt",
      text: "Miral automatycznie usuwa całe tło; nie trzeba rysować konturu ani maski."
    },
    {
      title: "Sprawdź trudne krawędzie",
      text: "Powiększ włosy, okulary, przezroczyste materiały, otwory produktu i inne drobne detale."
    },
    {
      title: "Pobierz przezroczysty PNG",
      text: "Zapisz wynik jako wielokrotnie używane wycięcie, a następnie umieść je na finalnym płótnie."
    }
  ],
  pros: [
    "Automatyczne wykrywanie obiektu bez ręcznego obrysowywania",
    "Obsługuje wejście JPG, PNG i WebP",
    "Pobiera wielokrotnie używany przezroczysty PNG",
    "Przydatne dla portretów, produktów, log, podpisów i zwierząt"
  ],
  cons: [
    "Włosy i przezroczyste obiekty nadal wymagają wizualnej kontroli",
    "Niski kontrast między obiektem a tłem może obniżyć jakość krawędzi",
    "Obecna strona przetwarza jeden obraz na raz",
    "Pliki większe niż 15 MB trzeba najpierw zmniejszyć"
  ],
  tips: [
    {
      title: "Sprawdź dwa kolory tła",
      text: "Umieść przezroczysty PNG na ciemnym i jasnym tle, aby ujawnić aureole i brakujące krawędzie."
    },
    {
      title: "Użyj najostrzejszego źródła",
      text: "Większy, ostrzejszy oryginał zwykle działa lepiej niż mały zrzut ekranu wielokrotnie skompresowany."
    },
    {
      title: "Chroń drobne detale",
      text: "Powiększ włosy, wąsy, łańcuszki biżuterii, sznurówki, okulary i szczeliny wewnątrz uchwytów produktu."
    },
    {
      title: "Napraw białe lub ciemne aureole",
      text: "Aureola często wynika ze zanieczyszczenia kolorem na oryginalnej krawędzi. Spróbuj ponownie z ostrzejszym źródłem i silniejszym kontrastem pierwszego planu i tła."
    },
    {
      title: "Sprawdź przezroczyste materiały",
      text: "Szkło i przezroczyste opakowanie pokazują stare tło przez obiekt, więc porównaj wynik na białym i ciemnym tle."
    }
  ],
  scenarios: [
    {
      title: "Usuwanie tła z portretu",
      text: "Sprawdź luźne włosy, kolczyki i okulary przed użyciem wycięcia w zdjęciu profilowym lub plakacie."
    },
    {
      title: "Usuwanie tła z produktu",
      text: "Sprawdź uchwyty, otwory, kable, odbijające krawędzie i przezroczyste opakowanie."
    },
    {
      title: "Usuwanie tła z logo lub podpisu",
      text: "Użyj źródła w wysokiej rozdzielczości, aby cienkie linie i wewnętrzne wycięcia pozostały nienaruszone."
    },
    {
      title: "Usuwanie tła ze zdjęcia zwierzęcia",
      text: "Wybierz proste tło z silnym kontrastem i sprawdź futro i wąsy w pełnym rozmiarze."
    }
  ],
  toolFaq: [
    {
      q: "Jak online usunąć tło z obrazu?",
      a: "Prześlij obraz JPG, PNG lub WebP, pozwól AI automatycznie wykryć i usunąć tło, a następnie pobierz przezroczysty PNG."
    },
    {
      q: "Czy muszę ręcznie zaznaczyć osobę lub produkt?",
      a: "Nie. Background Remover analizuje cały obraz i automatycznie wykrywa pierwszy plan."
    },
    {
      q: "Dlaczego wynik jest pobierany jako PNG?",
      a: "PNG obsługuje przezroczystość. JPG nie może zachować przezroczystego tła."
    },
    {
      q: "Jak naprawić białą aureolę po usunięciu tła?",
      a: "Najpierw sprawdź wynik na ciemnym tle, a następnie spróbuj ponownie z ostrzejszym źródłem o wyraźniejszym kontraście obiektu i tła."
    },
    {
      q: "Czy AI usuwa tło wokół włosów lub futra zwierząt?",
      a: "Tak, ale cienkie włosy, wąsy i futro to trudne krawędzie i zawsze należy je sprawdzić w pełnym rozmiarze."
    },
    {
      q: "Jaka jest różnica między przezroczystym, białym i zastąpionym tłem?",
      a: "Przezroczysty PNG nie ma stałego tła. Obraz z białym tłem zawiera białe piksele, a zastąpione tło umieszcza wycięcie w nowej scenie lub kolorze."
    },
    {
      q: "Dlaczego brakuje części szklanego obiektu?",
      a: "Przezroczyste obiekty zawierają kolory z oryginalnego tła. Spróbuj ponownie z ostrzejszym źródłem o wyższym kontraście i ręcznie sprawdź przezroczystość."
    },
    {
      q: "Czy muszę się zalogować, aby użyć Background Remover?",
      a: "Tak. Zaloguj się przed przesłaniem i przetworzeniem obrazu."
    },
    {
      q: "Czy Miral AI Background Remover jest darmowy?",
      a: "Tak. Funkcja usuwania tła jest darmowa po zalogowaniu, bez dodatkowego oprogramowania do instalacji."
    },
    {
      q: "Jakie formaty i rozmiary plików są obsługiwane?",
      a: "Narzędzie akceptuje obrazy JPG, PNG i WebP do 15 MB każdy."
    }
  ]
}

var plEcom = {
  overview: [
    "Do pracy e-commerce Miral AI Background Remover jest darmowy po zalogowaniu. Utwórz jeden czysty przezroczysty master PNG, a następnie wygeneruj wersje z białym tłem, kolorem marki, banerem i lifestyle z tego samego wycięcia.",
    "Miral AI Background Remover automatycznie wykrywa produkt po przesłaniu obrazu JPG, PNG lub WebP do 15 MB. Nie ma etapu ręcznej maski. Przed publikacją sprawdź uchwyty, łańcuszki, sznurówki, przezroczyste opakowanie, szkło, futro i metal odbijający światło.",
    "Amazon, Shopify, eBay, Etsy, Google Shopping i inne kanały mogą mieć różne i zmieniające się zasady dotyczące obrazów. Usuwanie tła przygotowuje asset, ale nie gwarantuje automatycznie zgodności z marketplace; sprawdź aktualne wymagania dla konkretnego kanału i kategorii."
  ],
  practice: [
    "Preferowany workflow to zdjęcie produktu źródłowe, automatyczne usuwanie tła, kontrola krawędzi, przezroczysty master PNG, a dopiero potem layout specyficzny dla kanału. To unika powtarzania wycinania dla każdego sklepu.",
    "Dla czysto białego obrazu umieść przezroczysty PNG na białym płótnie. Dla banerów Shopify lub reklam social użyj ponownie tego samego wycięcia na kolorze marki albo kontynuuj w Seedream lub FLUX dla sceny lifestyle."
  ],
  compareIntro: "Użyj Background Remover, aby utworzyć przezroczysty master produktu, a następnie dodaj białe płótno dla list marketplace lub kontynuuj w Seedream i FLUX dla obrazów lifestyle.",
  workflow: "Prześlij jedno wyraźne zdjęcie produktu do 15 MB, pozwól AI automatycznie usunąć całe tło, sprawdź krawędzie produktu i pobierz przezroczysty master PNG.",
  scenarioIntro: "Wybierz scenariusz e-commerce najbliższy produktowi, a następnie sprawdź automatycznie wykrytą krawędź produktu przed utworzeniem layoutu dla każdego kanału.",
  sec: {
    tldrTitle: "Workflow, który polecam",
    tldrCols: [
      "Etap",
      "Zachowaj",
      "Sprawdź"
    ],
    tldrRows: [
      [
        "Usuń tło",
        "Przezroczysty master PNG",
        "Krawędzie, otwory, drobne elementy i przezroczyste materiały"
      ],
      [
        "Utwórz wersję białą",
        "Osobny spłaszczony eksport",
        "Odstępy i aktualne zasady marketplace"
      ],
      [
        "Utwórz wersje marki",
        "Pliki do kart, banerów i reklam",
        "Kolor produktu, kształt, logo i tekst opakowania"
      ],
      [
        "Zarchiwizuj master",
        "Sprawdzony przezroczysty PNG",
        "Nie nadpisuj go tłem specyficznym dla kanału"
      ]
    ],
    tldrP: "Miral AI Background Remover jest darmowy po zalogowaniu. Usunąłbym tło raz, zachował ten przezroczysty master i zbudował z niego każdą wersję białą, markową lub lifestyle. To czystsze niż ponowne wycinanie tego samego produktu dla każdego sklepu.",
    workflowTitle: "Od zdjęcia źródłowego do wielokrotnie używanego wycięcia produktu",
    workflowP1: "Wybierz fotografię, na której cały przedmiot jest widoczny i w ostrości. Prześlij ją do Miral AI Background Remover, pozwól narzędziu automatycznie znaleźć produkt i sprawdź wynik przed pobraniem PNG.",
    workflowP2: "Ostatni krok łatwo pominąć. Sprawdź uchwyty, porty, sznurówki, łańcuszki, przezroczyste opakowanie i każdą szczelinę, przez którą powinno przeświecać stare tło. Te detale decydują, czy obraz nadal wygląda wiarygodnie na nowym płótnie.",
    transTitle: "Dlaczego najpierw zostawiam wersję przezroczystą",
    transP: "Przezroczysty PNG to elastyczny asset. Dziś może być na czysto białym płótnie marketplace, jutro na karcie marki Shopify, a w przyszłym miesiącu na sezonowym banerze. Jeśli zapiszesz tylko wersję białą, każde nowe tło zaczyna się od kolejnego czyszczenia.",
    transTipTitle: "Trzymaj warstwy osobno",
    transTipText: "Zarchiwizuj przezroczysty master i eksportuj wersje kanałowe jako osobne pliki. Poprawki stają się wtedy znacznie mniej bolesne.",
    platTitle: "Jeden master, różne sklepy",
    platCols: [
      "Kanał",
      "Typowe zastosowanie",
      "Praktyczna uwaga"
    ],
    platRows: [
      [
        "Amazon",
        "Główne i pomocnicze zdjęcia produktu",
        "Dodawaj biel tylko gdy wymagana, a następnie sprawdź aktualną politykę kategorii"
      ],
      [
        "Shopify",
        "Karty produktów, strony kolekcji i banery",
        "Przezroczystość dobrze współgra z kolorami motywu i responsywnymi layoutami"
      ],
      [
        "eBay",
        "Okładka listingu i galeria",
        "Szukaj resztek tła wokół sylwetki produktu"
      ],
      [
        "Etsy",
        "Okładki produktów rękodzielniczych i detale",
        "Zachowaj prawdziwość materiału i detali rękodzieła"
      ],
      [
        "Google Shopping",
        "Assety reklam produktowych",
        "Dopasuj do produktu na stronie docelowej i sprawdź aktualne zasady reklam"
      ]
    ],
    platP: "Zasady marketplace się zmieniają, a kategorie mogą różnić się w ramach tego samego marketplace. Usuwanie tła przygotowuje plik; nie certyfikuje finalnego obrazu dla konkretnej oferty.",
    qualityTitle: "Produkty, które najłatwiej zepsuć",
    qualityItems: [
      "Szkło, kryształ i przezroczyste opakowanie mogą stracić przezroczyste obszary.",
      "Łańcuszki biżuterii, sznurówki i siatka mogą rozpaść się na odłączone fragmenty.",
      "Białe produkty na białym i ciemne na ciemnym mają słaby kontrast krawędzi.",
      "Polar, futro i miękkie tkaniny wymagają kontroli na jasnym i ciemnym tle.",
      "Odbijający metal może zachować kolory z oryginalnego otoczenia."
    ],
    casesTitle: "Produkty wymagające dokładniejszej kontroli",
    casesCols: [
      "Produkt",
      "Typowy błąd",
      "Kontrola"
    ],
    casesRows: [
      [
        "Odzież i obuwie",
        "Postrzępiony materiał, sznurówki lub siatka znikają",
        "Podążaj za konturem i każdym skrzyżowaniem sznurówek"
      ],
      [
        "Biżuteria",
        "Łańcuszki pękają lub małe otwory się zamykają",
        "Powiększ ogniwa, szpilki, haczyki i przestrzeń negatywną"
      ],
      [
        "Szkło i przezroczyste opakowanie",
        "Przezroczyste obszary stają się pełne lub niekompletne",
        "Sprawdź na białym i ciemnym tle"
      ],
      [
        "Opakowanie kosmetyków",
        "Szczeliny pompy i przezroczyste butelki tracą detale",
        "Chroń etykiety, krawędzie nakrętek i prawdziwy kolor produktu"
      ],
      [
        "Elektronika",
        "Porty, kable i odbijające krawędzie się zmieniają",
        "Potwierdź każdą dołączoną część i złącze"
      ],
      [
        "Meble",
        "Przestrzeń między nogami pozostaje wypełniona",
        "Sprawdź wewnętrzne szczeliny tak samo dokładnie jak zewnętrzną krawędź"
      ]
    ],
    acceptTitle: "Moja kontrola przed publikacją",
    acceptItems: [
      "Brak jasnej aureoli, ciemnej obwódki, poszarpanej krawędzi lub fragmentu starego tła.",
      "Uchwyty, otwory, łańcuszki, sznurówki, siatka i inne wewnętrzne przestrzenie są otwarte tam, gdzie powinny.",
      "Szkło, przezroczysty plastik, futro i odbijający metal nadal wyglądają jak prawdziwy materiał.",
      "Kolor, logo, tekst opakowania, porty i akcesoria odpowiadają produktowi źródłowemu.",
      "Przezroczysty master jest zapisany osobno od eksportów białych i lifestyle.",
      "Finalny crop, odstępy, tło i treść spełniają aktualne zasady marketplace."
    ],
    prosConsTitle: "Co rozwiązuje ten workflow",
    miralTitle: "Resztę zbuduj w Miral AI",
    miralP: "Gdy wycięcie przejdzie kontrolę, może trafić do poprawy obrazu lub nowej sceny komercyjnej. Dalej sprawdzaj tożsamość produktu — dopracowane tło nie pomoże, jeśli zmieni się kształt butelki, kolor buta lub etykieta opakowania.",
    miralLinksTitle: "Przydatne kolejne kroki",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "Ogólny przewodnik usuwania tła AI",
        path: "/hub/articles/ai-background-remover-online"
      },
      {
        label: "Seedream 5 zdjęcia produktów",
        path: "/image-models/seedream-ai-image-generator"
      },
      {
        label: "FLUX.2 fotografia produktowa",
        path: "/image-models/flux-2-ai-image-generator"
      },
      {
        label: "GPT Image plakaty tekstowe",
        path: "/image-models/gpt-image-ai-image-generator"
      }
    ],
    faqTitle: "Częste pytania e-commerce",
    faqItems: [
      [
        "Czy usuwanie tła produktu w Miral AI jest darmowe?",
        "Tak. Zaloguj się, aby korzystać z usuwania tła za darmo i pobierać przezroczysty PNG."
      ],
      [
        "Jak zrobić obraz Amazon z białym tłem?",
        "Usuń oryginalne tło, zachowaj przezroczysty PNG, umieść kopię na czysto białym płótnie i sprawdź aktualne wymagania dla dokładnej kategorii."
      ],
      [
        "Czy zdjęcia produktów Shopify muszą mieć białe tło?",
        "Niekoniecznie. Przezroczyste pliki są często przydatne dla tematycznych kart produktów i banerów, ale ostateczny wybór zależy od designu sklepu."
      ],
      [
        "Jaka jest różnica między przezroczystym a białym tłem produktu?",
        "Przezroczysty PNG nie ma stałego tła. Obraz z białym tłem już zawiera białe piksele i nie może odsłonić innego płótna pod spodem."
      ],
      [
        "Czy mogę przetworzyć cały katalog naraz?",
        "Obecna strona obsługuje jeden obraz na raz."
      ],
      [
        "Dlaczego szklany produkt wygląda niekompletnie?",
        "Szkło i przezroczyste opakowanie zawierają kolory starego tła. Spróbuj ostrzejszego źródła z wyraźniejszym kontrastem i ręcznie sprawdź przezroczyste obszary."
      ],
      [
        "Jak naprawić białą obwódkę wokół produktu?",
        "Zobacz PNG na ciemnym tle, aby potwierdzić obwódkę, a następnie spróbuj ponownie z ostrzejszym źródłem i silniejszym kontrastem wokół produktu."
      ],
      [
        "Jak powinienem zapisać przezroczysty obraz produktu?",
        "Zachowaj jeden przezroczysty master PNG bez stałego tła, a następnie eksportuj z niego osobne wersje białe, markowe i lifestyle."
      ],
      [
        "Czy mogę użyć jednego obrazu na każdym marketplace?",
        "Ponownie używaj przezroczystego mastera, ale eksportuj finalny crop, odstępy i tło osobno dla każdego kanału i kategorii."
      ],
      [
        "Czy mogę zamienić wycięcie w obraz lifestyle?",
        "Tak. Kontynuuj z przezroczystym PNG w Seedream lub FLUX i sprawdź, czy kształt, kolor, logo i opakowanie produktu pozostają dokładne."
      ]
    ]
  },
  linksTitle: "Zbuduj workflow obrazów produktowych w Miral AI",
  linksIntro: "Zachowaj jeden przezroczysty master produktu, a następnie kontynuuj w Miral AI z poprawą jakości, generowaniem scen komercyjnych lub projektem promocyjnym opartym na tekście.",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "Ogólny przewodnik usuwania tła AI",
      path: "/hub/articles/ai-background-remover-online"
    },
    {
      label: "Seedream 5 zdjęcia produktów",
      path: "/image-models/seedream-ai-image-generator"
    },
    {
      label: "FLUX.2 fotografia produktowa",
      path: "/image-models/flux-2-ai-image-generator"
    },
    {
      label: "GPT Image plakaty tekstowe",
      path: "/image-models/gpt-image-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "Wybierz wyraźne zdjęcie produktu",
      text: "Użyj JPG, PNG lub WebP do 15 MB z całym przedmiotem widocznym i w ostrości."
    },
    {
      title: "Usuń oryginalne tło",
      text: "Miral AI wykrywa produkt i automatycznie czyści całe tło bez ręcznej maski."
    },
    {
      title: "Sprawdź detale produktu",
      text: "Sprawdź wewnętrzne szczeliny, drobne elementy, przezroczyste sekcje, futro, szkło i odbijające krawędzie."
    },
    {
      title: "Zapisz przezroczysty master",
      text: "Pobierz PNG przed dodaniem tła lub layoutu specyficznego dla marketplace."
    },
    {
      title: "Utwórz wersję kanału",
      text: "Dodaj białe lub markowe płótno, a następnie sprawdź aktualne wymagania docelowego marketplace."
    }
  ],
  pros: [
    "Jeden przezroczysty master może obsłużyć wiele kanałów sprzedaży",
    "Automatyczne wykrywanie produktu oszczędza czas ręcznego obrysowywania",
    "Ułatwia standaryzację tła i odstępów w sklepach",
    "Wycięcie może kontynuować w scenach Seedream lub FLUX"
  ],
  cons: [
    "Wymagania marketplace nadal trzeba sprawdzić przed publikacją",
    "Szkło, futro, cienkie łańcuszki i materiały odbijające wymagają ręcznej kontroli",
    "Usuwanie tła nie wykonuje finalnego dopasowania rozmiaru i layoutu marketplace",
    "Obecne narzędzie przetwarza jeden obraz na raz"
  ],
  tips: [
    {
      title: "Oddziel usuwanie od layoutu",
      text: "Zachowaj przezroczysty master PNG, a następnie twórz pochodne z białym tłem i marką bez powtarzania wycinania."
    },
    {
      title: "Sprawdź trudne materiały",
      text: "Szkło, przezroczyste opakowanie, łańcuszki biżuterii, futro i odbijający metal to pierwsze miejsca do kontroli."
    },
    {
      title: "Sprawdź aktualne zasady marketplace",
      text: "Rozmiar obrazu, tło, kadrowanie i polityki treści mogą się zmieniać i różnić według kategorii."
    },
    {
      title: "Użyj checklisty akceptacji produktu",
      text: "Przed publikacją potwierdź kontur, wewnętrzne szczeliny, kolor, logo, tekst opakowania, porty, akcesoria i przezroczyste obszary."
    },
    {
      title: "Zachowaj jeden przezroczysty master",
      text: "Przechowuj sprawdzony przezroczysty PNG osobno i twórz z niego każdą wersję białą, markową i lifestyle."
    }
  ],
  scenarios: [
    {
      title: "Obrazy produktów Amazon z białym tłem",
      text: "Umieść sprawdzony przezroczysty PNG na czysto białym płótnie, a następnie zweryfikuj aktualne wymagania kategorii."
    },
    {
      title: "Karty produktów i banery Shopify",
      text: "Ponownie użyj przezroczystego produktu na responsywnych kartach, kolorach marki i kompozycjach strony głównej."
    },
    {
      title: "Obrazy listingu eBay i Etsy",
      text: "Zachowaj przedmiot kompletny i wierny oraz sprawdź krawędź pod kątem resztek tła przed uploadem."
    },
    {
      title: "Kreacje e-commerce cross-border",
      text: "Utwórz kilka rozmiarów kanałowych z jednego przezroczystego mastera PNG, zachowując prawdziwy kształt, kolor i branding produktu."
    },
    {
      title: "Reklamy produktów Google Shopping",
      text: "Dopasuj do produktu na stronie docelowej i twórz assety z przezroczystego mastera zgodnie z aktualnymi zasadami reklam."
    }
  ],
  toolFaq: [
    {
      q: "Czy usuwanie tła produktu e-commerce w Miral AI jest darmowe?",
      a: "Tak. Zaloguj się, aby korzystać z usuwania tła za darmo i pobierać przezroczysty PNG."
    },
    {
      q: "Jak zrobić obraz produktu Amazon z białym tłem?",
      a: "Usuń tło źródłowe, pobierz przezroczysty PNG, umieść go na czysto białym płótnie i sprawdź aktualne wymagania kategorii produktu."
    },
    {
      q: "Czy zdjęcie produktu Shopify musi mieć białe tło?",
      a: "Nie zawsze. Przezroczysty PNG jest przydatny dla kart i banerów w kolorze marki; wybierz finalne tło dla motywu i layoutu sklepu."
    },
    {
      q: "Jaka jest różnica między przezroczystym a białym tłem?",
      a: "Przezroczysty obraz nie ma stałego tła i może leżeć na dowolnym płótnie. Obraz z białym tłem zawiera białe piksele."
    },
    {
      q: "Czy mogę usunąć tło z całego katalogu produktów naraz?",
      a: "Obecna strona Background Remover przetwarza jeden obraz na raz, więc ten artykuł nie opisuje workflow wsadowego."
    },
    {
      q: "Dlaczego szklany produkt wygląda niekompletnie po usunięciu tła?",
      a: "Przezroczystość i odbicia trudno oddzielić. Spróbuj ponownie z ostrzejszym obrazem i silniejszym kontrastem, a następnie ręcznie sprawdź wynik."
    },
    {
      q: "Jak naprawić białą aureolę wokół wycięcia produktu?",
      a: "Umieść przezroczysty PNG na ciemnym tle, aby zlokalizować aureolę, a następnie spróbuj ponownie z źródłem o wyższej rozdzielczości i silniejszym kontraście krawędzi."
    },
    {
      q: "Co sprawdzić przed publikacją wycięcia produktu?",
      a: "Sprawdź w pełnym rozmiarze kontur, otwory, łańcuszki, sznurówki, przezroczystość, kolor, logo, tekst opakowania, porty i dołączone akcesoria."
    },
    {
      q: "Czy ten sam obraz produktu można użyć na każdym marketplace?",
      a: "Ponownie używaj przezroczystego mastera PNG, ale twórz finalne rozmiary, kadrowanie, odstępy i tła dla każdego marketplace i aktualnej polityki kategorii."
    },
    {
      q: "Czy mogę zamienić wycięcie w lifestyle zdjęcie produktu?",
      a: "Tak. Kontynuuj z przezroczystym PNG w Seedream lub FLUX i sprawdź, czy struktura, kolor i branding produktu pozostają dokładne."
    }
  ]
}

var plArticles = {
  "ai-background-remover-online": {
    title: "Darmowe usuwanie tła AI do tworzenia przezroczystych PNG online",
    excerpt: "Usuń tło z obrazu za darmo: prześlij JPG, PNG lub WebP, pozwól AI wykryć obiekt i pobierz przezroczysty PNG.",
    metaTitle: "Darmowy AI Background Remover online | Miral",
    metaDescription: "Korzystaj za darmo z Miral AI Background Remover po zalogowaniu, aby automatycznie usuwać tło ze zdjęć i eksportować przezroczyste wycięcia PNG.",
    target: {
      label: "Otwórz usuwanie tła",
      path: "/tools/background-remover"
    }
  },
  "ecommerce-product-background-removal": {
    title: "Darmowy AI Background Remover produktów dla obrazów e-commerce",
    excerpt: "Usuń tło produktu za darmo i twórz przezroczyste PNG lub obrazy z białym tłem dla Amazon, Shopify, eBay i Etsy.",
    metaTitle: "Darmowy AI Background Remover produktów e-commerce | Miral",
    metaDescription: "Korzystaj za darmo z Miral AI po zalogowaniu, aby usuwać tło produktu, eksportować przezroczyste PNG i przygotowywać obrazy e-commerce z białym tłem.",
    target: {
      label: "Otwórz usuwanie tła produktu",
      path: "/tools/background-remover"
    }
  }
}

var arBg = {
  overview: [
    "Miral AI Background Remover مجاني بعد تسجيل الدخول. يحلّل الصورة كاملة، يفصل الموضوع في المقدمة عن المحيط، ويزيل الخلفية تلقائياً دون قناع مرسوم يدوياً.",
    "ارفع صورة JPG أو PNG أو WebP حتى 15 MB، افحص الشعر والمواد الشفافة والثقوب الصغيرة والحواف منخفضة التباين، ثم نزّل النتيجة كـ PNG شفاف.",
    "يمكن أن يبقى PNG الشفاف في سير عمل Miral AI للتحسين أو تنظيف الكائنات أو مشهد منتج جديد. الخلفية الشفافة ليست مثل الخلفية البيضاء: أضف طبقة بيضاء لاحقاً عندما يطلب السوق ذلك تحديداً."
  ],
  practice: [
    "أكثر مصدر موثوق به يحتوي على موضوع كامل وحواف حادة وتباين واضح بين المقدمة والخلفية. لقطات الشاشة المعاد ضغطها وضبابية الحركة تجعل فصل التفاصيل الدقيقة أصعب.",
    "أراجع كل نتيجة على خلفية داكنة وخلفية فاتحة. ذلك يكشف الهالات البيضاء والحواف الداكنة والفجوات الفائتة والخصل المحذوفة التي قد تكون غير مرئية في المعاينة الافتراضية."
  ],
  compareIntro: "استخدم AI Background Remover عندما يجب أن تختفي الخلفية بالكامل تلقائياً. استخدم Watermark Remover أو Object Remover عندما تحتاج فقط إلى إزالة علامة أو كائن غير مرغوب فيه.",
  workflow: "ارفع صورة JPG أو PNG أو WebP واحدة حتى 15 MB، دع الذكاء الاصطناعي يكتشف المقدمة تلقائياً، راجع الحواف الدقيقة، ونزّل PNG الشفاف.",
  scenarioIntro: "اختر السيناريو الأقرب إلى صورتك الأصلية، ثم راجع تفاصيل الحافة المكتشفة تلقائياً الأهم لذلك الموضوع.",
  sec: {
    tldrTitle: "الإجابة المختصرة",
    tldrCols: [
      "ما يجب معرفته",
      "التفاصيل"
    ],
    tldrRows: [
      [
        "السعر",
        "مجاني بعد تسجيل الدخول"
      ],
      [
        "الرفع",
        "صورة JPG أو PNG أو WebP واحدة حتى 15 MB"
      ],
      [
        "المعالجة",
        "اكتشاف تلقائي للموضوع؛ لا حاجة لرسم حدود أو قناع"
      ],
      [
        "التنزيل",
        "PNG شفاف"
      ],
      [
        "يستحق الفحص",
        "الشعر والزجاج والفراء والفجوات الدقيقة والحواف منخفضة التباين"
      ]
    ],
    tldrP: "لصورة شخصية أو منتج مباشرة، المهمة عادةً مجرد رفع وانتظار وفحص وتنزيل. الفحص مهم: قد يبدو القص جيداً في معاينة صغيرة ويظهر مع ذلك حافة باهتة عند وضعه على تصميم داكن.",
    whatTitle: "ما الذي يفعله أداة إزالة الخلفية فعلياً",
    whatP1: "Miral AI Background Remover يقرأ الصورة كاملة ويقرر أي البكسلات تنتمي إلى المقدمة. ذلك أسرع بكثير من تتبع الموضوع بأداة القلم، كما أنه لا توجد خطوة تحديد يجب ضبطها قبل المعالجة.",
    whatP2: "النتيجة PNG بشفافية، وليس JPG مطلياً بالأبيض. يمكنك وضع ذلك الملف على بطاقة منتج بيضاء أو لون العلامة التجارية أو مشهد جديد تماماً دون قص الموضوع مرة أخرى.",
    whatTipTitle: "تمييز مفيد",
    whatTipText: "الشفافية والأبيض ليسا متبادلين. الشفافية تترك اللوحة مفتوحة؛ الخلفية البيضاء تملأها ببكسلات بيضاء بشكل دائم.",
    howTitle: "سير عمل بسيط من أربع خطوات",
    howP: "ابدأ بالملف الأصلي إن كان متوفراً. لقطات الشاشة المرسلة عبر تطبيقات المراسلة تميل إلى حواف أكثر نعومة، مما يجعل فصل الشعر الرقيق والمواد الشفافة أصعب.",
    edgeTitle: "أين أنظر قبل التنزيل",
    edgeCols: [
      "الصورة",
      "انظر عن كثب إلى",
      "السبب"
    ],
    edgeRows: [
      [
        "صورة شخصية",
        "الشعر المنسدل والنظارات والأقراط",
        "التفاصيل الرقيقة يسهل قصها"
      ],
      [
        "منتج",
        "المقابض والثقوب والأسلاك ورباطات الحذاء",
        "قد تبقى الخلفية داخل الفجوات المغلقة"
      ],
      [
        "زجاج أو تغليف شفاف",
        "الانعكاسات والحواف شبه الشفافة",
        "الخلفية الأصلية تظهر عبر الكائن"
      ],
      [
        "شعار أو توقيع",
        "الخطوط الرفيعة والمساحات الداخلية",
        "قد تُغلق الفجوات الصغيرة"
      ],
      [
        "حيوان أليف",
        "الفراء والشوارب",
        "الصورة المصغرة قد تخفي خصل مفقودة"
      ]
    ],
    edgeP: "أحب وضع PNG المنزّل على لوحة فاتحة ولوحة داكنة. هذا الفحص السريع يكشف الهالات الباهتة والحواف الداكنة وهو أكثر موثوقية من الحكم على معاينة الشطرنج وحدها.",
    bgTitle: "شفاف أم أبيض أم خلفية مستبدلة؟",
    bgCols: [
      "النتيجة",
      "ما تحتويه",
      "الأفضل لـ"
    ],
    bgRows: [
      [
        "خلفية شفافة",
        "لا لون خلفية ثابت؛ محفوظة كـ PNG",
        "الشعارات وصور الملف الشخصي وأصول التصميم وقصات المنتج القابلة لإعادة الاستخدام"
      ],
      [
        "خلفية بيضاء",
        "طبقة بيضاء تحت القص",
        "قوائم المنتجات وصور الهوية والتخطيطات التي تتطلب الأبيض"
      ],
      [
        "خلفية بلون العلامة",
        "لون صلب أو تدرج تحت الموضوع",
        "رسومات الحملات وبطاقات الملف الشخصي ومرئيات العلامة"
      ],
      [
        "مشهد جديد",
        "القص موضوعاً في بيئة أخرى",
        "صور أسلوب حياة للمنتجات والتركيبات الإبداعية"
      ]
    ],
    bgP: "أحتفظ أولاً بـ PNG الشفاف وأصنع النسخ البيضاء أو الملونة لاحقاً. JPG لا يمكنه تخزين بكسلات شفافة، لذا فهو خيار ضعيف لملف master القابل لإعادة الاستخدام.",
    troubleTitle: "إذا بدا القص خاطئاً",
    troubleCols: [
      "المشكلة",
      "السبب المحتمل",
      "ما يمكن تجربته"
    ],
    troubleRows: [
      [
        "حافة بيضاء أو داكنة",
        "لون الخلفية القديمة يبقى على الحافة",
        "أعد المحاولة بمصدر أوضح وتباين أقوى"
      ],
      [
        "اختفاء الشعر أو الشوارب",
        "المصدر صغير أو ضبابي أو مضغوط بشدة",
        "استخدم الصورة الأصلية وافحص بالحجم الكامل"
      ],
      [
        "بقاء الخلفية في مقبض",
        "فُهمت فجوة مغلقة كجزء من الموضوع",
        "جرّب زاوية أوضح مع فجوة أكثر وضوحاً"
      ],
      [
        "الزجاج يبدو ناقصاً",
        "الشفافية تحتوي ألواناً من المشهد القديم",
        "استخدم خلفية أنظف وراجع النتيجة يدوياً"
      ],
      [
        "اختفاء حواف أبيض على أبيض",
        "المقدمة والخلفية متشابهان جداً",
        "اختر صورة بتباين أكبر"
      ]
    ],
    prosConsTitle: "أين يساعد — وأين لا يزال يحتاج إلى حكم",
    bestTitle: "عادات تحسّن النتيجة",
    bestItems: [
      "استخدم الصورة الأصلية بدلاً من صورة مصغرة محفوظة من تطبيق دردشة.",
      "اختر صورة يكون فيها الموضوع كاملاً وواضحاً.",
      "إذا اندمج الموضوع مع الخلفية، جرّب صورة أخرى بتباين أوضح.",
      "راجع PNG على لوحة فاتحة وداكنة قبل الاستخدام.",
      "افحص المنتجات البيضاء على لوحة داكنة؛ البقايا أسهل بكثير في الرؤية هناك.",
      "تعامل مع الصور المهمة واحدة تلو الأخرى حتى تحصل كل حافة على مراجعة مناسبة."
    ],
    miralTitle: "تابع العمل في Miral AI",
    miralP: "بمجرد اختفاء الخلفية، يصبح PNG الشفاف ملف master مفيداً. يمكنك تحسين حدته، إزالة كائن زائد، تنظيف علامة مائية لديك إذن بإزالتها، أو تحويل المنتج إلى مشهد تجاري جديد.",
    miralLinksTitle: "خطوات تالية مفيدة",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "AI Object Remover",
        path: "/tools/object-remover"
      },
      {
        label: "AI Watermark Remover",
        path: "/tools/watermark-remover"
      },
      {
        label: "دليل خلفية منتجات التجارة الإلكترونية",
        path: "/hub/articles/ecommerce-product-background-removal"
      },
      {
        label: "Seedream 5",
        path: "/image-models/seedream-ai-image-generator"
      }
    ],
    faqTitle: "أسئلة تطرأ في الممارسة",
    faqItems: [
      [
        "كيف أجعل خلفية الصورة شفافة عبر الإنترنت؟",
        "ارفع صورة JPG أو PNG أو WebP، انتظر إزالة الخلفية تلقائياً، ونزّل PNG الشفاف."
      ],
      [
        "هل Miral AI Background Remover مجاني؟",
        "نعم. سجّل الدخول، ارفع صورة، واستخدم ميزة إزالة الخلفية مجاناً. لا حاجة لتثبيت برنامج سطح مكتب إضافي."
      ],
      [
        "هل أحتاج إلى تسجيل الدخول؟",
        "نعم. سجّل الدخول قبل الرفع، لكن ميزة إزالة الخلفية نفسها مجانية."
      ],
      [
        "هل يجب أن أرسم حدود الموضوع؟",
        "لا. الأداة تكتشف المقدمة تلقائياً عبر الصورة كاملة."
      ],
      [
        "لماذا يكون التنزيل بصيغة PNG؟",
        "PNG يمكنه الاحتفاظ ببكسلات شفافة. JPG لا يمكنه ذلك."
      ],
      [
        "هل تغيّر إزالة الخلفية أبعاد الصورة؟",
        "تحقق من أبعاد البكسل المنزّلة مقابل التخطيط النهائي قبل النشر، خاصة عندما يكون للسوق أو القالب حجم ثابت."
      ],
      [
        "كيف أصلح هالة بيضاء حول القص؟",
        "اعرض PNG على لوحة داكنة، ثم أعد المحاولة بمصدر أوضح وتباين أقوى حول الموضوع."
      ],
      [
        "هل يمكنه التعامل مع الشعر وفراء الحيوانات؟",
        "نعم، لكن الخصل الرفيعة تستحق فحصاً بالحجم الكامل على خلفية فاتحة وداكنة."
      ],
      [
        "ما الفرق بين إزالة الخلفية بالذكاء الاصطناعي وممحاة الخلفية؟",
        "إزالة الخلفية بالذكاء الاصطناعي تجد الموضوع تلقائياً. ممحاة الخلفية التقليدية عادةً تطلب إزالة المناطق يدوياً."
      ],
      [
        "لماذا يختفي موضوع أبيض على خلفية بيضاء؟",
        "الحافة لديها تباين ضئيل جداً. صورة بخلفية أغمق أو أكثر تميزاً تعطي النموذج حداً أوضح."
      ],
      [
        "لماذا يختفي جزء من منتجي الزجاجي؟",
        "الزجاج يعكس وينقل الخلفية القديمة، لذا يكون الحد غامضاً. صورة أوضح على خلفية متباينة تعطي النموذج نقطة بداية أفضل."
      ],
      [
        "ماذا يمكنني رفعه؟",
        "صور JPG وPNG وWebP حتى 15 MB لكل منها. الصفحة تعالج صورة واحدة في كل مرة."
      ]
    ]
  },
  linksTitle: "تابع سير العمل في Miral AI",
  linksIntro: "بعد إزالة الخلفية، استخدم PNG الشفاف في أدوات Miral AI الأخرى أو تابع بدليل مركّز للخطوة التالية.",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "AI Object Remover",
      path: "/tools/object-remover"
    },
    {
      label: "AI Watermark Remover",
      path: "/tools/watermark-remover"
    },
    {
      label: "دليل خلفية منتجات التجارة الإلكترونية",
      path: "/hub/articles/ecommerce-product-background-removal"
    },
    {
      label: "Seedream 5",
      path: "/image-models/seedream-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "ارفع الصورة الأصلية",
      text: "اختر ملف JPG أو PNG أو WebP لا يتجاوز 15 MB."
    },
    {
      title: "دع الذكاء الاصطناعي يجد الموضوع",
      text: "Miral يزيل الخلفية كاملة تلقائياً؛ لا حاجة لرسم حدود أو قناع."
    },
    {
      title: "افحص الحواف الصعبة",
      text: "كبّر الشعر والنظارات والمواد الشفافة وثقوب المنتج وتفاصيل أخرى دقيقة."
    },
    {
      title: "نزّل PNG الشفاف",
      text: "احفظ النتيجة كقص قابل لإعادة الاستخدام، ثم ضعه على اللوحة النهائية."
    }
  ],
  pros: [
    "اكتشاف تلقائي للموضوع دون رسم حدود يدوي",
    "يدعم إدخال JPG وPNG وWebP",
    "ينزّل PNG شفافاً قابلاً لإعادة الاستخدام",
    "مفيد للصور الشخصية والمنتجات والشعارات والتوقيعات والحيوانات"
  ],
  cons: [
    "الشعر والكائنات الشفافة لا تزال تحتاج مراجعة بصرية",
    "التباين المنخفض بين الموضوع والخلفية قد يقلل جودة الحافة",
    "الصفحة الحالية تعالج صورة واحدة في كل مرة",
    "الملفات الأكبر من 15 MB يجب تصغيرها أولاً"
  ],
  tips: [
    {
      title: "افحص لونين للخلفية",
      text: "ضع PNG الشفاف على خلفيات داكنة وفاتحة لكشف الهالات والحواف المفقودة."
    },
    {
      title: "استخدم أوضح مصدر",
      text: "الأصل الأكبر والأوضح عادةً يعمل أفضل من لقطة شاشة صغيرة مضغوطة عدة مرات."
    },
    {
      title: "احمِ التفاصيل الدقيقة",
      text: "كبّر الشعر والشوارب وسلاسل المجوهرات ورباطات الحذاء والنظارات والفجوات داخل مقابض المنتج."
    },
    {
      title: "أصلح الهالات البيضاء أو الداكنة",
      text: "الهالة غالباً تأتي من تلوث لوني على الحافة الأصلية. أعد المحاولة بمصدر أوضح وتباين أقوى بين المقدمة والخلفية."
    },
    {
      title: "راجع المواد الشفافة",
      text: "الزجاج والتغليف الشفاف يظهران الخلفية القديمة عبر الكائن، لذا قارن النتيجة على لوحات بيضاء وداكنة."
    }
  ],
  scenarios: [
    {
      title: "إزالة خلفية صورة شخصية",
      text: "افحص الشعر المنسدل والأقراط والنظارات قبل استخدام القص في صورة ملف شخصي أو ملصق."
    },
    {
      title: "إزالة خلفية منتج",
      text: "افحص المقابض والثقوب والأسلاك والحواف العاكسة والتغليف الشفاف."
    },
    {
      title: "إزالة خلفية شعار أو توقيع",
      text: "استخدم مصدراً عالي الدقة حتى تبقى الخطوط الرفيعة والقصات الداخلية سليمة."
    },
    {
      title: "إزالة خلفية صورة حيوان",
      text: "اختر خلفية بسيطة بتباين قوي وافحص الفراء والشوارب بالحجم الكامل."
    }
  ],
  toolFaq: [
    {
      q: "كيف أزيل خلفية صورة عبر الإنترنت؟",
      a: "ارفع صورة JPG أو PNG أو WebP، دع الذكاء الاصطناعي يكتشف ويزيل الخلفية تلقائياً، ثم نزّل PNG الشفاف."
    },
    {
      q: "هل أحتاج لتحديد الشخص أو المنتج يدوياً؟",
      a: "لا. Background Remover يحلّل الصورة كاملة ويكتشف المقدمة تلقائياً."
    },
    {
      q: "لماذا تُنزَّل النتيجة كـ PNG؟",
      a: "PNG يدعم الشفافية. JPG لا يمكنه الحفاظ على خلفية شفافة."
    },
    {
      q: "كيف أصلح هالة بيضاء بعد إزالة الخلفية؟",
      a: "افحص النتيجة على لوحة داكنة أولاً، ثم أعد المحاولة بمصدر أوضح وتباين أوضح بين الموضوع والخلفية."
    },
    {
      q: "هل يمكن للذكاء الاصطناعي إزالة الخلفية حول الشعر أو فراء الحيوان؟",
      a: "نعم، لكن الشعر الرفيع والشوارب والفراء حواف صعبة ويجب دائماً مراجعتها بالحجم الكامل."
    },
    {
      q: "ما الفرق بين خلفية شفافة وبيضاء ومستبدلة؟",
      a: "PNG الشفاف ليس له خلفية ثابتة. صورة بخلفية بيضاء تحتوي بكسلات بيضاء، بينما الخلفية المستبدلة تضع القص في مشهد أو لون جديد."
    },
    {
      q: "لماذا تختفي أجزاء من كائن زجاجي؟",
      a: "الكائنات الشفافة تحتوي ألواناً من الخلفية الأصلية. أعد المحاولة بمصدر أوضح وأعلى تباين وراجع الشفافية يدوياً."
    },
    {
      q: "هل أحتاج لتسجيل الدخول لاستخدام Background Remover؟",
      a: "نعم. سجّل الدخول قبل رفع ومعالجة الصورة."
    },
    {
      q: "هل Miral AI Background Remover مجاني؟",
      a: "نعم. ميزة إزالة الخلفية مجانية بعد تسجيل الدخول، دون برنامج إضافي للتثبيت."
    },
    {
      q: "ما الصيغ وأحجام الملفات المدعومة؟",
      a: "الأداة تقبل صور JPG وPNG وWebP حتى 15 MB لكل منها."
    }
  ]
}

var arEcom = {
  overview: [
    "لعمل التجارة الإلكترونية، Miral AI Background Remover مجاني بعد تسجيل الدخول. أنشئ master PNG شفافاً نظيفاً واحداً، ثم أنتج نسخاً بخلفية بيضاء ولون العلامة ولافتات وأسلوب حياة من نفس القص.",
    "Miral AI Background Remover يكتشف المنتج تلقائياً بعد رفع صورة JPG أو PNG أو WebP حتى 15 MB. لا توجد خطوة قناع يدوي. قبل النشر، افحص المقابض والسلاسل والرباطات والتغليف الشفاف والزجاج والفراء والمعدن العاكس.",
    "Amazon وShopify وeBay وEtsy وGoogle Shopping وقنوات أخرى قد يكون لها قواعد صور مختلفة ومتغيرة. إزالة الخلفية تجهّز الأصل، لكنها لا تضمن تلقائياً الامتثال للسوق؛ تحقق من المتطلبات الحالية للقناة والفئة المحددة."
  ],
  practice: [
    "سير العمل المفضل لدي هو صورة المنتج الأصلية، إزالة الخلفية تلقائياً، مراجعة الحواف، master PNG شفاف، ثم فقط بعد ذلك تخطيط خاص بالقناة. هذا يتجنب تكرار عمل القص لكل واجهة متجر.",
    "لصورة بيضاء خالصة، ضع PNG الشفاف على لوحة بيضاء. لبانرات Shopify أو إعلانات التواصل، أعد استخدام نفس القص على لون العلامة أو تابع في Seedream أو FLUX لمشهد أسلوب حياة."
  ],
  compareIntro: "استخدم Background Remover لإنشاء master المنتج الشفاف، ثم أضف لوحة بيضاء لقوائم السوق أو تابع في Seedream وFLUX لصور أسلوب الحياة.",
  workflow: "ارفع صورة منتج واضحة واحدة حتى 15 MB، دع الذكاء الاصطناعي يزيل الخلفية كاملة تلقائياً، راجع حواف المنتج، ونزّل master PNG الشفاف.",
  scenarioIntro: "اختر سيناريو التجارة الإلكترونية الأقرب لمنتجك، ثم افحص حافة المنتج المكتشفة تلقائياً قبل إنشاء كل تخطيط خاص بالقناة.",
  sec: {
    tldrTitle: "سير العمل الذي أوصي به",
    tldrCols: [
      "المرحلة",
      "احتفظ بـ",
      "افحص"
    ],
    tldrRows: [
      [
        "أزل الخلفية",
        "master PNG شفاف",
        "الحواف والثقوب والأجزاء الدقيقة والمواد الشفافة"
      ],
      [
        "أنشئ نسخة بيضاء",
        "تصدير مسطح منفصل",
        "التباعد وقواعد السوق الحالية"
      ],
      [
        "أنشئ نسخ العلامة",
        "ملفات للبطاقات واللافتات والإعلانات",
        "لون المنتج والشكل والشعار ونص التغليف"
      ],
      [
        "أرشف master",
        "PNG الشفاف المراجع",
        "لا تستبدله بخلفية خاصة بقناة"
      ]
    ],
    tldrP: "Miral AI Background Remover مجاني بعد تسجيل الدخول. أزيل الخلفية مرة واحدة، أحتفظ بذلك master الشفاف، وأبني كل نسخة بيضاء أو للعلامة أو أسلوب حياة منه. ذلك أنظف من قص نفس المنتج مجدداً لكل واجهة متجر.",
    workflowTitle: "من الصورة الأصلية إلى قص منتج قابل لإعادة الاستخدام",
    workflowP1: "اختر صورة يكون فيها المنتج كاملاً وواضحاً. ارفعها إلى Miral AI Background Remover، دع الأداة تجد المنتج تلقائياً، ثم افحص النتيجة قبل تنزيل PNG.",
    workflowP2: "الجزء الأخير يسهل تخطيه. افحص المقابض والمنافذ والرباطات والسلاسل والتغليف الشفاف وأي فجوة يجب أن تظهر منها الخلفية القديمة. هذه التفاصيل تحدد ما إذا كانت الصورة ما زالت مقنعة على لوحة جديدة.",
    transTitle: "لماذا أحتفظ بالنسخة الشفافة أولاً",
    transP: "PNG الشفاف هو الأصل المرن. يمكن أن يوضع اليوم على لوحة سوق بيضاء خالصة، وغداً على بطاقة علامة Shopify، والشهر القادم على لافتة موسمية. إذا حفظت النسخة البيضاء فقط، كل خلفية جديدة تبدأ بمرور تنظيف آخر.",
    transTipTitle: "أبقِ الطبقات منفصلة",
    transTipText: "أرشف master الشفاف وصدّر نسخ القنوات كملفات منفصلة. ذلك يجعل المراجعات أقل إيلاماً بكثير.",
    platTitle: "master واحد، واجهات متاجر مختلفة",
    platCols: [
      "القناة",
      "الاستخدام المعتاد",
      "ملاحظة عملية"
    ],
    platRows: [
      [
        "Amazon",
        "الصور الرئيسية والمساندة للمنتج",
        "أضف الأبيض فقط عند الطلب، ثم تحقق من سياسة الفئة الحالية"
      ],
      [
        "Shopify",
        "بطاقات المنتج وصفحات المجموعات واللافتات",
        "الشفافية تعمل جيداً مع ألوان القالب والتخطيطات المتجاوبة"
      ],
      [
        "eBay",
        "غلاف القائمة وصور المعرض",
        "ابحث عن بقايا حول محيط المنتج"
      ],
      [
        "Etsy",
        "أغلفة المنتجات اليدوية ولقطات التفاصيل",
        "حافظ على صدق المواد والتفاصيل اليدوية"
      ],
      [
        "Google Shopping",
        "أصول إعلانات المنتج",
        "طابق المنتج المعروض على صفحة الهبوط وتحقق من قواعد الإعلان الحالية"
      ]
    ],
    platP: "قواعد الأسواق تتغير، وقد تختلف الفئات داخل نفس السوق. إزالة الخلفية تجهّز الملف؛ لا تصدّق على الصورة النهائية لقائمة معينة.",
    qualityTitle: "المنتجات الأسهل في الخطأ",
    qualityItems: [
      "الزجاج والكريستال والتغليف الشفاف قد تفقد مناطقها الشفافة.",
      "سلاسل المجوهرات ورباطات الحذاء والشبكة قد تنكسر إلى قطع منفصلة.",
      "المنتجات البيضاء على أبيض والداكنة على داكن لديها تباين حافة ضعيف.",
      "الصوف الخفيف والفراء والمنسوجات الناعمة تحتاج فحصاً على خلفيات فاتحة وداكنة.",
      "المعدن العاكس قد يحتفظ بألوان من المحيط الأصلي."
    ],
    casesTitle: "المنتجات التي تحتاج نظرة أدق",
    casesCols: [
      "المنتج",
      "الفشل الشائع",
      "المراجعة"
    ],
    casesRows: [
      [
        "الملابس والأحذية",
        "اختفاء القماش المتآكل أو الرباطات أو الشبكة",
        "تابع المحيط وكل تقاطع رباط"
      ],
      [
        "المجوهرات",
        "انكسار السلاسل أو امتلاء الفتحات الصغيرة",
        "كبّر الحلقات والمشابك والخطافات والمساحة السالبة"
      ],
      [
        "الزجاج والتغليف الشفاف",
        "تصبح المناطق الشفافة صلبة أو ناقصة",
        "افحص على خلفيات بيضاء وداكنة"
      ],
      [
        "تغليف التجميل",
        "فقدان تفاصيل فجوات المضخة والزجاجات الشفافة",
        "احمِ الملصقات وحواف الغطاء ولون المنتج الحقيقي"
      ],
      [
        "الإلكترونيات",
        "تغيّر المنافذ والكابلات والحواف العاكسة",
        "أكّد كل جزء وموصل مُرفق"
      ],
      [
        "الأثاث",
        "بقاء المساحة بين الأرجل مملوءة",
        "افحص الفجوات الداخلية بعناية مثل الحافة الخارجية"
      ]
    ],
    acceptTitle: "فحصي قبل النشر",
    acceptItems: [
      "لا هالة باهتة ولا حافة داكنة ولا حافة متعرجة ولا بقعة من الخلفية القديمة.",
      "المقابض والثقوب والسلاسل والرباطات والشبكة والمساحات الداخلية الأخرى مفتوحة حيث ينبغي.",
      "الزجاج والبلاستيك الشفاف والفراء والمعدن العاكس ما زالت تبدو كالمادة الحقيقية.",
      "اللون والشعار ونص التغليف والمنافذ والملحقات تطابق المنتج الأصلي.",
      "master الشفاف محفوظ منفصلاً عن تصديرات النسخ البيضاء وأسلوب الحياة.",
      "القص النهائي والتباعد والخلفية والمحتوى يتبعون قواعد السوق الحالية."
    ],
    prosConsTitle: "ما الذي يحلّه هذا السير",
    miralTitle: "ابنِ الباقي في Miral AI",
    miralP: "بعد اجتياز القص للمراجعة، يمكن أن ينتقل إلى تحسين الصورة أو مشهد تجاري جديد. استمر في التحقق من هوية المنتج؛ خلفية مصقولة لا تفيد إذا تغيّر شكل الزجاجة أو لون الحذاء أو ملصق العبوة.",
    miralLinksTitle: "خطوات تالية مفيدة",
    miralLinks: [
      {
        label: "Miral AI Background Remover",
        path: "/tools/background-remover"
      },
      {
        label: "AI Image Enhancer",
        path: "/tools/image-enhancer"
      },
      {
        label: "دليل إزالة الخلفية بالذكاء الاصطناعي العام",
        path: "/hub/articles/ai-background-remover-online"
      },
      {
        label: "Seedream 5 صور المنتج",
        path: "/image-models/seedream-ai-image-generator"
      },
      {
        label: "FLUX.2 تصوير المنتج",
        path: "/image-models/flux-2-ai-image-generator"
      },
      {
        label: "GPT Image ملصقات نصية",
        path: "/image-models/gpt-image-ai-image-generator"
      }
    ],
    faqTitle: "أسئلة التجارة الإلكترونية الشائعة",
    faqItems: [
      [
        "هل إزالة خلفية المنتج مجانية في Miral AI؟",
        "نعم. سجّل الدخول لاستخدام أداة إزالة الخلفية مجاناً وتنزيل PNG الشفاف."
      ],
      [
        "كيف أصنع صورة Amazon بخلفية بيضاء؟",
        "أزل الخلفية الأصلية، احتفظ بـ PNG الشفاف، ضع نسخة على لوحة بيضاء خالصة، ثم تحقق من المتطلبات الحالية للفئة المحددة."
      ],
      [
        "هل صور منتجات Shopify تحتاج خلفية بيضاء؟",
        "ليس بالضرورة. الملفات الشفافة مفيدة غالباً لبطاقات المنتج واللافتات المخصصة، لكن الاختيار النهائي يعتمد على تصميم المتجر."
      ],
      [
        "ما الفرق بين خلفية منتج شفافة وبيضاء؟",
        "PNG الشفاف ليس له خلفية ثابتة. صورة بخلفية بيضاء تحتوي بالفعل بكسلات بيضاء ولا يمكنها إظهار لوحة أخرى تحتها."
      ],
      [
        "هل يمكنني معالجة جميع صور المنتجات دفعة واحدة؟",
        "الصفحة الحالية تعالج صورة واحدة في كل مرة."
      ],
      [
        "لماذا يبدو منتج زجاجي ناقصاً؟",
        "الزجاج والتغليف الشفاف يحتويان ألواناً من الخلفية القديمة. جرّب مصدراً أوضح بتباين أوضح وراجع المناطق الشفافة يدوياً."
      ],
      [
        "كيف أصلح حافة بيضاء حول المنتج؟",
        "اعرض PNG على لوحة داكنة لتأكيد الحافة، ثم أعد المحاولة بمصدر أوضح وتباين أقوى حول المنتج."
      ],
      [
        "كيف يجب أن أحفظ صورة المنتج الشفافة؟",
        "احتفظ بـ master PNG شفاف واحد دون خلفية ثابتة، ثم صدّر نسخاً بيضاء وللعلامة وأسلوب حياة منفصلة منه."
      ],
      [
        "هل يمكنني إعادة استخدام صورة واحدة على كل سوق؟",
        "أعد استخدام master الشفاف، لكن صدّر القص النهائي والتباعد والخلفية بشكل منفصل لكل قناة وفئة."
      ],
      [
        "هل يمكنني تحويل القص إلى صورة أسلوب حياة؟",
        "نعم. تابع بـ PNG الشفاف في Seedream أو FLUX، ثم تحقق من بقاء شكل المنتج ولونه وشعاره وتغليفه دقيقاً."
      ]
    ]
  },
  linksTitle: "ابنِ سير عمل صور المنتج في Miral AI",
  linksIntro: "احتفظ بـ master منتج شفاف واحد، ثم تابع في Miral AI بالتحسين أو توليد مشهد تجاري أو تصميم ترويجي قائم على النص.",
  links: [
    {
      label: "Miral AI Background Remover",
      path: "/tools/background-remover"
    },
    {
      label: "AI Image Enhancer",
      path: "/tools/image-enhancer"
    },
    {
      label: "دليل إزالة الخلفية بالذكاء الاصطناعي العام",
      path: "/hub/articles/ai-background-remover-online"
    },
    {
      label: "Seedream 5 صور المنتج",
      path: "/image-models/seedream-ai-image-generator"
    },
    {
      label: "FLUX.2 تصوير المنتج",
      path: "/image-models/flux-2-ai-image-generator"
    },
    {
      label: "GPT Image ملصقات نصية",
      path: "/image-models/gpt-image-ai-image-generator"
    }
  ],
  steps: [
    {
      title: "اختر صورة منتج واضحة",
      text: "استخدم JPG أو PNG أو WebP حتى 15 MB مع ظهور المنتج كاملاً وواضحاً."
    },
    {
      title: "أزل الخلفية الأصلية",
      text: "Miral AI يكتشف المنتج ويمسح الخلفية كاملة تلقائياً دون قناع يدوي."
    },
    {
      title: "افحص تفاصيل المنتج",
      text: "افحص الفجوات الداخلية والأجزاء الدقيقة والأقسام الشفافة والفراء والزجاج والحواف العاكسة."
    },
    {
      title: "احفظ master الشفاف",
      text: "نزّل PNG قبل إضافة خلفية أو تخطيط خاص بالسوق."
    },
    {
      title: "أنشئ نسخة القناة",
      text: "أضف لوحة بيضاء أو بلون العلامة، ثم تحقق من المتطلبات الحالية لسوق الوجهة."
    }
  ],
  pros: [
    "master شفاف واحد يمكن أن يخدم عدة قنوات بيع",
    "اكتشاف المنتج التلقائي يوفر وقت الرسم اليدوي",
    "يسهّل توحيد خلفيات المتجر والتباعد",
    "يمكن للقص أن يتابع في مشاهد Seedream أو FLUX"
  ],
  cons: [
    "متطلبات السوق لا تزال يجب التحقق منها قبل النشر",
    "الزجاج والفراء والسلاسل الرفيعة والمواد العاكسة تحتاج مراجعة يدوية",
    "إزالة الخلفية لا تنفّذ الحجم والتخطيط النهائي للسوق",
    "الأداة الحالية تعالج صورة واحدة في كل مرة"
  ],
  tips: [
    {
      title: "افصل الإزالة عن التخطيط",
      text: "احتفظ بـ master PNG الشفاف، ثم أنشئ مشتقات بخلفية بيضاء وللعلامة دون تكرار القص."
    },
    {
      title: "افحص المواد الصعبة",
      text: "الزجاج والتغليف الشفاف وسلاسل المجوهرات والفراء والمعدن العاكس هي أول أماكن للفحص."
    },
    {
      title: "تحقق من قواعد السوق الحالية",
      text: "حجم الصورة والخلفية والإطار وسياسات المحتوى قد تتغير وتختلف حسب الفئة."
    },
    {
      title: "استخدم قائمة قبول المنتج",
      text: "أكّد المحيط والفجوات الداخلية واللون والشعار ونص التغليف والمنافذ والملحقات والمناطق الشفافة قبل النشر."
    },
    {
      title: "احتفظ بـ master شفاف واحد",
      text: "خزّن PNG الشفاف المراجع منفصلاً، ثم اشتق منه كل نسخة بيضاء وللعلامة وأسلوب حياة."
    }
  ],
  scenarios: [
    {
      title: "صور منتج Amazon بخلفية بيضاء",
      text: "ضع PNG الشفاف المراجع على لوحة بيضاء خالصة، ثم تحقق من متطلبات الفئة الحالية."
    },
    {
      title: "بطاقات منتج Shopify ولافتات",
      text: "أعد استخدام المنتج الشفاف على بطاقات متجاوبة وألوان العلامة وتركيبات الصفحة الرئيسية."
    },
    {
      title: "صور قوائم eBay وEtsy",
      text: "حافظ على المنتج كاملاً وصادقاً، وافحص الحافة بحثاً عن بقايا خلفية قبل الرفع."
    },
    {
      title: "إبداع تجارة إلكترونية عابرة للحدود",
      text: "أنشئ عدة أحجام قنوات من master PNG شفاف واحد مع الحفاظ على شكل المنتج ولونه وعلامته الحقيقية."
    },
    {
      title: "إعلانات منتج Google Shopping",
      text: "طابق المنتج في صفحة الهبوط وأنشئ الأصول من master الشفاف وفق قواعد الإعلان الحالية."
    }
  ],
  toolFaq: [
    {
      q: "هل إزالة خلفية منتجات التجارة الإلكترونية مجانية في Miral AI؟",
      a: "نعم. سجّل الدخول لاستخدام ميزة إزالة الخلفية مجاناً وتنزيل PNG الشفاف."
    },
    {
      q: "كيف أصنع صورة منتج Amazon بخلفية بيضاء؟",
      a: "أزل الخلفية الأصلية، نزّل PNG الشفاف، ضعه على لوحة بيضاء خالصة، وتحقق من المتطلبات الحالية لفئة المنتج."
    },
    {
      q: "هل يجب أن تستخدم صورة منتج Shopify خلفية بيضاء؟",
      a: "ليس دائماً. PNG الشفاف مفيد لبطاقات ولافتات بلون العلامة؛ اختر الخلفية النهائية لقالب المتجر وتخطيطه."
    },
    {
      q: "ما الفرق بين الخلفيات الشفافة والبيضاء؟",
      a: "الصورة الشفافة ليس لها خلفية ثابتة ويمكن وضعها على أي لوحة. صورة بخلفية بيضاء تحتوي بكسلات بيضاء."
    },
    {
      q: "هل يمكنني إزالة خلفيات جميع صور المنتجات دفعة واحدة؟",
      a: "صفحة Background Remover الحالية تعالج صورة واحدة في كل مرة، لذا لا يدّعي هذا المقال سير عمل دفعي."
    },
    {
      q: "لماذا يبدو منتج زجاجي ناقصاً بعد إزالة الخلفية؟",
      a: "الشفافية والانعكاسات صعبة الفصل. أعد المحاولة بصورة أوضح وتباين أقوى، ثم راجع النتيجة يدوياً."
    },
    {
      q: "كيف أصلح هالة بيضاء حول قص منتج؟",
      a: "ضع PNG الشفاف على لوحة داكنة لتحديد الهالة، ثم أعد المحاولة بمصدر أعلى دقة وتباين حافة أقوى."
    },
    {
      q: "ما الذي يجب فحصه قبل نشر قص منتج؟",
      a: "افحص بالحجم الكامل المحيط والثقوب والسلاسل والرباطات والشفافية واللون والشعار ونص التغليف والمنافذ والملحقات المرفقة."
    },
    {
      q: "هل يمكن استخدام نفس صورة المنتج على كل سوق؟",
      a: "أعد استخدام master PNG الشفاف، لكن أنشئ الأحجام النهائية والإطار والتباعد والخلفيات لكل سوق وسياسة فئة حالية."
    },
    {
      q: "هل يمكنني تحويل القص إلى صورة منتج أسلوب حياة؟",
      a: "نعم. تابع بـ PNG الشفاف في Seedream أو FLUX، وتحقق من بقاء بنية المنتج ولونه وعلامته دقيقة."
    }
  ]
}

var arArticles = {
  "ai-background-remover-online": {
    title: "أداة مجانية لإزالة الخلفية بالذكاء الاصطناعي وإنشاء PNG شفاف عبر الإنترنت",
    excerpt: "أزل خلفية الصورة مجاناً: ارفع JPG أو PNG أو WebP، دع الذكاء الاصطناعي يكتشف الموضوع ونزّل PNG شفاف.",
    metaTitle: "أداة إزالة الخلفية بالذكاء الاصطناعي مجاناً عبر الإنترنت | Miral",
    metaDescription: "استخدم Miral AI Background Remover مجاناً بعد تسجيل الدخول لإزالة خلفية الصور تلقائياً وتصدير قصات PNG شفافة.",
    target: {
      label: "افتح أداة إزالة الخلفية",
      path: "/tools/background-remover"
    }
  },
  "ecommerce-product-background-removal": {
    title: "أداة إزالة خلفية المنتج بالذكاء الاصطناعي مجاناً لصور التجارة الإلكترونية",
    excerpt: "أزل خلفية المنتج مجاناً وأنشئ PNG شفاف أو صور بخلفية بيضاء لـ Amazon وShopify وeBay وEtsy.",
    metaTitle: "أداة إزالة خلفية منتجات التجارة الإلكترونية مجاناً | Miral",
    metaDescription: "استخدم Miral AI مجاناً بعد تسجيل الدخول لإزالة خلفية المنتج وتصدير PNG شفاف وإعداد صور التجارة الإلكترونية بخلفية بيضاء.",
    target: {
      label: "افتح أداة إزالة خلفية المنتج",
      path: "/tools/background-remover"
    }
  }
}

module.exports = {
  ja: buildLocale(jaBg, jaEcom, jaArticles, 'ja'),
  ko: buildLocale(koBg, koEcom, koArticles, 'ko'),
  fr: buildLocale(frBg, frEcom, frArticles, 'fr'),
  es: buildLocale(esBg, esEcom, esArticles, 'es'),
  it: buildLocale(itBg, itEcom, itArticles, 'it'),
  de: buildLocale(deBg, deEcom, deArticles, 'de'),
  pt: buildLocale(ptBg, ptEcom, ptArticles, 'pt'),
  pl: buildLocale(plBg, plEcom, plArticles, 'pl'),
  ar: buildLocale(arBg, arEcom, arArticles, 'ar')
}
